// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%238ddece%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%2317a98c%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/BANNER.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/*!
* Start Bootstrap - Freelancer v7.0.7 (https://startbootstrap.com/theme/freelancer)
* Copyright 2013-2023 Start Bootstrap
* Licensed under MIT (https://github.com/StartBootstrap/startbootstrap-freelancer/blob/master/LICENSE)
*/
/*!
 * Bootstrap  v5.2.3 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
    --bs-blue: #0d6efd;
    --bs-indigo: #6610f2;
    --bs-purple: #6f42c1;
    --bs-pink: #d63384;
    --bs-red: #dc3545;
    --bs-orange: #fd7e14;
    --bs-yellow: #ffc107;
    --bs-green: #198754;
    --bs-teal: #0085CA;
    --bs-cyan: #0dcaf0;
    --bs-black: #000;
    --bs-white: #fff;
    --bs-gray: #6c757d;
    --bs-gray-dark: #343a40;
    --bs-gray-100: #f8f9fa;
    --bs-gray-200: #e9ecef;
    --bs-gray-300: #dee2e6;
    --bs-gray-400: #ced4da;
    --bs-gray-500: #adb5bd;
    --bs-gray-600: #6c757d;
    --bs-gray-700: #495057;
    --bs-gray-800: #343a40;
    --bs-gray-900: #212529;
    --bs-primary: #0085CA;
    --bs-secondary: #0085CA;
    --bs-success: #0085CA;
    --bs-info: #0dcaf0;
    --bs-warning: #ffc107;
    --bs-danger: #dc3545;
    --bs-light: #f8f9fa;
    --bs-dark: #212529;
    --bs-primary-rgb: 26, 188, 156;
    --bs-secondary-rgb: 44, 62, 80;
    --bs-success-rgb: 25, 135, 84;
    --bs-info-rgb: 13, 202, 240;
    --bs-warning-rgb: 255, 193, 7;
    --bs-danger-rgb: 220, 53, 69;
    --bs-light-rgb: 248, 249, 250;
    --bs-dark-rgb: 33, 37, 41;
    --bs-white-rgb: 255, 255, 255;
    --bs-black-rgb: 0, 0, 0;
    --bs-body-color-rgb: 33, 37, 41;
    --bs-body-bg-rgb: 255, 255, 255;
    --bs-font-sans-serif: "Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
    --bs-body-font-family: var(--bs-font-sans-serif);
    --bs-body-font-size: 1rem;
    --bs-body-font-weight: 400;
    --bs-body-line-height: 1.5;
    --bs-body-color: #212529;
    --bs-body-bg: #fff;
    --bs-border-width: 0.125rem;
    --bs-border-style: solid;
    --bs-border-color: #dee2e6;
    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
    --bs-border-radius: 0.5rem;
    --bs-border-radius-sm: 0.25rem;
    --bs-border-radius-lg: 0.75rem;
    --bs-border-radius-xl: 1rem;
    --bs-border-radius-2xl: 2rem;
    --bs-border-radius-pill: 50rem;
    --bs-link-color: #ffffff;
    --bs-link-hover-color: #15967d;
    --bs-code-color: #d63384;
    --bs-highlight-bg: #fff3cd;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
    :root {
        scroll-behavior: smooth;
    }
}

body {
    margin: 0;
    font-family: var(--bs-body-font-family);
    font-size: var(--bs-body-font-size);
    font-weight: var(--bs-body-font-weight);
    line-height: var(--bs-body-line-height);
    color: var(--bs-body-color);
    text-align: var(--bs-body-text-align);
    background-color: var(--bs-body-bg);
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
    margin: 1rem 0;
    color: inherit;
    border: 0;
    border-top: 0.125rem solid;
    opacity: 0.25;
}

h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: 700;
    line-height: 1.2;
}

h1,
.h1 {
    font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {

    h1,
    .h1 {
        font-size: 2.5rem;
    }
}

h2,
.h2 {
    font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {

    h2,
    .h2 {
        font-size: 2rem;
    }
}

h3,
.h3 {
    font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {

    h3,
    .h3 {
        font-size: 1.75rem;
    }
}

h4,
.h4 {
    font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {

    h4,
    .h4 {
        font-size: 1.5rem;
    }
}

h5,
.h5 {
    font-size: 1.25rem;
}

h6,
.h6 {
    font-size: 1rem;
}

p {
    margin-top: 0;
    margin-bottom: 1rem;
}

abbr[title] {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    text-decoration-skip-ink: none;
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
}

ol,
ul {
    padding-left: 2rem;
}

ol,
ul,
dl {
    margin-top: 0;
    margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
    margin-bottom: 0;
}

dt {
    font-weight: 700;
}

dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
}

blockquote {
    margin: 0 0 1rem;
}

b,
strong {
    font-weight: bolder;
}

small,
.small {
    font-size: 0.875em;
}

mark,
.mark {
    padding: 0.1875em;
    background-color: var(--bs-highlight-bg);
}

sub,
sup {
    position: relative;
    font-size: 0.75em;
    line-height: 0;
    vertical-align: baseline;
}

sub {
    bottom: -0.25em;
}

sup {
    top: -0.5em;
}

a {
    color: var(--bs-link-color);
    text-decoration: underline;
}

a:hover {
    color: var(--bs-link-hover-color);
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none;
}

pre,
code,
kbd,
samp {
    font-family: var(--bs-font-monospace);
    font-size: 1em;
}

pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: 0.875em;
}

pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal;
}

code {
    font-size: 0.875em;
    color: var(--bs-code-color);
    word-wrap: break-word;
}

a>code {
    color: inherit;
}

kbd {
    padding: 0.1875rem 0.375rem;
    font-size: 0.875em;
    color: var(--bs-body-bg);
    background-color: var(--bs-body-color);
    border-radius: 0.25rem;
}

kbd kbd {
    padding: 0;
    font-size: 1em;
}

figure {
    margin: 0 0 1rem;
}

img,
svg {
    vertical-align: middle;
}

table {
    caption-side: bottom;
    border-collapse: collapse;
}

caption {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: #6c757d;
    text-align: left;
}

th {
    text-align: inherit;
    text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
}

label {
    display: inline-block;
}

button {
    border-radius: 0;
}

button:focus:not(:focus-visible) {
    outline: 0;
}

input,
button,
select,
optgroup,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

button,
select {
    text-transform: none;
}

[role=button] {
    cursor: pointer;
}

select {
    word-wrap: normal;
}

select:disabled {
    opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
    display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
    -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
    cursor: pointer;
}

::-moz-focus-inner {
    padding: 0;
    border-style: none;
}

textarea {
    resize: vertical;
}

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
}

legend {
    float: left;
    width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: calc(1.275rem + 0.3vw);
    line-height: inherit;
}

@media (min-width: 1200px) {
    legend {
        font-size: 1.5rem;
    }
}

legend+* {
    clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
    padding: 0;
}

::-webkit-inner-spin-button {
    height: auto;
}

[type=search] {
    outline-offset: -2px;
    -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
    -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
    padding: 0;
}

::file-selector-button {
    font: inherit;
    -webkit-appearance: button;
}

output {
    display: inline-block;
}

iframe {
    border: 0;
}

summary {
    display: list-item;
    cursor: pointer;
}

progress {
    vertical-align: baseline;
}

[hidden] {
    display: none !important;
}

.lead {
    font-size: 1.25rem;
    font-weight: 300;
}

.display-1 {
    font-size: calc(1.625rem + 4.5vw);
    font-weight: 300;
    line-height: 1.2;
}

@media (min-width: 1200px) {
    .display-1 {
        font-size: 5rem;
    }
}

.display-2 {
    font-size: calc(1.575rem + 3.9vw);
    font-weight: 300;
    line-height: 1.2;
}

@media (min-width: 1200px) {
    .display-2 {
        font-size: 4.5rem;
    }
}

.display-3 {
    font-size: calc(1.525rem + 3.3vw);
    font-weight: 300;
    line-height: 1.2;
}

@media (min-width: 1200px) {
    .display-3 {
        font-size: 4rem;
    }
}

.display-4 {
    font-size: calc(1.475rem + 2.7vw);
    font-weight: 300;
    line-height: 1.2;
}

@media (min-width: 1200px) {
    .display-4 {
        font-size: 3.5rem;
    }
}

.display-5 {
    font-size: calc(1.425rem + 2.1vw);
    font-weight: 300;
    line-height: 1.2;
}

@media (min-width: 1200px) {
    .display-5 {
        font-size: 3rem;
    }
}

.display-6 {
    font-size: calc(1.375rem + 1.5vw);
    font-weight: 300;
    line-height: 1.2;
}

@media (min-width: 1200px) {
    .display-6 {
        font-size: 2.5rem;
    }
}

.list-unstyled {
    padding-left: 0;
    list-style: none;
}

.list-inline {
    padding-left: 0;
    list-style: none;
}

.list-inline-item {
    display: inline-block;
}

.list-inline-item:not(:last-child) {
    margin-right: 0.5rem;
}

.initialism {
    font-size: 0.875em;
    text-transform: uppercase;
}

.blockquote {
    margin-bottom: 1rem;
    font-size: 1.25rem;
}

.blockquote> :last-child {
    margin-bottom: 0;
}

.blockquote-footer {
    margin-top: -1rem;
    margin-bottom: 1rem;
    font-size: 0.875em;
    color: #6c757d;
}

.blockquote-footer::before {
    content: "— ";
}

.img-fluid {
    max-width: 100%;
    height: auto;
}

.img-thumbnail {
    padding: 0.25rem;
    background-color: #fff;
    border: 0.125rem solid var(--bs-border-color);
    border-radius: 0.5rem;
    max-width: 100%;
    height: auto;
}

.figure {
    display: inline-block;
}

.figure-img {
    margin-bottom: 0.5rem;
    line-height: 1;
}

.figure-caption {
    font-size: 0.875em;
    color: #6c757d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-right: auto;
    margin-left: auto;
}

@media (min-width: 576px) {

    .container-sm,
    .container {
        max-width: 540px;
    }
}

@media (min-width: 768px) {

    .container-md,
    .container-sm,
    .container {
        max-width: 720px;
    }
}

@media (min-width: 992px) {

    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {

    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 1140px;
    }
}

@media (min-width: 1400px) {

    .container-xxl,
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container {
        max-width: 1320px;
    }
}

.row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
    margin-right: calc(-0.5 * var(--bs-gutter-x));
    margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row>* {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-top: var(--bs-gutter-y);
}

.col {
    flex: 1 0;
}

.row-cols-auto>* {
    flex: 0 0 auto;
    width: auto;
}

.row-cols-1>* {
    flex: 0 0 auto;
    width: 100%;
}

.row-cols-2>* {
    flex: 0 0 auto;
    width: 50%;
}

.row-cols-3>* {
    flex: 0 0 auto;
    width: 33.3333333333%;
}

.row-cols-4>* {
    flex: 0 0 auto;
    width: 25%;
}

.row-cols-5>* {
    flex: 0 0 auto;
    width: 20%;
}

.row-cols-6>* {
    flex: 0 0 auto;
    width: 16.6666666667%;
}

.col-auto {
    flex: 0 0 auto;
    width: auto;
}

.col-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
}

.col-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
}

.col-3 {
    flex: 0 0 auto;
    width: 25%;
}

.col-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
}

.col-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
}

.col-6 {
    flex: 0 0 auto;
    width: 50%;
}

.col-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
}

.col-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
}

.col-9 {
    flex: 0 0 auto;
    width: 75%;
}

.col-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
}

.col-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
}

.col-12 {
    flex: 0 0 auto;
    width: 100%;
}

.offset-1 {
    margin-left: 8.33333333%;
}

.offset-2 {
    margin-left: 16.66666667%;
}

.offset-3 {
    margin-left: 25%;
}

.offset-4 {
    margin-left: 33.33333333%;
}

.offset-5 {
    margin-left: 41.66666667%;
}

.offset-6 {
    margin-left: 50%;
}

.offset-7 {
    margin-left: 58.33333333%;
}

.offset-8 {
    margin-left: 66.66666667%;
}

.offset-9 {
    margin-left: 75%;
}

.offset-10 {
    margin-left: 83.33333333%;
}

.offset-11 {
    margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
    --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
    --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
    --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
    --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
    --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
    --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
    --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
    --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
    --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
    --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
    --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
    --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
    .col-sm {
        flex: 1 0;
    }

    .row-cols-sm-auto>* {
        flex: 0 0 auto;
        width: auto;
    }

    .row-cols-sm-1>* {
        flex: 0 0 auto;
        width: 100%;
    }

    .row-cols-sm-2>* {
        flex: 0 0 auto;
        width: 50%;
    }

    .row-cols-sm-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%;
    }

    .row-cols-sm-4>* {
        flex: 0 0 auto;
        width: 25%;
    }

    .row-cols-sm-5>* {
        flex: 0 0 auto;
        width: 20%;
    }

    .row-cols-sm-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%;
    }

    .col-sm-auto {
        flex: 0 0 auto;
        width: auto;
    }

    .col-sm-1 {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    .col-sm-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-sm-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .col-sm-4 {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .col-sm-5 {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    .col-sm-6 {
        flex: 0 0 auto;
        width: 50%;
    }

    .col-sm-7 {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    .col-sm-8 {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .col-sm-9 {
        flex: 0 0 auto;
        width: 75%;
    }

    .col-sm-10 {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    .col-sm-11 {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    .col-sm-12 {
        flex: 0 0 auto;
        width: 100%;
    }

    .offset-sm-0 {
        margin-left: 0;
    }

    .offset-sm-1 {
        margin-left: 8.33333333%;
    }

    .offset-sm-2 {
        margin-left: 16.66666667%;
    }

    .offset-sm-3 {
        margin-left: 25%;
    }

    .offset-sm-4 {
        margin-left: 33.33333333%;
    }

    .offset-sm-5 {
        margin-left: 41.66666667%;
    }

    .offset-sm-6 {
        margin-left: 50%;
    }

    .offset-sm-7 {
        margin-left: 58.33333333%;
    }

    .offset-sm-8 {
        margin-left: 66.66666667%;
    }

    .offset-sm-9 {
        margin-left: 75%;
    }

    .offset-sm-10 {
        margin-left: 83.33333333%;
    }

    .offset-sm-11 {
        margin-left: 91.66666667%;
    }

    .g-sm-0,
    .gx-sm-0 {
        --bs-gutter-x: 0;
    }

    .g-sm-0,
    .gy-sm-0 {
        --bs-gutter-y: 0;
    }

    .g-sm-1,
    .gx-sm-1 {
        --bs-gutter-x: 0.25rem;
    }

    .g-sm-1,
    .gy-sm-1 {
        --bs-gutter-y: 0.25rem;
    }

    .g-sm-2,
    .gx-sm-2 {
        --bs-gutter-x: 0.5rem;
    }

    .g-sm-2,
    .gy-sm-2 {
        --bs-gutter-y: 0.5rem;
    }

    .g-sm-3,
    .gx-sm-3 {
        --bs-gutter-x: 1rem;
    }

    .g-sm-3,
    .gy-sm-3 {
        --bs-gutter-y: 1rem;
    }

    .g-sm-4,
    .gx-sm-4 {
        --bs-gutter-x: 1.5rem;
    }

    .g-sm-4,
    .gy-sm-4 {
        --bs-gutter-y: 1.5rem;
    }

    .g-sm-5,
    .gx-sm-5 {
        --bs-gutter-x: 3rem;
    }

    .g-sm-5,
    .gy-sm-5 {
        --bs-gutter-y: 3rem;
    }
}

@media (min-width: 768px) {
    .col-md {
        flex: 1 0;
    }

    .row-cols-md-auto>* {
        flex: 0 0 auto;
        width: auto;
    }

    .row-cols-md-1>* {
        flex: 0 0 auto;
        width: 100%;
    }

    .row-cols-md-2>* {
        flex: 0 0 auto;
        width: 50%;
    }

    .row-cols-md-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%;
    }

    .row-cols-md-4>* {
        flex: 0 0 auto;
        width: 25%;
    }

    .row-cols-md-5>* {
        flex: 0 0 auto;
        width: 20%;
    }

    .row-cols-md-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%;
    }

    .col-md-auto {
        flex: 0 0 auto;
        width: auto;
    }

    .col-md-1 {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    .col-md-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-md-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .col-md-4 {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .col-md-5 {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    .col-md-6 {
        flex: 0 0 auto;
        width: 50%;
    }

    .col-md-7 {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    .col-md-8 {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .col-md-9 {
        flex: 0 0 auto;
        width: 75%;
    }

    .col-md-10 {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    .col-md-11 {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    .col-md-12 {
        flex: 0 0 auto;
        width: 100%;
    }

    .offset-md-0 {
        margin-left: 0;
    }

    .offset-md-1 {
        margin-left: 8.33333333%;
    }

    .offset-md-2 {
        margin-left: 16.66666667%;
    }

    .offset-md-3 {
        margin-left: 25%;
    }

    .offset-md-4 {
        margin-left: 33.33333333%;
    }

    .offset-md-5 {
        margin-left: 41.66666667%;
    }

    .offset-md-6 {
        margin-left: 50%;
    }

    .offset-md-7 {
        margin-left: 58.33333333%;
    }

    .offset-md-8 {
        margin-left: 66.66666667%;
    }

    .offset-md-9 {
        margin-left: 75%;
    }

    .offset-md-10 {
        margin-left: 83.33333333%;
    }

    .offset-md-11 {
        margin-left: 91.66666667%;
    }

    .g-md-0,
    .gx-md-0 {
        --bs-gutter-x: 0;
    }

    .g-md-0,
    .gy-md-0 {
        --bs-gutter-y: 0;
    }

    .g-md-1,
    .gx-md-1 {
        --bs-gutter-x: 0.25rem;
    }

    .g-md-1,
    .gy-md-1 {
        --bs-gutter-y: 0.25rem;
    }

    .g-md-2,
    .gx-md-2 {
        --bs-gutter-x: 0.5rem;
    }

    .g-md-2,
    .gy-md-2 {
        --bs-gutter-y: 0.5rem;
    }

    .g-md-3,
    .gx-md-3 {
        --bs-gutter-x: 1rem;
    }

    .g-md-3,
    .gy-md-3 {
        --bs-gutter-y: 1rem;
    }

    .g-md-4,
    .gx-md-4 {
        --bs-gutter-x: 1.5rem;
    }

    .g-md-4,
    .gy-md-4 {
        --bs-gutter-y: 1.5rem;
    }

    .g-md-5,
    .gx-md-5 {
        --bs-gutter-x: 3rem;
    }

    .g-md-5,
    .gy-md-5 {
        --bs-gutter-y: 3rem;
    }
}

@media (min-width: 992px) {
    .col-lg {
        flex: 1 0;
    }

    .row-cols-lg-auto>* {
        flex: 0 0 auto;
        width: auto;
    }

    .row-cols-lg-1>* {
        flex: 0 0 auto;
        width: 100%;
    }

    .row-cols-lg-2>* {
        flex: 0 0 auto;
        width: 50%;
    }

    .row-cols-lg-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%;
    }

    .row-cols-lg-4>* {
        flex: 0 0 auto;
        width: 25%;
    }

    .row-cols-lg-5>* {
        flex: 0 0 auto;
        width: 20%;
    }

    .row-cols-lg-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%;
    }

    .col-lg-auto {
        flex: 0 0 auto;
        width: auto;
    }

    .col-lg-1 {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    .col-lg-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-lg-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .col-lg-4 {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .col-lg-5 {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    .col-lg-6 {
        flex: 0 0 auto;
        width: 50%;
    }

    .col-lg-7 {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    .col-lg-8 {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .col-lg-9 {
        flex: 0 0 auto;
        width: 75%;
    }

    .col-lg-10 {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    .col-lg-11 {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    .col-lg-12 {
        flex: 0 0 auto;
        width: 100%;
    }

    .offset-lg-0 {
        margin-left: 0;
    }

    .offset-lg-1 {
        margin-left: 8.33333333%;
    }

    .offset-lg-2 {
        margin-left: 16.66666667%;
    }

    .offset-lg-3 {
        margin-left: 25%;
    }

    .offset-lg-4 {
        margin-left: 33.33333333%;
    }

    .offset-lg-5 {
        margin-left: 41.66666667%;
    }

    .offset-lg-6 {
        margin-left: 50%;
    }

    .offset-lg-7 {
        margin-left: 58.33333333%;
    }

    .offset-lg-8 {
        margin-left: 66.66666667%;
    }

    .offset-lg-9 {
        margin-left: 75%;
    }

    .offset-lg-10 {
        margin-left: 83.33333333%;
    }

    .offset-lg-11 {
        margin-left: 91.66666667%;
    }

    .g-lg-0,
    .gx-lg-0 {
        --bs-gutter-x: 0;
    }

    .g-lg-0,
    .gy-lg-0 {
        --bs-gutter-y: 0;
    }

    .g-lg-1,
    .gx-lg-1 {
        --bs-gutter-x: 0.25rem;
    }

    .g-lg-1,
    .gy-lg-1 {
        --bs-gutter-y: 0.25rem;
    }

    .g-lg-2,
    .gx-lg-2 {
        --bs-gutter-x: 0.5rem;
    }

    .g-lg-2,
    .gy-lg-2 {
        --bs-gutter-y: 0.5rem;
    }

    .g-lg-3,
    .gx-lg-3 {
        --bs-gutter-x: 1rem;
    }

    .g-lg-3,
    .gy-lg-3 {
        --bs-gutter-y: 1rem;
    }

    .g-lg-4,
    .gx-lg-4 {
        --bs-gutter-x: 1.5rem;
    }

    .g-lg-4,
    .gy-lg-4 {
        --bs-gutter-y: 1.5rem;
    }

    .g-lg-5,
    .gx-lg-5 {
        --bs-gutter-x: 3rem;
    }

    .g-lg-5,
    .gy-lg-5 {
        --bs-gutter-y: 3rem;
    }
}

@media (min-width: 1200px) {
    .col-xl {
        flex: 1 0;
    }

    .row-cols-xl-auto>* {
        flex: 0 0 auto;
        width: auto;
    }

    .row-cols-xl-1>* {
        flex: 0 0 auto;
        width: 100%;
    }

    .row-cols-xl-2>* {
        flex: 0 0 auto;
        width: 50%;
    }

    .row-cols-xl-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%;
    }

    .row-cols-xl-4>* {
        flex: 0 0 auto;
        width: 25%;
    }

    .row-cols-xl-5>* {
        flex: 0 0 auto;
        width: 20%;
    }

    .row-cols-xl-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%;
    }

    .col-xl-auto {
        flex: 0 0 auto;
        width: auto;
    }

    .col-xl-1 {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    .col-xl-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-xl-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .col-xl-4 {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .col-xl-5 {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    .col-xl-6 {
        flex: 0 0 auto;
        width: 50%;
    }

    .col-xl-7 {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    .col-xl-8 {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .col-xl-9 {
        flex: 0 0 auto;
        width: 75%;
    }

    .col-xl-10 {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    .col-xl-11 {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    .col-xl-12 {
        flex: 0 0 auto;
        width: 100%;
    }

    .offset-xl-0 {
        margin-left: 0;
    }

    .offset-xl-1 {
        margin-left: 8.33333333%;
    }

    .offset-xl-2 {
        margin-left: 16.66666667%;
    }

    .offset-xl-3 {
        margin-left: 25%;
    }

    .offset-xl-4 {
        margin-left: 33.33333333%;
    }

    .offset-xl-5 {
        margin-left: 41.66666667%;
    }

    .offset-xl-6 {
        margin-left: 50%;
    }

    .offset-xl-7 {
        margin-left: 58.33333333%;
    }

    .offset-xl-8 {
        margin-left: 66.66666667%;
    }

    .offset-xl-9 {
        margin-left: 75%;
    }

    .offset-xl-10 {
        margin-left: 83.33333333%;
    }

    .offset-xl-11 {
        margin-left: 91.66666667%;
    }

    .g-xl-0,
    .gx-xl-0 {
        --bs-gutter-x: 0;
    }

    .g-xl-0,
    .gy-xl-0 {
        --bs-gutter-y: 0;
    }

    .g-xl-1,
    .gx-xl-1 {
        --bs-gutter-x: 0.25rem;
    }

    .g-xl-1,
    .gy-xl-1 {
        --bs-gutter-y: 0.25rem;
    }

    .g-xl-2,
    .gx-xl-2 {
        --bs-gutter-x: 0.5rem;
    }

    .g-xl-2,
    .gy-xl-2 {
        --bs-gutter-y: 0.5rem;
    }

    .g-xl-3,
    .gx-xl-3 {
        --bs-gutter-x: 1rem;
    }

    .g-xl-3,
    .gy-xl-3 {
        --bs-gutter-y: 1rem;
    }

    .g-xl-4,
    .gx-xl-4 {
        --bs-gutter-x: 1.5rem;
    }

    .g-xl-4,
    .gy-xl-4 {
        --bs-gutter-y: 1.5rem;
    }

    .g-xl-5,
    .gx-xl-5 {
        --bs-gutter-x: 3rem;
    }

    .g-xl-5,
    .gy-xl-5 {
        --bs-gutter-y: 3rem;
    }
}

@media (min-width: 1400px) {
    .col-xxl {
        flex: 1 0;
    }

    .row-cols-xxl-auto>* {
        flex: 0 0 auto;
        width: auto;
    }

    .row-cols-xxl-1>* {
        flex: 0 0 auto;
        width: 100%;
    }

    .row-cols-xxl-2>* {
        flex: 0 0 auto;
        width: 50%;
    }

    .row-cols-xxl-3>* {
        flex: 0 0 auto;
        width: 33.3333333333%;
    }

    .row-cols-xxl-4>* {
        flex: 0 0 auto;
        width: 25%;
    }

    .row-cols-xxl-5>* {
        flex: 0 0 auto;
        width: 20%;
    }

    .row-cols-xxl-6>* {
        flex: 0 0 auto;
        width: 16.6666666667%;
    }

    .col-xxl-auto {
        flex: 0 0 auto;
        width: auto;
    }

    .col-xxl-1 {
        flex: 0 0 auto;
        width: 8.33333333%;
    }

    .col-xxl-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .col-xxl-3 {
        flex: 0 0 auto;
        width: 25%;
    }

    .col-xxl-4 {
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .col-xxl-5 {
        flex: 0 0 auto;
        width: 41.66666667%;
    }

    .col-xxl-6 {
        flex: 0 0 auto;
        width: 50%;
    }

    .col-xxl-7 {
        flex: 0 0 auto;
        width: 58.33333333%;
    }

    .col-xxl-8 {
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .col-xxl-9 {
        flex: 0 0 auto;
        width: 75%;
    }

    .col-xxl-10 {
        flex: 0 0 auto;
        width: 83.33333333%;
    }

    .col-xxl-11 {
        flex: 0 0 auto;
        width: 91.66666667%;
    }

    .col-xxl-12 {
        flex: 0 0 auto;
        width: 100%;
    }

    .offset-xxl-0 {
        margin-left: 0;
    }

    .offset-xxl-1 {
        margin-left: 8.33333333%;
    }

    .offset-xxl-2 {
        margin-left: 16.66666667%;
    }

    .offset-xxl-3 {
        margin-left: 25%;
    }

    .offset-xxl-4 {
        margin-left: 33.33333333%;
    }

    .offset-xxl-5 {
        margin-left: 41.66666667%;
    }

    .offset-xxl-6 {
        margin-left: 50%;
    }

    .offset-xxl-7 {
        margin-left: 58.33333333%;
    }

    .offset-xxl-8 {
        margin-left: 66.66666667%;
    }

    .offset-xxl-9 {
        margin-left: 75%;
    }

    .offset-xxl-10 {
        margin-left: 83.33333333%;
    }

    .offset-xxl-11 {
        margin-left: 91.66666667%;
    }

    .g-xxl-0,
    .gx-xxl-0 {
        --bs-gutter-x: 0;
    }

    .g-xxl-0,
    .gy-xxl-0 {
        --bs-gutter-y: 0;
    }

    .g-xxl-1,
    .gx-xxl-1 {
        --bs-gutter-x: 0.25rem;
    }

    .g-xxl-1,
    .gy-xxl-1 {
        --bs-gutter-y: 0.25rem;
    }

    .g-xxl-2,
    .gx-xxl-2 {
        --bs-gutter-x: 0.5rem;
    }

    .g-xxl-2,
    .gy-xxl-2 {
        --bs-gutter-y: 0.5rem;
    }

    .g-xxl-3,
    .gx-xxl-3 {
        --bs-gutter-x: 1rem;
    }

    .g-xxl-3,
    .gy-xxl-3 {
        --bs-gutter-y: 1rem;
    }

    .g-xxl-4,
    .gx-xxl-4 {
        --bs-gutter-x: 1.5rem;
    }

    .g-xxl-4,
    .gy-xxl-4 {
        --bs-gutter-y: 1.5rem;
    }

    .g-xxl-5,
    .gx-xxl-5 {
        --bs-gutter-x: 3rem;
    }

    .g-xxl-5,
    .gy-xxl-5 {
        --bs-gutter-y: 3rem;
    }
}

.table {
    --bs-table-color: var(--bs-body-color);
    --bs-table-bg: transparent;
    --bs-table-border-color: var(--bs-border-color);
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: var(--bs-body-color);
    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
    --bs-table-active-color: var(--bs-body-color);
    --bs-table-active-bg: rgba(0, 0, 0, 0.1);
    --bs-table-hover-color: var(--bs-body-color);
    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
    width: 100%;
    margin-bottom: 1rem;
    color: var(--bs-table-color);
    vertical-align: top;
    border-color: var(--bs-table-border-color);
}

.table> :not(caption)>*>* {
    padding: 0.5rem 0.5rem;
    background-color: var(--bs-table-bg);
    border-bottom-width: 0.125rem;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.table>tbody {
    vertical-align: inherit;
}

.table>thead {
    vertical-align: bottom;
}

.table-group-divider {
    border-top: 0.25rem solid currentcolor;
}

.caption-top {
    caption-side: top;
}

.table-sm> :not(caption)>*>* {
    padding: 0.25rem 0.25rem;
}

.table-bordered> :not(caption)>* {
    border-width: 0.125rem 0;
}

.table-bordered> :not(caption)>*>* {
    border-width: 0 0.125rem;
}

.table-borderless> :not(caption)>*>* {
    border-bottom-width: 0;
}

.table-borderless> :not(:first-child) {
    border-top-width: 0;
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
    --bs-table-accent-bg: var(--bs-table-striped-bg);
    color: var(--bs-table-striped-color);
}

.table-striped-columns> :not(caption)>tr> :nth-child(even) {
    --bs-table-accent-bg: var(--bs-table-striped-bg);
    color: var(--bs-table-striped-color);
}

.table-active {
    --bs-table-accent-bg: var(--bs-table-active-bg);
    color: var(--bs-table-active-color);
}

.table-hover>tbody>tr:hover>* {
    --bs-table-accent-bg: var(--bs-table-hover-bg);
    color: var(--bs-table-hover-color);
}

.table-primary {
    --bs-table-color: #000;
    --bs-table-bg: #d1f2eb;
    --bs-table-border-color: #bcdad4;
    --bs-table-striped-bg: #c7e6df;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #bcdad4;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #c1e0d9;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-secondary {
    --bs-table-color: #000;
    --bs-table-bg: #d5d8dc;
    --bs-table-border-color: #c0c2c6;
    --bs-table-striped-bg: #cacdd1;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #c0c2c6;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #c5c8cc;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-success {
    --bs-table-color: #000;
    --bs-table-bg: #d1e7dd;
    --bs-table-border-color: #bcd0c7;
    --bs-table-striped-bg: #c7dbd2;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #bcd0c7;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #c1d6cc;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-info {
    --bs-table-color: #000;
    --bs-table-bg: #cff4fc;
    --bs-table-border-color: #badce3;
    --bs-table-striped-bg: #c5e8ef;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #badce3;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #bfe2e9;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-warning {
    --bs-table-color: #000;
    --bs-table-bg: #fff3cd;
    --bs-table-border-color: #e6dbb9;
    --bs-table-striped-bg: #f2e7c3;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #e6dbb9;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #ece1be;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-danger {
    --bs-table-color: #000;
    --bs-table-bg: #f8d7da;
    --bs-table-border-color: #dfc2c4;
    --bs-table-striped-bg: #eccccf;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #dfc2c4;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #e5c7ca;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-light {
    --bs-table-color: #000;
    --bs-table-bg: #f8f9fa;
    --bs-table-border-color: #dfe0e1;
    --bs-table-striped-bg: #ecedee;
    --bs-table-striped-color: #000;
    --bs-table-active-bg: #dfe0e1;
    --bs-table-active-color: #000;
    --bs-table-hover-bg: #e5e6e7;
    --bs-table-hover-color: #000;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-dark {
    --bs-table-color: #fff;
    --bs-table-bg: #212529;
    --bs-table-border-color: #373b3e;
    --bs-table-striped-bg: #2c3034;
    --bs-table-striped-color: #fff;
    --bs-table-active-bg: #373b3e;
    --bs-table-active-color: #fff;
    --bs-table-hover-bg: #323539;
    --bs-table-hover-color: #fff;
    color: var(--bs-table-color);
    border-color: var(--bs-table-border-color);
}

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
    .table-responsive-sm {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

@media (max-width: 767.98px) {
    .table-responsive-md {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

@media (max-width: 991.98px) {
    .table-responsive-lg {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

@media (max-width: 1199.98px) {
    .table-responsive-xl {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

@media (max-width: 1399.98px) {
    .table-responsive-xxl {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

.form-label {
    margin-bottom: 0.5rem;
}

.col-form-label {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
}

.col-form-label-lg {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 1.25rem;
}

.col-form-label-sm {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    font-size: 0.875rem;
}

.form-text {
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #6c757d;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 0.125rem solid #ced4da;
    appearance: none;
    border-radius: 0.5rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .form-control {
        transition: none;
    }
}

.form-control[type=file] {
    overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
    cursor: pointer;
}

.form-control:focus {
    color: #212529;
    background-color: #fff;
    border-color: #8ddece;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
}

.form-control::-webkit-date-and-time-value {
    height: 1.5em;
}

.form-control::placeholder {
    color: #6c757d;
    opacity: 1;
}

.form-control:disabled {
    background-color: #e9ecef;
    opacity: 1;
}

.form-control::file-selector-button {
    padding: 0.375rem 0.75rem;
    margin: -0.375rem -0.75rem;
    margin-inline-end: 0.75rem;
    color: #212529;
    background-color: #e9ecef;
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 0.125rem;
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .form-control::file-selector-button {
        transition: none;
    }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: #dde0e3;
}

.form-control-plaintext {
    display: block;
    width: 100%;
    padding: 0.375rem 0;
    margin-bottom: 0;
    line-height: 1.5;
    color: #212529;
    background-color: transparent;
    border: solid transparent;
    border-width: 0.125rem 0;
}

.form-control-plaintext:focus {
    outline: 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0;
}

.form-control-sm {
    min-height: calc(1.5em + 0.75rem);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
}

.form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: 0.5rem;
}

.form-control-lg {
    min-height: calc(1.5em + 1.25rem);
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    border-radius: 0.75rem;
}

.form-control-lg::file-selector-button {
    padding: 0.5rem 1rem;
    margin: -0.5rem -1rem;
    margin-inline-end: 1rem;
}

textarea.form-control {
    min-height: calc(1.5em + 1rem);
}

textarea.form-control-sm {
    min-height: calc(1.5em + 0.75rem);
}

textarea.form-control-lg {
    min-height: calc(1.5em + 1.25rem);
}

.form-control-color {
    width: 3rem;
    height: calc(1.5em + 1rem);
    padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer;
}

.form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: 0.5rem;
}

.form-control-color::-webkit-color-swatch {
    border-radius: 0.5rem;
}

.form-control-color.form-control-sm {
    height: calc(1.5em + 0.75rem);
}

.form-control-color.form-control-lg {
    height: calc(1.5em + 1.25rem);
}

.form-select {
    display: block;
    width: 100%;
    padding: 0.375rem 2.25rem 0.375rem 0.75rem;
    -moz-padding-start: calc(0.75rem - 3px);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    border: 0.125rem solid #ced4da;
    border-radius: 0.5rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none;
}

@media (prefers-reduced-motion: reduce) {
    .form-select {
        transition: none;
    }
}

.form-select:focus {
    border-color: #8ddece;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
    padding-right: 0.75rem;
    background-image: none;
}

.form-select:disabled {
    background-color: #e9ecef;
}

.form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #212529;
}

.form-select-sm {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
}

.form-select-lg {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    font-size: 1.25rem;
    border-radius: 0.75rem;
}

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: 0.125rem;
}

.form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
}

.form-check-reverse {
    padding-right: 1.5em;
    padding-left: 0;
    text-align: right;
}

.form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.5em;
    margin-left: 0;
}

.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid rgba(0, 0, 0, 0.25);
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
    border-radius: 0.25em;
}

.form-check-input[type=radio] {
    border-radius: 50%;
}

.form-check-input:active {
    filter: brightness(90%);
}

.form-check-input:focus {
    border-color: #8ddece;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
}

.form-check-input:checked {
    background-color: #0085CA;
    border-color: #0085CA;
}

.form-check-input:checked[type=checkbox] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check-input:checked[type=radio] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input[type=checkbox]:indeterminate {
    background-color: #0085CA;
    border-color: #0085CA;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
    cursor: default;
    opacity: 0.5;
}

.form-switch {
    padding-left: 2.5em;
}

.form-switch .form-check-input {
    width: 2em;
    margin-left: -2.5em;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .form-switch .form-check-input {
        transition: none;
    }
}

.form-switch .form-check-input:focus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-switch .form-check-input:checked {
    background-position: right center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
    margin-right: -2.5em;
    margin-left: 0;
}

.form-check-inline {
    display: inline-block;
    margin-right: 1rem;
}

.btn-check {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
}

.btn-check[disabled]+.btn,
.btn-check:disabled+.btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65;
}

.form-range {
    width: 100%;
    height: 1.5rem;
    padding: 0;
    background-color: transparent;
    appearance: none;
}

.form-range:focus {
    outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
}

.form-range:focus::-moz-range-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
}

.form-range::-moz-focus-outer {
    border: 0;
}

.form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #0085CA;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none;
}

@media (prefers-reduced-motion: reduce) {
    .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none;
    }
}

.form-range::-webkit-slider-thumb:active {
    background-color: #baebe1;
}

.form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
    border-radius: 1rem;
}

.form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #0085CA;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none;
}

@media (prefers-reduced-motion: reduce) {
    .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none;
    }
}

.form-range::-moz-range-thumb:active {
    background-color: #baebe1;
}

.form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
    border-radius: 1rem;
}

.form-range:disabled {
    pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
    background-color: #adb5bd;
}

.form-range:disabled::-moz-range-thumb {
    background-color: #adb5bd;
}

.form-floating {
    position: relative;
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext,
.form-floating>.form-select {
    height: 5.5rem;
    line-height: 1.25;
}

.form-floating>label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 1.5rem 0;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: 0.125rem solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .form-floating>label {
        transition: none;
    }
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext {
    padding: 1.5rem 0;
}

.form-floating>.form-control::placeholder,
.form-floating>.form-control-plaintext::placeholder {
    color: transparent;
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown),
.form-floating>.form-control-plaintext:focus,
.form-floating>.form-control-plaintext:not(:placeholder-shown) {
    padding-top: 2.5rem;
    padding-bottom: 1.5rem;
}

.form-floating>.form-control:-webkit-autofill,
.form-floating>.form-control-plaintext:-webkit-autofill {
    padding-top: 2.5rem;
    padding-bottom: 1.5rem;
}

.form-floating>.form-select {
    padding-top: 2.5rem;
    padding-bottom: 1.5rem;
}

.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-control-plaintext~label,
.form-floating>.form-select~label {
    opacity: 0.65;
    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
}

.form-floating>.form-control:-webkit-autofill~label {
    opacity: 0.65;
    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
}

.form-floating>.form-control-plaintext~label {
    border-width: 0.125rem 0;
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}

.input-group>.form-control,
.input-group>.form-select,
.input-group>.form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}

.input-group>.form-control:focus,
.input-group>.form-select:focus,
.input-group>.form-floating:focus-within {
    z-index: 5;
}

.input-group .btn {
    position: relative;
    z-index: 2;
}

.input-group .btn:focus {
    z-index: 5;
}

.input-group-text {
    display: flex;
    align-items: center;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 0.125rem solid #ced4da;
    border-radius: 0.5rem;
}

.input-group-lg>.form-control,
.input-group-lg>.form-select,
.input-group-lg>.input-group-text,
.input-group-lg>.btn {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    border-radius: 0.75rem;
}

.input-group-sm>.form-control,
.input-group-sm>.form-select,
.input-group-sm>.input-group-text,
.input-group-sm>.btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
}

.input-group-lg>.form-select,
.input-group-sm>.form-select {
    padding-right: 3rem;
}

.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: -0.125rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.input-group>.form-floating:not(:first-child)>.form-control,
.input-group>.form-floating:not(:first-child)>.form-select {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.valid-feedback {
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #198754;
}

.valid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: 0.25rem 0.5rem;
    margin-top: 0.1rem;
    font-size: 0.875rem;
    color: #fff;
    background-color: rgba(25, 135, 84, 0.9);
    border-radius: 0.5rem;
}

.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip,
.is-valid~.valid-feedback,
.is-valid~.valid-tooltip {
    display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
    border-color: #198754;
    padding-right: calc(1.5em + 0.75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
    border-color: #198754;
    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
    padding-right: calc(1.5em + 0.75rem);
    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
    border-color: #198754;
}

.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"] {
    padding-right: 4.125rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: right 0.75rem center, center right 2.25rem;
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
    border-color: #198754;
    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.was-validated .form-control-color:valid,
.form-control-color.is-valid {
    width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
    border-color: #198754;
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
    background-color: #198754;
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
    color: #198754;
}

.form-check-inline .form-check-input~.valid-feedback {
    margin-left: 0.5em;
}

.was-validated .input-group>.form-control:not(:focus):valid,
.input-group>.form-control:not(:focus).is-valid,
.was-validated .input-group>.form-select:not(:focus):valid,
.input-group>.form-select:not(:focus).is-valid,
.was-validated .input-group>.form-floating:not(:focus-within):valid,
.input-group>.form-floating:not(:focus-within).is-valid {
    z-index: 3;
}

.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
}

.invalid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: 0.25rem 0.5rem;
    margin-top: 0.1rem;
    font-size: 0.875rem;
    color: #fff;
    background-color: rgba(220, 53, 69, 0.9);
    border-radius: 0.5rem;
}

.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip,
.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip {
    display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
    border-color: #dc3545;
    padding-right: calc(1.5em + 0.75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
    padding-right: calc(1.5em + 0.75rem);
    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
    border-color: #dc3545;
}

.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"] {
    padding-right: 4.125rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-position: right 0.75rem center, center right 2.25rem;
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-control-color:invalid,
.form-control-color.is-invalid {
    width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
    border-color: #dc3545;
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
    background-color: #dc3545;
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
    color: #dc3545;
}

.form-check-inline .form-check-input~.invalid-feedback {
    margin-left: 0.5em;
}

.was-validated .input-group>.form-control:not(:focus):invalid,
.input-group>.form-control:not(:focus).is-invalid,
.was-validated .input-group>.form-select:not(:focus):invalid,
.input-group>.form-select:not(:focus).is-invalid,
.was-validated .input-group>.form-floating:not(:focus-within):invalid,
.input-group>.form-floating:not(:focus-within).is-invalid {
    z-index: 4;
}

.btn {
    --bs-btn-padding-x: 0.75rem;
    --bs-btn-padding-y: 0.375rem;
    --bs-btn-font-family: ;
    --bs-btn-font-size: 1rem;
    --bs-btn-font-weight: 400;
    --bs-btn-line-height: 1.5;
    --bs-btn-color: #212529;
    --bs-btn-bg: transparent;
    --bs-btn-border-width: 0.125rem;
    --bs-btn-border-color: transparent;
    --bs-btn-border-radius: 0.5rem;
    --bs-btn-hover-border-color: transparent;
    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
    --bs-btn-disabled-opacity: 0.65;
    --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
    display: inline-block;
    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
    font-family: var(--bs-btn-font-family);
    font-size: var(--bs-btn-font-size);
    font-weight: var(--bs-btn-font-weight);
    line-height: var(--bs-btn-line-height);
    color: var(--bs-btn-color);
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
    border-radius: var(--bs-btn-border-radius);
    background-color: var(--bs-btn-bg);
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .btn {
        transition: none;
    }
}

.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
}

.btn-check+.btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible+.btn {
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked+.btn,
:not(.btn-check)+.btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
    color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);
    border-color: var(--bs-btn-active-border-color);
}

.btn-check:checked+.btn:focus-visible,
:not(.btn-check)+.btn:active:focus-visible,
.btn:first-child:active:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible {
    box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
    color: var(--bs-btn-disabled-color);
    pointer-events: none;
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
    opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: #0085CA;
    --bs-btn-border-color: #0085CA;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #16a085;
    --bs-btn-hover-border-color: #15967d;
    --bs-btn-focus-shadow-rgb: 60, 198, 171;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #15967d;
    --bs-btn-active-border-color: #148d75;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #0085CA;
    --bs-btn-disabled-border-color: #0085CA;
}

.btn-secondary {
    --bs-btn-color: #fff;
    --bs-btn-bg: #2c3e50;
    --bs-btn-border-color: #2c3e50;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #253544;
    --bs-btn-hover-border-color: #233240;
    --bs-btn-focus-shadow-rgb: 76, 91, 106;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #233240;
    --bs-btn-active-border-color: #212f3c;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #2c3e50;
    --bs-btn-disabled-border-color: #2c3e50;
}

.btn-success {
    --bs-btn-color: #fff;
    --bs-btn-bg: #198754;
    --bs-btn-border-color: #198754;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #157347;
    --bs-btn-hover-border-color: #146c43;
    --bs-btn-focus-shadow-rgb: 60, 153, 110;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #146c43;
    --bs-btn-active-border-color: #13653f;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #198754;
    --bs-btn-disabled-border-color: #198754;
}

.btn-info {
    --bs-btn-color: #000;
    --bs-btn-bg: #0dcaf0;
    --bs-btn-border-color: #0dcaf0;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #31d2f2;
    --bs-btn-hover-border-color: #25cff2;
    --bs-btn-focus-shadow-rgb: 11, 172, 204;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #3dd5f3;
    --bs-btn-active-border-color: #25cff2;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #0dcaf0;
    --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
    --bs-btn-color: #000;
    --bs-btn-bg: #ffc107;
    --bs-btn-border-color: #ffc107;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #ffca2c;
    --bs-btn-hover-border-color: #ffc720;
    --bs-btn-focus-shadow-rgb: 217, 164, 6;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #ffcd39;
    --bs-btn-active-border-color: #ffc720;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #ffc107;
    --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
    --bs-btn-color: #fff;
    --bs-btn-bg: #dc3545;
    --bs-btn-border-color: #dc3545;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #bb2d3b;
    --bs-btn-hover-border-color: #b02a37;
    --bs-btn-focus-shadow-rgb: 225, 83, 97;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #b02a37;
    --bs-btn-active-border-color: #a52834;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #dc3545;
    --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
    --bs-btn-color: #000;
    --bs-btn-bg: #f8f9fa;
    --bs-btn-border-color: #f8f9fa;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #d3d4d5;
    --bs-btn-hover-border-color: #c6c7c8;
    --bs-btn-focus-shadow-rgb: 211, 212, 213;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #c6c7c8;
    --bs-btn-active-border-color: #babbbc;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #000;
    --bs-btn-disabled-bg: #f8f9fa;
    --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
    --bs-btn-color: #fff;
    --bs-btn-bg: #212529;
    --bs-btn-border-color: #212529;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #424649;
    --bs-btn-hover-border-color: #373b3e;
    --bs-btn-focus-shadow-rgb: 66, 70, 73;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #4d5154;
    --bs-btn-active-border-color: #373b3e;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #212529;
    --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
    --bs-btn-color: #0085CA;
    --bs-btn-border-color: #0085CA;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #0085CA;
    --bs-btn-hover-border-color: #0085CA;
    --bs-btn-focus-shadow-rgb: 26, 188, 156;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #0085CA;
    --bs-btn-active-border-color: #0085CA;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #0085CA;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #0085CA;
    --bs-gradient: none;
}

.btn-outline-secondary {
    --bs-btn-color: #2c3e50;
    --bs-btn-border-color: #2c3e50;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #2c3e50;
    --bs-btn-hover-border-color: #2c3e50;
    --bs-btn-focus-shadow-rgb: 44, 62, 80;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #2c3e50;
    --bs-btn-active-border-color: #2c3e50;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #2c3e50;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #2c3e50;
    --bs-gradient: none;
}

.btn-outline-success {
    --bs-btn-color: #198754;
    --bs-btn-border-color: #198754;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #198754;
    --bs-btn-hover-border-color: #198754;
    --bs-btn-focus-shadow-rgb: 25, 135, 84;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #198754;
    --bs-btn-active-border-color: #198754;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #198754;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #198754;
    --bs-gradient: none;
}

.btn-outline-info {
    --bs-btn-color: #0dcaf0;
    --bs-btn-border-color: #0dcaf0;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #0dcaf0;
    --bs-btn-hover-border-color: #0dcaf0;
    --bs-btn-focus-shadow-rgb: 13, 202, 240;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #0dcaf0;
    --bs-btn-active-border-color: #0dcaf0;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #0dcaf0;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #0dcaf0;
    --bs-gradient: none;
}

.btn-outline-warning {
    --bs-btn-color: #ffc107;
    --bs-btn-border-color: #ffc107;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #ffc107;
    --bs-btn-hover-border-color: #ffc107;
    --bs-btn-focus-shadow-rgb: 255, 193, 7;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #ffc107;
    --bs-btn-active-border-color: #ffc107;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #ffc107;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #ffc107;
    --bs-gradient: none;
}

.btn-outline-danger {
    --bs-btn-color: #dc3545;
    --bs-btn-border-color: #dc3545;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #dc3545;
    --bs-btn-hover-border-color: #dc3545;
    --bs-btn-focus-shadow-rgb: 220, 53, 69;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #dc3545;
    --bs-btn-active-border-color: #dc3545;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #dc3545;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #dc3545;
    --bs-gradient: none;
}

.btn-outline-light {
    --bs-btn-color: #f8f9fa;
    --bs-btn-border-color: #f8f9fa;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #f8f9fa;
    --bs-btn-hover-border-color: #f8f9fa;
    --bs-btn-focus-shadow-rgb: 248, 249, 250;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #f8f9fa;
    --bs-btn-active-border-color: #f8f9fa;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #f8f9fa;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #f8f9fa;
    --bs-gradient: none;
}

.btn-outline-dark {
    --bs-btn-color: #212529;
    --bs-btn-border-color: #212529;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #212529;
    --bs-btn-hover-border-color: #212529;
    --bs-btn-focus-shadow-rgb: 33, 37, 41;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #212529;
    --bs-btn-active-border-color: #212529;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #212529;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #212529;
    --bs-gradient: none;
}

.btn-link {
    --bs-btn-font-weight: 400;
    --bs-btn-color: var(--bs-link-color);
    --bs-btn-bg: transparent;
    --bs-btn-border-color: transparent;
    --bs-btn-hover-color: var(--bs-link-hover-color);
    --bs-btn-hover-border-color: transparent;
    --bs-btn-active-color: var(--bs-link-hover-color);
    --bs-btn-active-border-color: transparent;
    --bs-btn-disabled-color: #6c757d;
    --bs-btn-disabled-border-color: transparent;
    --bs-btn-box-shadow: none;
    --bs-btn-focus-shadow-rgb: 60, 198, 171;
    text-decoration: underline;
}

.btn-link:focus-visible {
    color: var(--bs-btn-color);
}

.btn-link:hover {
    color: var(--bs-btn-hover-color);
}

.btn-lg,
.btn-group-lg>.btn {
    --bs-btn-padding-y: 0.5rem;
    --bs-btn-padding-x: 1rem;
    --bs-btn-font-size: 1.25rem;
    --bs-btn-border-radius: 0.75rem;
}

.btn-sm,
.btn-group-sm>.btn {
    --bs-btn-padding-y: 0.25rem;
    --bs-btn-padding-x: 0.5rem;
    --bs-btn-font-size: 0.875rem;
    --bs-btn-border-radius: 0.25rem;
}

.fade {
    transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
    .fade {
        transition: none;
    }
}

.fade:not(.show) {
    opacity: 0;
}

.collapse:not(.show) {
    display: none;
}

.collapsing {
    height: 0;
    overflow: hidden;
    transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
    .collapsing {
        transition: none;
    }
}

.collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
    .collapsing.collapse-horizontal {
        transition: none;
    }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
    position: relative;
}

.dropdown-toggle {
    white-space: nowrap;
}

.dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropdown-menu {
    --bs-dropdown-zindex: 1000;
    --bs-dropdown-min-width: 10rem;
    --bs-dropdown-padding-x: 0;
    --bs-dropdown-padding-y: 0.5rem;
    --bs-dropdown-spacer: 0.125rem;
    --bs-dropdown-font-size: 1rem;
    --bs-dropdown-color: #212529;
    --bs-dropdown-bg: #fff;
    --bs-dropdown-border-color: var(--bs-border-color-translucent);
    --bs-dropdown-border-radius: 0.5rem;
    --bs-dropdown-border-width: 0.125rem;
    --bs-dropdown-inner-border-radius: 0.375rem;
    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
    --bs-dropdown-divider-margin-y: 0.5rem;
    --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-dropdown-link-color: #212529;
    --bs-dropdown-link-hover-color: #1e2125;
    --bs-dropdown-link-hover-bg: #e9ecef;
    --bs-dropdown-link-active-color: #fff;
    --bs-dropdown-link-active-bg: #0085CA;
    --bs-dropdown-link-disabled-color: #adb5bd;
    --bs-dropdown-item-padding-x: 1rem;
    --bs-dropdown-item-padding-y: 0.25rem;
    --bs-dropdown-header-color: #6c757d;
    --bs-dropdown-header-padding-x: 1rem;
    --bs-dropdown-header-padding-y: 0.5rem;
    position: absolute;
    z-index: var(--bs-dropdown-zindex);
    display: none;
    min-width: var(--bs-dropdown-min-width);
    padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
    margin: 0;
    font-size: var(--bs-dropdown-font-size);
    color: var(--bs-dropdown-color);
    text-align: left;
    list-style: none;
    background-color: var(--bs-dropdown-bg);
    background-clip: padding-box;
    border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
    border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
    --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0;
}

.dropdown-menu-end {
    --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto;
}

@media (min-width: 576px) {
    .dropdown-menu-sm-start {
        --bs-position: start;
    }

    .dropdown-menu-sm-start[data-bs-popper] {
        right: auto;
        left: 0;
    }

    .dropdown-menu-sm-end {
        --bs-position: end;
    }

    .dropdown-menu-sm-end[data-bs-popper] {
        right: 0;
        left: auto;
    }
}

@media (min-width: 768px) {
    .dropdown-menu-md-start {
        --bs-position: start;
    }

    .dropdown-menu-md-start[data-bs-popper] {
        right: auto;
        left: 0;
    }

    .dropdown-menu-md-end {
        --bs-position: end;
    }

    .dropdown-menu-md-end[data-bs-popper] {
        right: 0;
        left: auto;
    }
}

@media (min-width: 992px) {
    .dropdown-menu-lg-start {
        --bs-position: start;
    }

    .dropdown-menu-lg-start[data-bs-popper] {
        right: auto;
        left: 0;
    }

    .dropdown-menu-lg-end {
        --bs-position: end;
    }

    .dropdown-menu-lg-end[data-bs-popper] {
        right: 0;
        left: auto;
    }
}

@media (min-width: 1200px) {
    .dropdown-menu-xl-start {
        --bs-position: start;
    }

    .dropdown-menu-xl-start[data-bs-popper] {
        right: auto;
        left: 0;
    }

    .dropdown-menu-xl-end {
        --bs-position: end;
    }

    .dropdown-menu-xl-end[data-bs-popper] {
        right: 0;
        left: auto;
    }
}

@media (min-width: 1400px) {
    .dropdown-menu-xxl-start {
        --bs-position: start;
    }

    .dropdown-menu-xxl-start[data-bs-popper] {
        right: auto;
        left: 0;
    }

    .dropdown-menu-xxl-end {
        --bs-position: end;
    }

    .dropdown-menu-xxl-end[data-bs-popper] {
        right: 0;
        left: auto;
    }
}

.dropup .dropdown-menu[data-bs-popper] {
    top: auto;
    bottom: 100%;
    margin-top: 0;
    margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0;
    border-right: 0.3em solid transparent;
    border-bottom: 0.3em solid;
    border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
    top: 0;
    right: auto;
    left: 100%;
    margin-top: 0;
    margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid transparent;
    border-right: 0;
    border-bottom: 0.3em solid transparent;
    border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropend .dropdown-toggle::after {
    vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
    top: 0;
    right: 100%;
    left: auto;
    margin-top: 0;
    margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
}

.dropstart .dropdown-toggle::after {
    display: none;
}

.dropstart .dropdown-toggle::before {
    display: inline-block;
    margin-right: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid transparent;
    border-right: 0.3em solid;
    border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropstart .dropdown-toggle::before {
    vertical-align: 0;
}

.dropdown-divider {
    height: 0;
    margin: var(--bs-dropdown-divider-margin-y) 0;
    overflow: hidden;
    border-top: 1px solid var(--bs-dropdown-divider-bg);
    opacity: 1;
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
    clear: both;
    font-weight: 400;
    color: var(--bs-dropdown-link-color);
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
    color: var(--bs-dropdown-link-hover-color);
    background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active,
.dropdown-item:active {
    color: var(--bs-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
    color: var(--bs-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent;
}

.dropdown-menu.show {
    display: block;
}

.dropdown-header {
    display: block;
    padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
    margin-bottom: 0;
    font-size: 0.875rem;
    color: var(--bs-dropdown-header-color);
    white-space: nowrap;
}

.dropdown-item-text {
    display: block;
    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
    color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
    --bs-dropdown-color: #dee2e6;
    --bs-dropdown-bg: #343a40;
    --bs-dropdown-border-color: var(--bs-border-color-translucent);
    --bs-dropdown-box-shadow: ;
    --bs-dropdown-link-color: #dee2e6;
    --bs-dropdown-link-hover-color: #fff;
    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
    --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
    --bs-dropdown-link-active-color: #fff;
    --bs-dropdown-link-active-bg: #0085CA;
    --bs-dropdown-link-disabled-color: #adb5bd;
    --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
    position: relative;
    flex: 1 1 auto;
}

.btn-group>.btn-check:checked+.btn,
.btn-group>.btn-check:focus+.btn,
.btn-group>.btn:hover,
.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn-check:checked+.btn,
.btn-group-vertical>.btn-check:focus+.btn,
.btn-group-vertical>.btn:hover,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
    z-index: 1;
}

.btn-toolbar {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.btn-toolbar .input-group {
    width: auto;
}

.btn-group {
    border-radius: 0.5rem;
}

.btn-group> :not(.btn-check:first-child)+.btn,
.btn-group>.btn-group:not(:first-child) {
    margin-left: -0.125rem;
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn.dropdown-toggle-split:first-child,
.btn-group>.btn-group:not(:last-child)>.btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.btn-group>.btn:nth-child(n+3),
.btn-group> :not(.btn-check)+.btn,
.btn-group>.btn-group:not(:first-child)>.btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
    padding-right: 0.5625rem;
    padding-left: 0.5625rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
    margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
    margin-right: 0;
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
    padding-right: 0.375rem;
    padding-left: 0.375rem;
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
}

.btn-group-vertical {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
    width: 100%;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
    margin-top: -0.125rem;
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.btn-group-vertical>.btn~.btn,
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.nav {
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: var(--bs-link-color);
    --bs-nav-link-hover-color: var(--bs-link-hover-color);
    --bs-nav-link-disabled-color: #6c757d;
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.nav-link {
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: var(--bs-nav-link-font-weight);
    color: var(--bs-nav-link-color);
    text-decoration: none;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .nav-link {
        transition: none;
    }
}

.nav-link:hover,
.nav-link:focus {
    color: var(--bs-nav-link-hover-color);
}

.nav-link.disabled {
    color: var(--bs-nav-link-disabled-color);
    pointer-events: none;
    cursor: default;
}

.nav-tabs {
    --bs-nav-tabs-border-width: 0.125rem;
    --bs-nav-tabs-border-color: #dee2e6;
    --bs-nav-tabs-border-radius: 0.5rem;
    --bs-nav-tabs-link-hover-border-color: #e9ecef #e9ecef #dee2e6;
    --bs-nav-tabs-link-active-color: #495057;
    --bs-nav-tabs-link-active-bg: #fff;
    --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;
    border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
    background: none;
    border: var(--bs-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--bs-nav-tabs-border-radius);
    border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
    isolation: isolate;
    border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.disabled,
.nav-tabs .nav-link:disabled {
    color: var(--bs-nav-link-disabled-color);
    background-color: transparent;
    border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
    color: var(--bs-nav-tabs-link-active-color);
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.nav-pills {
    --bs-nav-pills-border-radius: 0.5rem;
    --bs-nav-pills-link-active-color: #fff;
    --bs-nav-pills-link-active-bg: #0085CA;
}

.nav-pills .nav-link {
    background: none;
    border: 0;
    border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link:disabled {
    color: var(--bs-nav-link-disabled-color);
    background-color: transparent;
    border-color: transparent;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
    flex: 1 1 auto;
    text-align: center;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
    width: 100%;
}

.tab-content>.tab-pane {
    display: none;
}

.tab-content>.active {
    display: block;
}

.navbar {
    --bs-navbar-padding-x: 0;
    --bs-navbar-padding-y: 0.5rem;
    --bs-navbar-color: rgba(0, 0, 0, 0.55);
    --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
    --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
    --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
    --bs-navbar-brand-padding-y: 0.3125rem;
    --bs-navbar-brand-margin-end: 1rem;
    --bs-navbar-brand-font-size: 1.25rem;
    --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
    --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
    --bs-navbar-nav-link-padding-x: 0.5rem;
    --bs-navbar-toggler-padding-y: 0.25rem;
    --bs-navbar-toggler-padding-x: 0.75rem;
    --bs-navbar-toggler-font-size: 1.25rem;
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
    --bs-navbar-toggler-border-radius: 0.5rem;
    --bs-navbar-toggler-focus-width: 0.25rem;
    --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar>.container,
.navbar>.container-fluid,
.navbar>.container-sm,
.navbar>.container-md,
.navbar>.container-lg,
.navbar>.container-xl,
.navbar>.container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between;
}

.navbar-brand {
    padding-top: var(--bs-navbar-brand-padding-y);
    padding-bottom: var(--bs-navbar-brand-padding-y);
    margin-right: var(--bs-navbar-brand-margin-end);
    font-size: var(--bs-navbar-brand-font-size);
    color: var(--bs-navbar-brand-color);
    text-decoration: none;
    white-space: nowrap;
}

.navbar-brand:hover,
.navbar-brand:focus {
    color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
    --bs-nav-link-padding-x: 0;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: var(--bs-navbar-color);
    --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
    --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.navbar-nav .show>.nav-link,
.navbar-nav .nav-link.active {
    color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
    position: static;
}

.navbar-text {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
    color: var(--bs-navbar-active-color);
}

.navbar-collapse {
    flex-basis: 100%;
    flex-grow: 1;
    align-items: center;
}

.navbar-toggler {
    padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
    font-size: var(--bs-navbar-toggler-font-size);
    line-height: 1;
    color: var(--bs-navbar-color);
    background-color: transparent;
    border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
    border-radius: var(--bs-navbar-toggler-border-radius);
    transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
        transition: none;
    }
}

.navbar-toggler:hover {
    text-decoration: none;
}

.navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    background-image: var(--bs-navbar-toggler-icon-bg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
}

.navbar-nav-scroll {
    max-height: var(--bs-scroll-height, 75vh);
    overflow-y: auto;
}

@media (min-width: 576px) {
    .navbar-expand-sm {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    .navbar-expand-sm .navbar-nav {
        flex-direction: row;
    }

    .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x);
    }

    .navbar-expand-sm .navbar-nav-scroll {
        overflow: visible;
    }

    .navbar-expand-sm .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }

    .navbar-expand-sm .navbar-toggler {
        display: none;
    }

    .navbar-expand-sm .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: transparent !important;
        border: 0 !important;
        transform: none !important;
        transition: none;
    }

    .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none;
    }

    .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
    }
}

@media (min-width: 768px) {
    .navbar-expand-md {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    .navbar-expand-md .navbar-nav {
        flex-direction: row;
    }

    .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x);
    }

    .navbar-expand-md .navbar-nav-scroll {
        overflow: visible;
    }

    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }

    .navbar-expand-md .navbar-toggler {
        display: none;
    }

    .navbar-expand-md .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: transparent !important;
        border: 0 !important;
        transform: none !important;
        transition: none;
    }

    .navbar-expand-md .offcanvas .offcanvas-header {
        display: none;
    }

    .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
    }
}

@media (min-width: 992px) {
    .navbar-expand-lg {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    .navbar-expand-lg .navbar-nav {
        flex-direction: row;
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x);
    }

    .navbar-expand-lg .navbar-nav-scroll {
        overflow: visible;
    }

    .navbar-expand-lg .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }

    .navbar-expand-lg .navbar-toggler {
        display: none;
    }

    .navbar-expand-lg .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: transparent !important;
        border: 0 !important;
        transform: none !important;
        transition: none;
    }

    .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none;
    }

    .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
    }
}

@media (min-width: 1200px) {
    .navbar-expand-xl {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    .navbar-expand-xl .navbar-nav {
        flex-direction: row;
    }

    .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x);
    }

    .navbar-expand-xl .navbar-nav-scroll {
        overflow: visible;
    }

    .navbar-expand-xl .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }

    .navbar-expand-xl .navbar-toggler {
        display: none;
    }

    .navbar-expand-xl .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: transparent !important;
        border: 0 !important;
        transform: none !important;
        transition: none;
    }

    .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none;
    }

    .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
    }
}

@media (min-width: 1400px) {
    .navbar-expand-xxl {
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    .navbar-expand-xxl .navbar-nav {
        flex-direction: row;
    }

    .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x);
    }

    .navbar-expand-xxl .navbar-nav-scroll {
        overflow: visible;
    }

    .navbar-expand-xxl .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }

    .navbar-expand-xxl .navbar-toggler {
        display: none;
    }

    .navbar-expand-xxl .offcanvas {
        position: static;
        z-index: auto;
        flex-grow: 1;
        width: auto !important;
        height: auto !important;
        visibility: visible !important;
        background-color: transparent !important;
        border: 0 !important;
        transform: none !important;
        transition: none;
    }

    .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none;
    }

    .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
    }
}

.navbar-expand {
    flex-wrap: nowrap;
    justify-content: flex-start;
}

.navbar-expand .navbar-nav {
    flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
    position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
    overflow: visible;
}

.navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
}

.navbar-expand .navbar-toggler {
    display: none;
}

.navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
    display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
}

.navbar-dark {
    --bs-navbar-color: rgba(255, 255, 255, 0.55);
    --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
    --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
    --bs-navbar-active-color: #fff;
    --bs-navbar-brand-color: #fff;
    --bs-navbar-brand-hover-color: #fff;
    --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
    --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
    --bs-card-spacer-y: 1rem;
    --bs-card-spacer-x: 1rem;
    --bs-card-title-spacer-y: 0.5rem;
    --bs-card-border-width: 0.125rem;
    --bs-card-border-color: var(--bs-border-color-translucent);
    --bs-card-border-radius: 0.5rem;
    --bs-card-box-shadow: ;
    --bs-card-inner-border-radius: 0.375rem;
    --bs-card-cap-padding-y: 0.5rem;
    --bs-card-cap-padding-x: 1rem;
    --bs-card-cap-bg: rgba(0, 0, 0, 0.03);
    --bs-card-cap-color: ;
    --bs-card-height: ;
    --bs-card-color: ;
    --bs-card-bg: #fff;
    --bs-card-img-overlay-padding: 1rem;
    --bs-card-group-margin: 0.75rem;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: var(--bs-card-height);
    word-wrap: break-word;
    background-color: var(--bs-card-bg);
    background-clip: border-box;
    border: var(--bs-card-border-width) solid var(--bs-card-border-color);
    border-radius: var(--bs-card-border-radius);
}

.card>hr {
    margin-right: 0;
    margin-left: 0;
}

.card>.list-group {
    border-top: inherit;
    border-bottom: inherit;
}

.card>.list-group:first-child {
    border-top-width: 0;
    border-top-left-radius: var(--bs-card-inner-border-radius);
    border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card>.list-group:last-child {
    border-bottom-width: 0;
    border-bottom-right-radius: var(--bs-card-inner-border-radius);
    border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
    border-top: 0;
}

.card-body {
    flex: 1 1 auto;
    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
    color: var(--bs-card-color);
}

.card-title {
    margin-bottom: var(--bs-card-title-spacer-y);
}

.card-subtitle {
    margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
    margin-bottom: 0;
}

.card-text:last-child {
    margin-bottom: 0;
}

.card-link+.card-link {
    margin-left: var(--bs-card-spacer-x);
}

.card-header {
    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
    margin-bottom: 0;
    color: var(--bs-card-cap-color);
    background-color: var(--bs-card-cap-bg);
    border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
    color: var(--bs-card-cap-color);
    background-color: var(--bs-card-cap-bg);
    border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
    margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
    margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
    margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
    border-bottom: 0;
}

.card-header-tabs .nav-link.active {
    background-color: var(--bs-card-bg);
    border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
    margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
    margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: var(--bs-card-img-overlay-padding);
    border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
    width: 100%;
}

.card-img,
.card-img-top {
    border-top-left-radius: var(--bs-card-inner-border-radius);
    border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
    border-bottom-right-radius: var(--bs-card-inner-border-radius);
    border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group>.card {
    margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
    .card-group {
        display: flex;
        flex-flow: row wrap;
    }

    .card-group>.card {
        flex: 1 0;
        margin-bottom: 0;
    }

    .card-group>.card+.card {
        margin-left: 0;
        border-left: 0;
    }

    .card-group>.card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .card-group>.card:not(:last-child) .card-img-top,
    .card-group>.card:not(:last-child) .card-header {
        border-top-right-radius: 0;
    }

    .card-group>.card:not(:last-child) .card-img-bottom,
    .card-group>.card:not(:last-child) .card-footer {
        border-bottom-right-radius: 0;
    }

    .card-group>.card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .card-group>.card:not(:first-child) .card-img-top,
    .card-group>.card:not(:first-child) .card-header {
        border-top-left-radius: 0;
    }

    .card-group>.card:not(:first-child) .card-img-bottom,
    .card-group>.card:not(:first-child) .card-footer {
        border-bottom-left-radius: 0;
    }
}

.accordion {
    --bs-accordion-color: #212529;
    --bs-accordion-bg: #fff;
    --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
    --bs-accordion-border-color: var(--bs-border-color);
    --bs-accordion-border-width: 0.125rem;
    --bs-accordion-border-radius: 0.5rem;
    --bs-accordion-inner-border-radius: 0.375rem;
    --bs-accordion-btn-padding-x: 1.25rem;
    --bs-accordion-btn-padding-y: 1rem;
    --bs-accordion-btn-color: #212529;
    --bs-accordion-btn-bg: var(--bs-accordion-bg);
    --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    --bs-accordion-btn-icon-width: 1.25rem;
    --bs-accordion-btn-icon-transform: rotate(-180deg);
    --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
    --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    --bs-accordion-btn-focus-border-color: #8ddece;
    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
    --bs-accordion-body-padding-x: 1.25rem;
    --bs-accordion-body-padding-y: 1rem;
    --bs-accordion-active-color: #17a98c;
    --bs-accordion-active-bg: #e8f8f5;
}

.accordion-button {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
    font-size: 1rem;
    color: var(--bs-accordion-btn-color);
    text-align: left;
    background-color: var(--bs-accordion-btn-bg);
    border: 0;
    border-radius: 0;
    overflow-anchor: none;
    transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
    .accordion-button {
        transition: none;
    }
}

.accordion-button:not(.collapsed) {
    color: var(--bs-accordion-active-color);
    background-color: var(--bs-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
    background-image: var(--bs-accordion-btn-active-icon);
    transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
    .accordion-button::after {
        transition: none;
    }
}

.accordion-button:hover {
    z-index: 2;
}

.accordion-button:focus {
    z-index: 3;
    border-color: var(--bs-accordion-btn-focus-border-color);
    outline: 0;
    box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
    margin-bottom: 0;
}

.accordion-item {
    color: var(--bs-accordion-color);
    background-color: var(--bs-accordion-bg);
    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
    border-top-left-radius: var(--bs-accordion-border-radius);
    border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type .accordion-button {
    border-top-left-radius: var(--bs-accordion-inner-border-radius);
    border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
    border-top: 0;
}

.accordion-item:last-of-type {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type .accordion-button.collapsed {
    border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
    border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type .accordion-collapse {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
    border-width: 0;
}

.accordion-flush .accordion-item {
    border-right: 0;
    border-left: 0;
    border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
    border-top: 0;
}

.accordion-flush .accordion-item:last-child {
    border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button,
.accordion-flush .accordion-item .accordion-button.collapsed {
    border-radius: 0;
}

.breadcrumb {
    --bs-breadcrumb-padding-x: 0;
    --bs-breadcrumb-padding-y: 0;
    --bs-breadcrumb-margin-bottom: 1rem;
    --bs-breadcrumb-bg: ;
    --bs-breadcrumb-border-radius: ;
    --bs-breadcrumb-divider-color: #6c757d;
    --bs-breadcrumb-item-padding-x: 0.5rem;
    --bs-breadcrumb-item-active-color: #6c757d;
    display: flex;
    flex-wrap: wrap;
    padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
    margin-bottom: var(--bs-breadcrumb-margin-bottom);
    font-size: var(--bs-breadcrumb-font-size);
    list-style: none;
    background-color: var(--bs-breadcrumb-bg);
    border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item+.breadcrumb-item {
    padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item+.breadcrumb-item::before {
    float: left;
    padding-right: var(--bs-breadcrumb-item-padding-x);
    color: var(--bs-breadcrumb-divider-color);
    content: var(--bs-breadcrumb-divider, "/")
        /* rtl: var(--bs-breadcrumb-divider, "/") */
    ;
}

.breadcrumb-item.active {
    color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
    --bs-pagination-padding-x: 0.75rem;
    --bs-pagination-padding-y: 0.375rem;
    --bs-pagination-font-size: 1rem;
    --bs-pagination-color: var(--bs-link-color);
    --bs-pagination-bg: #fff;
    --bs-pagination-border-width: 0.125rem;
    --bs-pagination-border-color: #dee2e6;
    --bs-pagination-border-radius: 0.5rem;
    --bs-pagination-hover-color: var(--bs-link-hover-color);
    --bs-pagination-hover-bg: #e9ecef;
    --bs-pagination-hover-border-color: #dee2e6;
    --bs-pagination-focus-color: var(--bs-link-hover-color);
    --bs-pagination-focus-bg: #e9ecef;
    --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
    --bs-pagination-active-color: #fff;
    --bs-pagination-active-bg: #0085CA;
    --bs-pagination-active-border-color: #0085CA;
    --bs-pagination-disabled-color: #6c757d;
    --bs-pagination-disabled-bg: #fff;
    --bs-pagination-disabled-border-color: #dee2e6;
    display: flex;
    padding-left: 0;
    list-style: none;
}

.page-link {
    position: relative;
    display: block;
    padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
    font-size: var(--bs-pagination-font-size);
    color: var(--bs-pagination-color);
    text-decoration: none;
    background-color: var(--bs-pagination-bg);
    border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .page-link {
        transition: none;
    }
}

.page-link:hover {
    z-index: 2;
    color: var(--bs-pagination-hover-color);
    background-color: var(--bs-pagination-hover-bg);
    border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
    z-index: 3;
    color: var(--bs-pagination-focus-color);
    background-color: var(--bs-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--bs-pagination-focus-box-shadow);
}

.page-link.active,
.active>.page-link {
    z-index: 3;
    color: var(--bs-pagination-active-color);
    background-color: var(--bs-pagination-active-bg);
    border-color: var(--bs-pagination-active-border-color);
}

.page-link.disabled,
.disabled>.page-link {
    color: var(--bs-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--bs-pagination-disabled-bg);
    border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
    margin-left: -0.125rem;
}

.page-item:first-child .page-link {
    border-top-left-radius: var(--bs-pagination-border-radius);
    border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.page-item:last-child .page-link {
    border-top-right-radius: var(--bs-pagination-border-radius);
    border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
    --bs-pagination-padding-x: 1.5rem;
    --bs-pagination-padding-y: 0.75rem;
    --bs-pagination-font-size: 1.25rem;
    --bs-pagination-border-radius: 0.75rem;
}

.pagination-sm {
    --bs-pagination-padding-x: 0.5rem;
    --bs-pagination-padding-y: 0.25rem;
    --bs-pagination-font-size: 0.875rem;
    --bs-pagination-border-radius: 0.25rem;
}

.badge {
    --bs-badge-padding-x: 0.65em;
    --bs-badge-padding-y: 0.35em;
    --bs-badge-font-size: 0.75em;
    --bs-badge-font-weight: 700;
    --bs-badge-color: #fff;
    --bs-badge-border-radius: 0.5rem;
    display: inline-block;
    padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
    font-size: var(--bs-badge-font-size);
    font-weight: var(--bs-badge-font-weight);
    line-height: 1;
    color: var(--bs-badge-color);
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
    display: none;
}

.btn .badge {
    position: relative;
    top: -1px;
}

.alert {
    --bs-alert-bg: transparent;
    --bs-alert-padding-x: 1rem;
    --bs-alert-padding-y: 1rem;
    --bs-alert-margin-bottom: 1rem;
    --bs-alert-color: inherit;
    --bs-alert-border-color: transparent;
    --bs-alert-border: 0.125rem solid var(--bs-alert-border-color);
    --bs-alert-border-radius: 0.5rem;
    position: relative;
    padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
    margin-bottom: var(--bs-alert-margin-bottom);
    color: var(--bs-alert-color);
    background-color: var(--bs-alert-bg);
    border: var(--bs-alert-border);
    border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
    color: inherit;
}

.alert-link {
    font-weight: 700;
}

.alert-dismissible {
    padding-right: 3rem;
}

.alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1.25rem 1rem;
}

.alert-primary {
    --bs-alert-color: #10715e;
    --bs-alert-bg: #d1f2eb;
    --bs-alert-border-color: #baebe1;
}

.alert-primary .alert-link {
    color: #0d5a4b;
}

.alert-secondary {
    --bs-alert-color: #1a2530;
    --bs-alert-bg: #d5d8dc;
    --bs-alert-border-color: #c0c5cb;
}

.alert-secondary .alert-link {
    color: #151e26;
}

.alert-success {
    --bs-alert-color: #0f5132;
    --bs-alert-bg: #d1e7dd;
    --bs-alert-border-color: #badbcc;
}

.alert-success .alert-link {
    color: #0c4128;
}

.alert-info {
    --bs-alert-color: #087990;
    --bs-alert-bg: #cff4fc;
    --bs-alert-border-color: #b6effb;
}

.alert-info .alert-link {
    color: #066173;
}

.alert-warning {
    --bs-alert-color: #997404;
    --bs-alert-bg: #fff3cd;
    --bs-alert-border-color: #ffecb5;
}

.alert-warning .alert-link {
    color: #7a5d03;
}

.alert-danger {
    --bs-alert-color: #842029;
    --bs-alert-bg: #f8d7da;
    --bs-alert-border-color: #f5c2c7;
}

.alert-danger .alert-link {
    color: #6a1a21;
}

.alert-light {
    --bs-alert-color: #959596;
    --bs-alert-bg: #fefefe;
    --bs-alert-border-color: #fdfdfe;
}

.alert-light .alert-link {
    color: #777778;
}

.alert-dark {
    --bs-alert-color: #141619;
    --bs-alert-bg: #d3d3d4;
    --bs-alert-border-color: #bcbebf;
}

.alert-dark .alert-link {
    color: #101214;
}

@keyframes progress-bar-stripes {
    0% {
        background-position-x: 1rem;
    }
}

.progress {
    --bs-progress-height: 1rem;
    --bs-progress-font-size: 0.75rem;
    --bs-progress-bg: #e9ecef;
    --bs-progress-border-radius: 0.5rem;
    --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
    --bs-progress-bar-color: #fff;
    --bs-progress-bar-bg: #0085CA;
    --bs-progress-bar-transition: width 0.6s ease;
    display: flex;
    height: var(--bs-progress-height);
    overflow: hidden;
    font-size: var(--bs-progress-font-size);
    background-color: var(--bs-progress-bg);
    border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    color: var(--bs-progress-bar-color);
    text-align: center;
    white-space: nowrap;
    background-color: var(--bs-progress-bar-bg);
    transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
    .progress-bar {
        transition: none;
    }
}

.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-bar-animated {
    animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
        animation: none;
    }
}

.list-group {
    --bs-list-group-color: #212529;
    --bs-list-group-bg: #fff;
    --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
    --bs-list-group-border-width: 0.125rem;
    --bs-list-group-border-radius: 0.5rem;
    --bs-list-group-item-padding-x: 1rem;
    --bs-list-group-item-padding-y: 0.5rem;
    --bs-list-group-action-color: #495057;
    --bs-list-group-action-hover-color: #495057;
    --bs-list-group-action-hover-bg: #f8f9fa;
    --bs-list-group-action-active-color: #212529;
    --bs-list-group-action-active-bg: #e9ecef;
    --bs-list-group-disabled-color: #6c757d;
    --bs-list-group-disabled-bg: #fff;
    --bs-list-group-active-color: #fff;
    --bs-list-group-active-bg: #0085CA;
    --bs-list-group-active-border-color: #0085CA;
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
    list-style-type: none;
    counter-reset: section;
}

.list-group-numbered>.list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section;
}

.list-group-item-action {
    width: 100%;
    color: var(--bs-list-group-action-color);
    text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
    color: var(--bs-list-group-action-active-color);
    background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
    position: relative;
    display: block;
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}

.list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
    color: var(--bs-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
    z-index: 2;
    color: var(--bs-list-group-active-color);
    background-color: var(--bs-list-group-active-bg);
    border-color: var(--bs-list-group-active-border-color);
}

.list-group-item+.list-group-item {
    border-top-width: 0;
}

.list-group-item+.list-group-item.active {
    margin-top: calc(-1 * var(--bs-list-group-border-width));
    border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
    flex-direction: row;
}

.list-group-horizontal>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
}

.list-group-horizontal>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
}

.list-group-horizontal>.list-group-item.active {
    margin-top: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
    .list-group-horizontal-sm {
        flex-direction: row;
    }

    .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0;
    }

    .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0;
    }

    .list-group-horizontal-sm>.list-group-item.active {
        margin-top: 0;
    }

    .list-group-horizontal-sm>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0;
    }

    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width);
    }
}

@media (min-width: 768px) {
    .list-group-horizontal-md {
        flex-direction: row;
    }

    .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0;
    }

    .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0;
    }

    .list-group-horizontal-md>.list-group-item.active {
        margin-top: 0;
    }

    .list-group-horizontal-md>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0;
    }

    .list-group-horizontal-md>.list-group-item+.list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width);
    }
}

@media (min-width: 992px) {
    .list-group-horizontal-lg {
        flex-direction: row;
    }

    .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0;
    }

    .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0;
    }

    .list-group-horizontal-lg>.list-group-item.active {
        margin-top: 0;
    }

    .list-group-horizontal-lg>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0;
    }

    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width);
    }
}

@media (min-width: 1200px) {
    .list-group-horizontal-xl {
        flex-direction: row;
    }

    .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0;
    }

    .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0;
    }

    .list-group-horizontal-xl>.list-group-item.active {
        margin-top: 0;
    }

    .list-group-horizontal-xl>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0;
    }

    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width);
    }
}

@media (min-width: 1400px) {
    .list-group-horizontal-xxl {
        flex-direction: row;
    }

    .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {
        border-bottom-left-radius: var(--bs-list-group-border-radius);
        border-top-right-radius: 0;
    }

    .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {
        border-top-right-radius: var(--bs-list-group-border-radius);
        border-bottom-left-radius: 0;
    }

    .list-group-horizontal-xxl>.list-group-item.active {
        margin-top: 0;
    }

    .list-group-horizontal-xxl>.list-group-item+.list-group-item {
        border-top-width: var(--bs-list-group-border-width);
        border-left-width: 0;
    }

    .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width);
    }
}

.list-group-flush {
    border-radius: 0;
}

.list-group-flush>.list-group-item {
    border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush>.list-group-item:last-child {
    border-bottom-width: 0;
}

.list-group-item-primary {
    color: #10715e;
    background-color: #d1f2eb;
}

.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
    color: #10715e;
    background-color: #bcdad4;
}

.list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #10715e;
    border-color: #10715e;
}

.list-group-item-secondary {
    color: #1a2530;
    background-color: #d5d8dc;
}

.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
    color: #1a2530;
    background-color: #c0c2c6;
}

.list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #1a2530;
    border-color: #1a2530;
}

.list-group-item-success {
    color: #0f5132;
    background-color: #d1e7dd;
}

.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
    color: #0f5132;
    background-color: #bcd0c7;
}

.list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #0f5132;
    border-color: #0f5132;
}

.list-group-item-info {
    color: #087990;
    background-color: #cff4fc;
}

.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
    color: #087990;
    background-color: #badce3;
}

.list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #087990;
    border-color: #087990;
}

.list-group-item-warning {
    color: #997404;
    background-color: #fff3cd;
}

.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
    color: #997404;
    background-color: #e6dbb9;
}

.list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #997404;
    border-color: #997404;
}

.list-group-item-danger {
    color: #842029;
    background-color: #f8d7da;
}

.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
    color: #842029;
    background-color: #dfc2c4;
}

.list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #842029;
    border-color: #842029;
}

.list-group-item-light {
    color: #959596;
    background-color: #fefefe;
}

.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
    color: #959596;
    background-color: #e5e5e5;
}

.list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #959596;
    border-color: #959596;
}

.list-group-item-dark {
    color: #141619;
    background-color: #d3d3d4;
}

.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
    color: #141619;
    background-color: #bebebf;
}

.list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #141619;
    border-color: #141619;
}

.btn-close {
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 0.25em 0.25em;
    color: #000;
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/1em auto no-repeat;
    border: 0;
    border-radius: 0.5rem;
    opacity: 0.5;
}

.btn-close:hover {
    color: #000;
    text-decoration: none;
    opacity: 0.75;
}

.btn-close:focus {
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);
    opacity: 1;
}

.btn-close:disabled,
.btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none;
    opacity: 0.25;
}

.btn-close-white {
    filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
    --bs-toast-zindex: 1090;
    --bs-toast-padding-x: 0.75rem;
    --bs-toast-padding-y: 0.5rem;
    --bs-toast-spacing: 1.5rem;
    --bs-toast-max-width: 350px;
    --bs-toast-font-size: 0.875rem;
    --bs-toast-color: ;
    --bs-toast-bg: rgba(255, 255, 255, 0.85);
    --bs-toast-border-width: 0.125rem;
    --bs-toast-border-color: var(--bs-border-color-translucent);
    --bs-toast-border-radius: 0.5rem;
    --bs-toast-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-toast-header-color: #6c757d;
    --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
    --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
    width: var(--bs-toast-max-width);
    max-width: 100%;
    font-size: var(--bs-toast-font-size);
    color: var(--bs-toast-color);
    pointer-events: auto;
    background-color: var(--bs-toast-bg);
    background-clip: padding-box;
    border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
    box-shadow: var(--bs-toast-box-shadow);
    border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
    opacity: 0;
}

.toast:not(.show) {
    display: none;
}

.toast-container {
    --bs-toast-zindex: 1090;
    position: absolute;
    z-index: var(--bs-toast-zindex);
    width: max-content;
    max-width: 100%;
    pointer-events: none;
}

.toast-container> :not(:last-child) {
    margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
    display: flex;
    align-items: center;
    padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
    color: var(--bs-toast-header-color);
    background-color: var(--bs-toast-header-bg);
    background-clip: padding-box;
    border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
    border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
    border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
    margin-right: calc(-0.5 * var(--bs-toast-padding-x));
    margin-left: var(--bs-toast-padding-x);
}

.toast-body {
    padding: var(--bs-toast-padding-x);
    word-wrap: break-word;
}

.modal {
    --bs-modal-zindex: 1055;
    --bs-modal-width: 500px;
    --bs-modal-padding: 1rem;
    --bs-modal-margin: 0.5rem;
    --bs-modal-color: ;
    --bs-modal-bg: #fff;
    --bs-modal-border-color: var(--bs-border-color-translucent);
    --bs-modal-border-width: 0.125rem;
    --bs-modal-border-radius: 0.75rem;
    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-modal-inner-border-radius: 0.625rem;
    --bs-modal-header-padding-x: 1rem;
    --bs-modal-header-padding-y: 1rem;
    --bs-modal-header-padding: 1rem 1rem;
    --bs-modal-header-border-color: var(--bs-border-color);
    --bs-modal-header-border-width: 0.125rem;
    --bs-modal-title-line-height: 1.5;
    --bs-modal-footer-gap: 0.5rem;
    --bs-modal-footer-bg: ;
    --bs-modal-footer-border-color: var(--bs-border-color);
    --bs-modal-footer-border-width: 0.125rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-modal-zindex);
    display: none;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: var(--bs-modal-margin);
    pointer-events: none;
}

.modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
    .modal.fade .modal-dialog {
        transition: none;
    }
}

.modal.show .modal-dialog {
    transform: none;
}

.modal.modal-static .modal-dialog {
    transform: scale(1.02);
}

.modal-dialog-scrollable {
    height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
    overflow-y: auto;
}

.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: var(--bs-modal-color);
    pointer-events: auto;
    background-color: var(--bs-modal-bg);
    background-clip: padding-box;
    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    border-radius: var(--bs-modal-border-radius);
    outline: 0;
}

.modal-backdrop {
    --bs-backdrop-zindex: 1050;
    --bs-backdrop-bg: #000;
    --bs-backdrop-opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
    opacity: 0;
}

.modal-backdrop.show {
    opacity: var(--bs-backdrop-opacity);
}

.modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-modal-header-padding);
    border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
    border-top-left-radius: var(--bs-modal-inner-border-radius);
    border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
    margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
    margin-bottom: 0;
    line-height: var(--bs-modal-title-line-height);
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: var(--bs-modal-padding);
}

.modal-footer {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
    background-color: var(--bs-modal-footer-bg);
    border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
    border-bottom-right-radius: var(--bs-modal-inner-border-radius);
    border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer>* {
    margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
    .modal {
        --bs-modal-margin: 1.75rem;
        --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    }

    .modal-dialog {
        max-width: var(--bs-modal-width);
        margin-right: auto;
        margin-left: auto;
    }

    .modal-sm {
        --bs-modal-width: 300px;
    }
}

@media (min-width: 992px) {

    .modal-lg,
    .modal-xl {
        --bs-modal-width: 800px;
    }
}

@media (min-width: 1200px) {
    .modal-xl {
        --bs-modal-width: 1140px;
    }
}

.modal-fullscreen {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
}

.modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
    border-radius: 0;
}

.modal-fullscreen .modal-body {
    overflow-y: auto;
}

@media (max-width: 575.98px) {
    .modal-fullscreen-sm-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0;
    }

    .modal-fullscreen-sm-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0;
    }

    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
        border-radius: 0;
    }

    .modal-fullscreen-sm-down .modal-body {
        overflow-y: auto;
    }
}

@media (max-width: 767.98px) {
    .modal-fullscreen-md-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0;
    }

    .modal-fullscreen-md-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0;
    }

    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
        border-radius: 0;
    }

    .modal-fullscreen-md-down .modal-body {
        overflow-y: auto;
    }
}

@media (max-width: 991.98px) {
    .modal-fullscreen-lg-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0;
    }

    .modal-fullscreen-lg-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0;
    }

    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
        border-radius: 0;
    }

    .modal-fullscreen-lg-down .modal-body {
        overflow-y: auto;
    }
}

@media (max-width: 1199.98px) {
    .modal-fullscreen-xl-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0;
    }

    .modal-fullscreen-xl-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0;
    }

    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
        border-radius: 0;
    }

    .modal-fullscreen-xl-down .modal-body {
        overflow-y: auto;
    }
}

@media (max-width: 1399.98px) {
    .modal-fullscreen-xxl-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0;
    }

    .modal-fullscreen-xxl-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0;
    }

    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
        border-radius: 0;
    }

    .modal-fullscreen-xxl-down .modal-body {
        overflow-y: auto;
    }
}

.tooltip {
    --bs-tooltip-zindex: 1080;
    --bs-tooltip-max-width: 200px;
    --bs-tooltip-padding-x: 0.5rem;
    --bs-tooltip-padding-y: 0.25rem;
    --bs-tooltip-margin: ;
    --bs-tooltip-font-size: 0.875rem;
    --bs-tooltip-color: #fff;
    --bs-tooltip-bg: #000;
    --bs-tooltip-border-radius: 0.5rem;
    --bs-tooltip-opacity: 0.9;
    --bs-tooltip-arrow-width: 0.8rem;
    --bs-tooltip-arrow-height: 0.4rem;
    z-index: var(--bs-tooltip-zindex);
    display: block;
    padding: var(--bs-tooltip-arrow-height);
    margin: var(--bs-tooltip-margin);
    font-family: var(--bs-font-sans-serif);
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    white-space: normal;
    word-spacing: normal;
    line-break: auto;
    font-size: var(--bs-tooltip-font-size);
    word-wrap: break-word;
    opacity: 0;
}

.tooltip.show {
    opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
    display: block;
    width: var(--bs-tooltip-arrow-width);
    height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid;
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
    bottom: 0;
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
    border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
    left: 0;
    width: var(--bs-tooltip-arrow-height);
    height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
    border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
    top: 0;
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
    border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
    right: 0;
    width: var(--bs-tooltip-arrow-height);
    height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
    border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
    max-width: var(--bs-tooltip-max-width);
    padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
    color: var(--bs-tooltip-color);
    text-align: center;
    background-color: var(--bs-tooltip-bg);
    border-radius: var(--bs-tooltip-border-radius);
}

.popover {
    --bs-popover-zindex: 1070;
    --bs-popover-max-width: 276px;
    --bs-popover-font-size: 0.875rem;
    --bs-popover-bg: #fff;
    --bs-popover-border-width: 0.125rem;
    --bs-popover-border-color: var(--bs-border-color-translucent);
    --bs-popover-border-radius: 0.75rem;
    --bs-popover-inner-border-radius: 0.625rem;
    --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    --bs-popover-header-padding-x: 1rem;
    --bs-popover-header-padding-y: 0.5rem;
    --bs-popover-header-font-size: 1rem;
    --bs-popover-header-color: ;
    --bs-popover-header-bg: #f0f0f0;
    --bs-popover-body-padding-x: 1rem;
    --bs-popover-body-padding-y: 1rem;
    --bs-popover-body-color: #212529;
    --bs-popover-arrow-width: 1rem;
    --bs-popover-arrow-height: 0.5rem;
    --bs-popover-arrow-border: var(--bs-popover-border-color);
    z-index: var(--bs-popover-zindex);
    display: block;
    max-width: var(--bs-popover-max-width);
    font-family: var(--bs-font-sans-serif);
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    white-space: normal;
    word-spacing: normal;
    line-break: auto;
    font-size: var(--bs-popover-font-size);
    word-wrap: break-word;
    background-color: var(--bs-popover-bg);
    background-clip: padding-box;
    border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
    border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
    display: block;
    width: var(--bs-popover-arrow-width);
    height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid;
    border-width: 0;
}

.bs-popover-top>.popover-arrow,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {
    bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,
.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {
    bottom: 0;
    border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
    bottom: var(--bs-popover-border-width);
    border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end>.popover-arrow,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {
    left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
    width: var(--bs-popover-arrow-height);
    height: var(--bs-popover-arrow-width);
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,
.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {
    left: 0;
    border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
    left: var(--bs-popover-border-width);
    border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom>.popover-arrow,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {
    top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,
.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
    border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {
    top: 0;
    border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
    top: var(--bs-popover-border-width);
    border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: var(--bs-popover-arrow-width);
    margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
    content: "";
    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start>.popover-arrow,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {
    right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
    width: var(--bs-popover-arrow-height);
    height: var(--bs-popover-arrow-width);
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,
.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {
    right: 0;
    border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
    right: var(--bs-popover-border-width);
    border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
    padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
    margin-bottom: 0;
    font-size: var(--bs-popover-header-font-size);
    color: var(--bs-popover-header-color);
    background-color: var(--bs-popover-header-bg);
    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
    border-top-left-radius: var(--bs-popover-inner-border-radius);
    border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
    display: none;
}

.popover-body {
    padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
    color: var(--bs-popover-body-color);
}

.carousel {
    position: relative;
}

.carousel.pointer-event {
    touch-action: pan-y;
}

.carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.carousel-inner::after {
    display: block;
    clear: both;
    content: "";
}

.carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .carousel-item {
        transition: none;
    }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
    display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
    transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
    transform: translateX(-100%);
}

.carousel-fade .carousel-item {
    opacity: 0;
    transition-property: opacity;
    transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
    z-index: 1;
    opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
    z-index: 0;
    opacity: 0;
    transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {

    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
        transition: none;
    }
}

.carousel-control-prev,
.carousel-control-next {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15%;
    padding: 0;
    color: #fff;
    text-align: center;
    background: none;
    border: 0;
    opacity: 0.5;
    transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

    .carousel-control-prev,
    .carousel-control-next {
        transition: none;
    }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9;
}

.carousel-control-prev {
    left: 0;
}

.carousel-control-next {
    right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    padding: 0;
    margin-right: 15%;
    margin-bottom: 1rem;
    margin-left: 15%;
    list-style: none;
}

.carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
    .carousel-indicators [data-bs-target] {
        transition: none;
    }
}

.carousel-indicators .active {
    opacity: 1;
}

.carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 1.25rem;
    left: 15%;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    color: #fff;
    text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
    filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
    background-color: #000;
}

.carousel-dark .carousel-caption {
    color: #000;
}

.spinner-grow,
.spinner-border {
    display: inline-block;
    width: var(--bs-spinner-width);
    height: var(--bs-spinner-height);
    vertical-align: var(--bs-spinner-vertical-align);
    border-radius: 50%;
    animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg)
            /* rtl:ignore */
        ;
    }
}

.spinner-border {
    --bs-spinner-width: 2rem;
    --bs-spinner-height: 2rem;
    --bs-spinner-vertical-align: -0.125em;
    --bs-spinner-border-width: 0.25em;
    --bs-spinner-animation-speed: 0.75s;
    --bs-spinner-animation-name: spinner-border;
    border: var(--bs-spinner-border-width) solid currentcolor;
    border-right-color: transparent;
}

.spinner-border-sm {
    --bs-spinner-width: 1rem;
    --bs-spinner-height: 1rem;
    --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
    0% {
        transform: scale(0);
    }

    50% {
        opacity: 1;
        transform: none;
    }
}

.spinner-grow {
    --bs-spinner-width: 2rem;
    --bs-spinner-height: 2rem;
    --bs-spinner-vertical-align: -0.125em;
    --bs-spinner-animation-speed: 0.75s;
    --bs-spinner-animation-name: spinner-grow;
    background-color: currentcolor;
    opacity: 0;
}

.spinner-grow-sm {
    --bs-spinner-width: 1rem;
    --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {

    .spinner-border,
    .spinner-grow {
        --bs-spinner-animation-speed: 1.5s;
    }
}

.offcanvas,
.offcanvas-xxl,
.offcanvas-xl,
.offcanvas-lg,
.offcanvas-md,
.offcanvas-sm {
    --bs-offcanvas-zindex: 1045;
    --bs-offcanvas-width: 400px;
    --bs-offcanvas-height: 30vh;
    --bs-offcanvas-padding-x: 1rem;
    --bs-offcanvas-padding-y: 1rem;
    --bs-offcanvas-color: ;
    --bs-offcanvas-bg: #fff;
    --bs-offcanvas-border-width: 0.125rem;
    --bs-offcanvas-border-color: var(--bs-border-color-translucent);
    --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

@media (max-width: 575.98px) {
    .offcanvas-sm {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform 0.3s ease-in-out;
    }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
        transition: none;
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%);
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%);
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%);
    }
}

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%);
    }
}

@media (max-width: 575.98px) {

    .offcanvas-sm.showing,
    .offcanvas-sm.show:not(.hiding) {
        transform: none;
    }
}

@media (max-width: 575.98px) {

    .offcanvas-sm.showing,
    .offcanvas-sm.hiding,
    .offcanvas-sm.show {
        visibility: visible;
    }
}

@media (min-width: 576px) {
    .offcanvas-sm {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent !important;
    }

    .offcanvas-sm .offcanvas-header {
        display: none;
    }

    .offcanvas-sm .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent !important;
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform 0.3s ease-in-out;
    }
}

@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
        transition: none;
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%);
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%);
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%);
    }
}

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%);
    }
}

@media (max-width: 767.98px) {

    .offcanvas-md.showing,
    .offcanvas-md.show:not(.hiding) {
        transform: none;
    }
}

@media (max-width: 767.98px) {

    .offcanvas-md.showing,
    .offcanvas-md.hiding,
    .offcanvas-md.show {
        visibility: visible;
    }
}

@media (min-width: 768px) {
    .offcanvas-md {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent !important;
    }

    .offcanvas-md .offcanvas-header {
        display: none;
    }

    .offcanvas-md .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent !important;
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform 0.3s ease-in-out;
    }
}

@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
        transition: none;
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%);
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%);
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%);
    }
}

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%);
    }
}

@media (max-width: 991.98px) {

    .offcanvas-lg.showing,
    .offcanvas-lg.show:not(.hiding) {
        transform: none;
    }
}

@media (max-width: 991.98px) {

    .offcanvas-lg.showing,
    .offcanvas-lg.hiding,
    .offcanvas-lg.show {
        visibility: visible;
    }
}

@media (min-width: 992px) {
    .offcanvas-lg {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent !important;
    }

    .offcanvas-lg .offcanvas-header {
        display: none;
    }

    .offcanvas-lg .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent !important;
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform 0.3s ease-in-out;
    }
}

@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
        transition: none;
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%);
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%);
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%);
    }
}

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%);
    }
}

@media (max-width: 1199.98px) {

    .offcanvas-xl.showing,
    .offcanvas-xl.show:not(.hiding) {
        transform: none;
    }
}

@media (max-width: 1199.98px) {

    .offcanvas-xl.showing,
    .offcanvas-xl.hiding,
    .offcanvas-xl.show {
        visibility: visible;
    }
}

@media (min-width: 1200px) {
    .offcanvas-xl {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent !important;
    }

    .offcanvas-xl .offcanvas-header {
        display: none;
    }

    .offcanvas-xl .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent !important;
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl {
        position: fixed;
        bottom: 0;
        z-index: var(--bs-offcanvas-zindex);
        display: flex;
        flex-direction: column;
        max-width: 100%;
        color: var(--bs-offcanvas-color);
        visibility: hidden;
        background-color: var(--bs-offcanvas-bg);
        background-clip: padding-box;
        outline: 0;
        transition: transform 0.3s ease-in-out;
    }
}

@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
        transition: none;
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
        top: 0;
        left: 0;
        width: var(--bs-offcanvas-width);
        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(-100%);
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-end {
        top: 0;
        right: 0;
        width: var(--bs-offcanvas-width);
        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateX(100%);
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-top {
        top: 0;
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(-100%);
    }
}

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-bottom {
        right: 0;
        left: 0;
        height: var(--bs-offcanvas-height);
        max-height: 100%;
        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
        transform: translateY(100%);
    }
}

@media (max-width: 1399.98px) {

    .offcanvas-xxl.showing,
    .offcanvas-xxl.show:not(.hiding) {
        transform: none;
    }
}

@media (max-width: 1399.98px) {

    .offcanvas-xxl.showing,
    .offcanvas-xxl.hiding,
    .offcanvas-xxl.show {
        visibility: visible;
    }
}

@media (min-width: 1400px) {
    .offcanvas-xxl {
        --bs-offcanvas-height: auto;
        --bs-offcanvas-border-width: 0;
        background-color: transparent !important;
    }

    .offcanvas-xxl .offcanvas-header {
        display: none;
    }

    .offcanvas-xxl .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible;
        background-color: transparent !important;
    }
}

.offcanvas {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
    .offcanvas {
        transition: none;
    }
}

.offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
}

.offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
}

.offcanvas.showing,
.offcanvas.show:not(.hiding) {
    transform: none;
}

.offcanvas.showing,
.offcanvas.hiding,
.offcanvas.show {
    visibility: visible;
}

.offcanvas-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000;
}

.offcanvas-backdrop.fade {
    opacity: 0;
}

.offcanvas-backdrop.show {
    opacity: 0.5;
}

.offcanvas-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
    margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
    margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
    margin-bottom: 0;
    line-height: 1.5;
}

.offcanvas-body {
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto;
}

.placeholder {
    display: inline-block;
    min-height: 1em;
    vertical-align: middle;
    cursor: wait;
    background-color: currentcolor;
    opacity: 0.5;
}

.placeholder.btn::before {
    display: inline-block;
    content: "";
}

.placeholder-xs {
    min-height: 0.6em;
}

.placeholder-sm {
    min-height: 0.8em;
}

.placeholder-lg {
    min-height: 1.2em;
}

.placeholder-glow .placeholder {
    animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
    50% {
        opacity: 0.2;
    }
}

.placeholder-wave {
    mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
    mask-size: 200% 100%;
    animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
    100% {
        mask-position: -200% 0%;
    }
}

.clearfix::after {
    display: block;
    clear: both;
    content: "";
}

.text-bg-primary {
    color: #fff !important;
    background-color: RGBA(26, 188, 156, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
    color: #fff !important;
    background-color: RGBA(44, 62, 80, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
    color: #fff !important;
    background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
    color: #000 !important;
    background-color: RGBA(13, 202, 240, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
    color: #000 !important;
    background-color: RGBA(255, 193, 7, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
    color: #fff !important;
    background-color: RGBA(220, 53, 69, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
    color: #000 !important;
    background-color: RGBA(248, 249, 250, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
    color: #fff !important;
    background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
    color: #0085CA !important;
}

.link-primary:hover,
.link-primary:focus {
    color: #15967d !important;
}

.link-secondary {
    color: #2c3e50 !important;
}

.link-secondary:hover,
.link-secondary:focus {
    color: #233240 !important;
}

.link-success {
    color: #198754 !important;
}

.link-success:hover,
.link-success:focus {
    color: #146c43 !important;
}

.link-info {
    color: #0dcaf0 !important;
}

.link-info:hover,
.link-info:focus {
    color: #3dd5f3 !important;
}

.link-warning {
    color: #ffc107 !important;
}

.link-warning:hover,
.link-warning:focus {
    color: #ffcd39 !important;
}

.link-danger {
    color: #dc3545 !important;
}

.link-danger:hover,
.link-danger:focus {
    color: #b02a37 !important;
}

.link-light {
    color: #f8f9fa !important;
}

.link-light:hover,
.link-light:focus {
    color: #f9fafb !important;
}

.link-dark {
    color: #212529 !important;
}

.link-dark:hover,
.link-dark:focus {
    color: #1a1e21 !important;
}

.ratio {
    position: relative;
    width: 100%;
}

.ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: "";
}

.ratio>* {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.ratio-1x1 {
    --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
    --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
    --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
    --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
}

.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
}

.sticky-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
}

@media (min-width: 576px) {
    .sticky-sm-top {
        position: sticky;
        top: 0;
        z-index: 1020;
    }

    .sticky-sm-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020;
    }
}

@media (min-width: 768px) {
    .sticky-md-top {
        position: sticky;
        top: 0;
        z-index: 1020;
    }

    .sticky-md-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020;
    }
}

@media (min-width: 992px) {
    .sticky-lg-top {
        position: sticky;
        top: 0;
        z-index: 1020;
    }

    .sticky-lg-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020;
    }
}

@media (min-width: 1200px) {
    .sticky-xl-top {
        position: sticky;
        top: 0;
        z-index: 1020;
    }

    .sticky-xl-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020;
    }
}

@media (min-width: 1400px) {
    .sticky-xxl-top {
        position: sticky;
        top: 0;
        z-index: 1020;
    }

    .sticky-xxl-bottom {
        position: sticky;
        bottom: 0;
        z-index: 1020;
    }
}

.hstack {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
}

.vstack {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
}

.stretched-link::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    content: "";
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.vr {
    display: inline-block;
    align-self: stretch;
    width: 1px;
    min-height: 1em;
    background-color: currentcolor;
    opacity: 0.25;
}

.align-baseline {
    vertical-align: baseline !important;
}

.align-top {
    vertical-align: top !important;
}

.align-middle {
    vertical-align: middle !important;
}

.align-bottom {
    vertical-align: bottom !important;
}

.align-text-bottom {
    vertical-align: text-bottom !important;
}

.align-text-top {
    vertical-align: text-top !important;
}

.float-start {
    float: left !important;
}

.float-end {
    float: right !important;
}

.float-none {
    float: none !important;
}

.opacity-0 {
    opacity: 0 !important;
}

.opacity-25 {
    opacity: 0.25 !important;
}

.opacity-50 {
    opacity: 0.5 !important;
}

.opacity-75 {
    opacity: 0.75 !important;
}

.opacity-100 {
    opacity: 1 !important;
}

.overflow-auto {
    overflow: auto !important;
}

.overflow-hidden {
    overflow: hidden !important;
}

.overflow-visible {
    overflow: visible !important;
}

.overflow-scroll {
    overflow: scroll !important;
}

.d-inline {
    display: inline !important;
}

.d-inline-block {
    display: inline-block !important;
}

.d-block {
    display: block !important;
}

.d-grid {
    display: grid !important;
}

.d-table {
    display: table !important;
}

.d-table-row {
    display: table-row !important;
}

.d-table-cell {
    display: table-cell !important;
}

.d-flex {
    display: flex !important;
}

.d-inline-flex {
    display: inline-flex !important;
}

.d-none {
    display: none !important;
}

.shadow {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
    box-shadow: none !important;
}

.position-static {
    position: static !important;
}

.position-relative {
    position: relative !important;
}

.position-absolute {
    position: absolute !important;
}

.position-fixed {
    position: fixed !important;
}

.position-sticky {
    position: sticky !important;
}

.top-0 {
    top: 0 !important;
}

.top-50 {
    top: 50% !important;
}

.top-100 {
    top: 100% !important;
}

.bottom-0 {
    bottom: 0 !important;
}

.bottom-50 {
    bottom: 50% !important;
}

.bottom-100 {
    bottom: 100% !important;
}

.start-0 {
    left: 0 !important;
}

.start-50 {
    left: 50% !important;
}

.start-100 {
    left: 100% !important;
}

.end-0 {
    right: 0 !important;
}

.end-50 {
    right: 50% !important;
}

.end-100 {
    right: 100% !important;
}

.translate-middle {
    transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
    transform: translateX(-50%) !important;
}

.translate-middle-y {
    transform: translateY(-50%) !important;
}

.border {
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
    border: 0 !important;
}

.border-top {
    border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
    border-top: 0 !important;
}

.border-end {
    border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
    border-right: 0 !important;
}

.border-bottom {
    border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
    border-bottom: 0 !important;
}

.border-start {
    border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
    border-left: 0 !important;
}

.border-primary {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
    --bs-border-opacity: 1;
    border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-1 {
    --bs-border-width: 1px;
}

.border-2 {
    --bs-border-width: 2px;
}

.border-3 {
    --bs-border-width: 3px;
}

.border-4 {
    --bs-border-width: 4px;
}

.border-5 {
    --bs-border-width: 5px;
}

.border-opacity-10 {
    --bs-border-opacity: 0.1;
}

.border-opacity-25 {
    --bs-border-opacity: 0.25;
}

.border-opacity-50 {
    --bs-border-opacity: 0.5;
}

.border-opacity-75 {
    --bs-border-opacity: 0.75;
}

.border-opacity-100 {
    --bs-border-opacity: 1;
}

.w-25 {
    width: 25% !important;
}

.w-50 {
    width: 50% !important;
}

.w-75 {
    width: 75% !important;
}

.w-100 {
    width: 100% !important;
}

.w-auto {
    width: auto !important;
}

.mw-100 {
    max-width: 100% !important;
}

.vw-100 {
    width: 100vw !important;
}

.min-vw-100 {
    min-width: 100vw !important;
}

.h-25 {
    height: 25% !important;
}

.h-50 {
    height: 50% !important;
}

.h-75 {
    height: 75% !important;
}

.h-100 {
    height: 100% !important;
}

.h-auto {
    height: auto !important;
}

.mh-100 {
    max-height: 100% !important;
}

.vh-100 {
    height: 100vh !important;
}

.min-vh-100 {
    min-height: 100vh !important;
}

.flex-fill {
    flex: 1 1 auto !important;
}

.flex-row {
    flex-direction: row !important;
}

.flex-column {
    flex-direction: column !important;
}

.flex-row-reverse {
    flex-direction: row-reverse !important;
}

.flex-column-reverse {
    flex-direction: column-reverse !important;
}

.flex-grow-0 {
    flex-grow: 0 !important;
}

.flex-grow-1 {
    flex-grow: 1 !important;
}

.flex-shrink-0 {
    flex-shrink: 0 !important;
}

.flex-shrink-1 {
    flex-shrink: 1 !important;
}

.flex-wrap {
    flex-wrap: wrap !important;
}

.flex-nowrap {
    flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
    flex-wrap: wrap-reverse !important;
}

.justify-content-start {
    justify-content: flex-start !important;
}

.justify-content-end {
    justify-content: flex-end !important;
}

.justify-content-center {
    justify-content: center !important;
}

.justify-content-between {
    justify-content: space-between !important;
}

.justify-content-around {
    justify-content: space-around !important;
}

.justify-content-evenly {
    justify-content: space-evenly !important;
}

.align-items-start {
    align-items: flex-start !important;
}

.align-items-end {
    align-items: flex-end !important;
}

.align-items-center {
    align-items: center !important;
}

.align-items-baseline {
    align-items: baseline !important;
}

.align-items-stretch {
    align-items: stretch !important;
}

.align-content-start {
    align-content: flex-start !important;
}

.align-content-end {
    align-content: flex-end !important;
}

.align-content-center {
    align-content: center !important;
}

.align-content-between {
    align-content: space-between !important;
}

.align-content-around {
    align-content: space-around !important;
}

.align-content-stretch {
    align-content: stretch !important;
}

.align-self-auto {
    align-self: auto !important;
}

.align-self-start {
    align-self: flex-start !important;
}

.align-self-end {
    align-self: flex-end !important;
}

.align-self-center {
    align-self: center !important;
}

.align-self-baseline {
    align-self: baseline !important;
}

.align-self-stretch {
    align-self: stretch !important;
}

.order-first {
    order: -1 !important;
}

.order-0 {
    order: 0 !important;
}

.order-1 {
    order: 1 !important;
}

.order-2 {
    order: 2 !important;
}

.order-3 {
    order: 3 !important;
}

.order-4 {
    order: 4 !important;
}

.order-5 {
    order: 5 !important;
}

.order-last {
    order: 6 !important;
}

.m-0 {
    margin: 0 !important;
}

.m-1 {
    margin: 0.25rem !important;
}

.m-2 {
    margin: 0.5rem !important;
}

.m-3 {
    margin: 1rem !important;
}

.m-4 {
    margin: 1.5rem !important;
}

.m-5 {
    margin: 3rem !important;
}

.m-auto {
    margin: auto !important;
}

.mx-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
}

.mx-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
}

.mx-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
}

.mx-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
}

.mx-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
}

.mx-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
}

.mx-auto {
    margin-right: auto !important;
    margin-left: auto !important;
}

.my-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

.my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
}

.my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
}

.my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
}

.my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
}

.my-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
}

.my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
}

.mt-0 {
    margin-top: 0 !important;
}

.mt-1 {
    margin-top: 0.25rem !important;
}

.mt-2 {
    margin-top: 0.5rem !important;
}

.mt-3 {
    margin-top: 1rem !important;
}

.mt-4 {
    margin-top: 1.5rem !important;
}

.mt-5 {
    margin-top: 3rem !important;
}

.mt-auto {
    margin-top: auto !important;
}

.me-0 {
    margin-right: 0 !important;
}

.me-1 {
    margin-right: 0.25rem !important;
}

.me-2 {
    margin-right: 0.5rem !important;
}

.me-3 {
    margin-right: 1rem !important;
}

.me-4 {
    margin-right: 1.5rem !important;
}

.me-5 {
    margin-right: 3rem !important;
}

.me-auto {
    margin-right: auto !important;
}

.mb-0 {
    margin-bottom: 0 !important;
}

.mb-1 {
    margin-bottom: 0.25rem !important;
}

.mb-2 {
    margin-bottom: 0.5rem !important;
}

.mb-3 {
    margin-bottom: 1rem !important;
}

.mb-4 {
    margin-bottom: 1.5rem !important;
}

.mb-5 {
    margin-bottom: 3rem !important;
}

.mb-auto {
    margin-bottom: auto !important;
}

.ms-0 {
    margin-left: 0 !important;
}

.ms-1 {
    margin-left: 0.25rem !important;
}

.ms-2 {
    margin-left: 0.5rem !important;
}

.ms-3 {
    margin-left: 1rem !important;
}

.ms-4 {
    margin-left: 1.5rem !important;
}

.ms-5 {
    margin-left: 3rem !important;
}

.ms-auto {
    margin-left: auto !important;
}

.p-0 {
    padding: 0 !important;
}

.p-1 {
    padding: 0.25rem !important;
}

.p-2 {
    padding: 0.5rem !important;
}

.p-3 {
    padding: 1rem !important;
}

.p-4 {
    padding: 1.5rem !important;
}

.p-5 {
    padding: 3rem !important;
}

.px-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
}

.px-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
}

.px-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
}

.px-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
}

.px-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
}

.px-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
}

.py-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}

.py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}

.py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}

.py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
}

.py-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
}

.pt-0 {
    padding-top: 0 !important;
}

.pt-1 {
    padding-top: 0.25rem !important;
}

.pt-2 {
    padding-top: 0.5rem !important;
}

.pt-3 {
    padding-top: 1rem !important;
}

.pt-4 {
    padding-top: 1.5rem !important;
}

.pt-5 {
    padding-top: 3rem !important;
}

.pe-0 {
    padding-right: 0 !important;
}

.pe-1 {
    padding-right: 0.25rem !important;
}

.pe-2 {
    padding-right: 0.5rem !important;
}

.pe-3 {
    padding-right: 1rem !important;
}

.pe-4 {
    padding-right: 1.5rem !important;
}

.pe-5 {
    padding-right: 3rem !important;
}

.pb-0 {
    padding-bottom: 0 !important;
}

.pb-1 {
    padding-bottom: 0.25rem !important;
}

.pb-2 {
    padding-bottom: 0.5rem !important;
}

.pb-3 {
    padding-bottom: 1rem !important;
}

.pb-4 {
    padding-bottom: 1.5rem !important;
}

.pb-5 {
    padding-bottom: 3rem !important;
}

.ps-0 {
    padding-left: 0 !important;
}

.ps-1 {
    padding-left: 0.25rem !important;
}

.ps-2 {
    padding-left: 0.5rem !important;
}

.ps-3 {
    padding-left: 1rem !important;
}

.ps-4 {
    padding-left: 1.5rem !important;
}

.ps-5 {
    padding-left: 3rem !important;
}

.gap-0 {
    gap: 0 !important;
}

.gap-1 {
    gap: 0.25rem !important;
}

.gap-2 {
    gap: 0.5rem !important;
}

.gap-3 {
    gap: 1rem !important;
}

.gap-4 {
    gap: 1.5rem !important;
}

.gap-5 {
    gap: 3rem !important;
}

.font-monospace {
    font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
    font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
    font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
    font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
    font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
    font-size: 1.25rem !important;
}

.fs-6 {
    font-size: 1rem !important;
}

.fst-italic {
    font-style: italic !important;
}

.fst-normal {
    font-style: normal !important;
}

.fw-light {
    font-weight: 300 !important;
}

.fw-lighter {
    font-weight: lighter !important;
}

.fw-normal {
    font-weight: 400 !important;
}

.fw-bold {
    font-weight: 700 !important;
}

.fw-semibold {
    font-weight: 600 !important;
}

.fw-bolder {
    font-weight: bolder !important;
}

.lh-1 {
    line-height: 1 !important;
}

.lh-sm {
    line-height: 1.25 !important;
}

.lh-base {
    line-height: 1.5 !important;
}

.lh-lg {
    line-height: 2 !important;
}

.text-start {
    text-align: left !important;
}

.text-end {
    text-align: right !important;
}

.text-center {
    text-align: center !important;
}

.text-decoration-none {
    text-decoration: none !important;
}

.text-decoration-underline {
    text-decoration: underline !important;
}

.text-decoration-line-through {
    text-decoration: line-through !important;
}

.text-lowercase {
    text-transform: lowercase !important;
}

.text-uppercase {
    text-transform: uppercase !important;
}

.text-capitalize {
    text-transform: capitalize !important;
}

.text-wrap {
    white-space: normal !important;
}

.text-nowrap {
    white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
    word-wrap: break-word !important;
    word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
    --bs-text-opacity: 1;
    color: #6c757d !important;
}

.text-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
}

.text-opacity-25 {
    --bs-text-opacity: 0.25;
}

.text-opacity-50 {
    --bs-text-opacity: 0.5;
}

.text-opacity-75 {
    --bs-text-opacity: 0.75;
}

.text-opacity-100 {
    --bs-text-opacity: 1;
}

.bg-primary {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
    --bs-bg-opacity: 1;
    background-color: transparent !important;
}

.bg-opacity-10 {
    --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
    --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
    --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
    --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
    --bs-bg-opacity: 1;
}

.bg-gradient {
    background-image: var(--bs-gradient) !important;
}

.user-select-all {
    -webkit-user-select: all !important;
    user-select: all !important;
}

.user-select-auto {
    -webkit-user-select: auto !important;
    user-select: auto !important;
}

.user-select-none {
    -webkit-user-select: none !important;
    user-select: none !important;
}

.pe-none {
    pointer-events: none !important;
}

.pe-auto {
    pointer-events: auto !important;
}

.rounded {
    border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
    border-radius: 0 !important;
}

.rounded-1 {
    border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
    border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
    border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
    border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
    border-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-circle {
    border-radius: 50% !important;
}

.rounded-pill {
    border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
    border-top-left-radius: var(--bs-border-radius) !important;
    border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-end {
    border-top-right-radius: var(--bs-border-radius) !important;
    border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-bottom {
    border-bottom-right-radius: var(--bs-border-radius) !important;
    border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-start {
    border-bottom-left-radius: var(--bs-border-radius) !important;
    border-top-left-radius: var(--bs-border-radius) !important;
}

.visible {
    visibility: visible !important;
}

.invisible {
    visibility: hidden !important;
}

@media (min-width: 576px) {
    .float-sm-start {
        float: left !important;
    }

    .float-sm-end {
        float: right !important;
    }

    .float-sm-none {
        float: none !important;
    }

    .d-sm-inline {
        display: inline !important;
    }

    .d-sm-inline-block {
        display: inline-block !important;
    }

    .d-sm-block {
        display: block !important;
    }

    .d-sm-grid {
        display: grid !important;
    }

    .d-sm-table {
        display: table !important;
    }

    .d-sm-table-row {
        display: table-row !important;
    }

    .d-sm-table-cell {
        display: table-cell !important;
    }

    .d-sm-flex {
        display: flex !important;
    }

    .d-sm-inline-flex {
        display: inline-flex !important;
    }

    .d-sm-none {
        display: none !important;
    }

    .flex-sm-fill {
        flex: 1 1 auto !important;
    }

    .flex-sm-row {
        flex-direction: row !important;
    }

    .flex-sm-column {
        flex-direction: column !important;
    }

    .flex-sm-row-reverse {
        flex-direction: row-reverse !important;
    }

    .flex-sm-column-reverse {
        flex-direction: column-reverse !important;
    }

    .flex-sm-grow-0 {
        flex-grow: 0 !important;
    }

    .flex-sm-grow-1 {
        flex-grow: 1 !important;
    }

    .flex-sm-shrink-0 {
        flex-shrink: 0 !important;
    }

    .flex-sm-shrink-1 {
        flex-shrink: 1 !important;
    }

    .flex-sm-wrap {
        flex-wrap: wrap !important;
    }

    .flex-sm-nowrap {
        flex-wrap: nowrap !important;
    }

    .flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-sm-start {
        justify-content: flex-start !important;
    }

    .justify-content-sm-end {
        justify-content: flex-end !important;
    }

    .justify-content-sm-center {
        justify-content: center !important;
    }

    .justify-content-sm-between {
        justify-content: space-between !important;
    }

    .justify-content-sm-around {
        justify-content: space-around !important;
    }

    .justify-content-sm-evenly {
        justify-content: space-evenly !important;
    }

    .align-items-sm-start {
        align-items: flex-start !important;
    }

    .align-items-sm-end {
        align-items: flex-end !important;
    }

    .align-items-sm-center {
        align-items: center !important;
    }

    .align-items-sm-baseline {
        align-items: baseline !important;
    }

    .align-items-sm-stretch {
        align-items: stretch !important;
    }

    .align-content-sm-start {
        align-content: flex-start !important;
    }

    .align-content-sm-end {
        align-content: flex-end !important;
    }

    .align-content-sm-center {
        align-content: center !important;
    }

    .align-content-sm-between {
        align-content: space-between !important;
    }

    .align-content-sm-around {
        align-content: space-around !important;
    }

    .align-content-sm-stretch {
        align-content: stretch !important;
    }

    .align-self-sm-auto {
        align-self: auto !important;
    }

    .align-self-sm-start {
        align-self: flex-start !important;
    }

    .align-self-sm-end {
        align-self: flex-end !important;
    }

    .align-self-sm-center {
        align-self: center !important;
    }

    .align-self-sm-baseline {
        align-self: baseline !important;
    }

    .align-self-sm-stretch {
        align-self: stretch !important;
    }

    .order-sm-first {
        order: -1 !important;
    }

    .order-sm-0 {
        order: 0 !important;
    }

    .order-sm-1 {
        order: 1 !important;
    }

    .order-sm-2 {
        order: 2 !important;
    }

    .order-sm-3 {
        order: 3 !important;
    }

    .order-sm-4 {
        order: 4 !important;
    }

    .order-sm-5 {
        order: 5 !important;
    }

    .order-sm-last {
        order: 6 !important;
    }

    .m-sm-0 {
        margin: 0 !important;
    }

    .m-sm-1 {
        margin: 0.25rem !important;
    }

    .m-sm-2 {
        margin: 0.5rem !important;
    }

    .m-sm-3 {
        margin: 1rem !important;
    }

    .m-sm-4 {
        margin: 1.5rem !important;
    }

    .m-sm-5 {
        margin: 3rem !important;
    }

    .m-sm-auto {
        margin: auto !important;
    }

    .mx-sm-0 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .mx-sm-1 {
        margin-right: 0.25rem !important;
        margin-left: 0.25rem !important;
    }

    .mx-sm-2 {
        margin-right: 0.5rem !important;
        margin-left: 0.5rem !important;
    }

    .mx-sm-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important;
    }

    .mx-sm-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important;
    }

    .mx-sm-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important;
    }

    .mx-sm-auto {
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .my-sm-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .my-sm-1 {
        margin-top: 0.25rem !important;
        margin-bottom: 0.25rem !important;
    }

    .my-sm-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }

    .my-sm-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .my-sm-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }

    .my-sm-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
    }

    .my-sm-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    .mt-sm-0 {
        margin-top: 0 !important;
    }

    .mt-sm-1 {
        margin-top: 0.25rem !important;
    }

    .mt-sm-2 {
        margin-top: 0.5rem !important;
    }

    .mt-sm-3 {
        margin-top: 1rem !important;
    }

    .mt-sm-4 {
        margin-top: 1.5rem !important;
    }

    .mt-sm-5 {
        margin-top: 3rem !important;
    }

    .mt-sm-auto {
        margin-top: auto !important;
    }

    .me-sm-0 {
        margin-right: 0 !important;
    }

    .me-sm-1 {
        margin-right: 0.25rem !important;
    }

    .me-sm-2 {
        margin-right: 0.5rem !important;
    }

    .me-sm-3 {
        margin-right: 1rem !important;
    }

    .me-sm-4 {
        margin-right: 1.5rem !important;
    }

    .me-sm-5 {
        margin-right: 3rem !important;
    }

    .me-sm-auto {
        margin-right: auto !important;
    }

    .mb-sm-0 {
        margin-bottom: 0 !important;
    }

    .mb-sm-1 {
        margin-bottom: 0.25rem !important;
    }

    .mb-sm-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-sm-3 {
        margin-bottom: 1rem !important;
    }

    .mb-sm-4 {
        margin-bottom: 1.5rem !important;
    }

    .mb-sm-5 {
        margin-bottom: 3rem !important;
    }

    .mb-sm-auto {
        margin-bottom: auto !important;
    }

    .ms-sm-0 {
        margin-left: 0 !important;
    }

    .ms-sm-1 {
        margin-left: 0.25rem !important;
    }

    .ms-sm-2 {
        margin-left: 0.5rem !important;
    }

    .ms-sm-3 {
        margin-left: 1rem !important;
    }

    .ms-sm-4 {
        margin-left: 1.5rem !important;
    }

    .ms-sm-5 {
        margin-left: 3rem !important;
    }

    .ms-sm-auto {
        margin-left: auto !important;
    }

    .p-sm-0 {
        padding: 0 !important;
    }

    .p-sm-1 {
        padding: 0.25rem !important;
    }

    .p-sm-2 {
        padding: 0.5rem !important;
    }

    .p-sm-3 {
        padding: 1rem !important;
    }

    .p-sm-4 {
        padding: 1.5rem !important;
    }

    .p-sm-5 {
        padding: 3rem !important;
    }

    .px-sm-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .px-sm-1 {
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .px-sm-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .px-sm-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .px-sm-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important;
    }

    .px-sm-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }

    .py-sm-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .py-sm-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }

    .py-sm-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .py-sm-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

    .py-sm-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }

    .py-sm-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .pt-sm-0 {
        padding-top: 0 !important;
    }

    .pt-sm-1 {
        padding-top: 0.25rem !important;
    }

    .pt-sm-2 {
        padding-top: 0.5rem !important;
    }

    .pt-sm-3 {
        padding-top: 1rem !important;
    }

    .pt-sm-4 {
        padding-top: 1.5rem !important;
    }

    .pt-sm-5 {
        padding-top: 3rem !important;
    }

    .pe-sm-0 {
        padding-right: 0 !important;
    }

    .pe-sm-1 {
        padding-right: 0.25rem !important;
    }

    .pe-sm-2 {
        padding-right: 0.5rem !important;
    }

    .pe-sm-3 {
        padding-right: 1rem !important;
    }

    .pe-sm-4 {
        padding-right: 1.5rem !important;
    }

    .pe-sm-5 {
        padding-right: 3rem !important;
    }

    .pb-sm-0 {
        padding-bottom: 0 !important;
    }

    .pb-sm-1 {
        padding-bottom: 0.25rem !important;
    }

    .pb-sm-2 {
        padding-bottom: 0.5rem !important;
    }

    .pb-sm-3 {
        padding-bottom: 1rem !important;
    }

    .pb-sm-4 {
        padding-bottom: 1.5rem !important;
    }

    .pb-sm-5 {
        padding-bottom: 3rem !important;
    }

    .ps-sm-0 {
        padding-left: 0 !important;
    }

    .ps-sm-1 {
        padding-left: 0.25rem !important;
    }

    .ps-sm-2 {
        padding-left: 0.5rem !important;
    }

    .ps-sm-3 {
        padding-left: 1rem !important;
    }

    .ps-sm-4 {
        padding-left: 1.5rem !important;
    }

    .ps-sm-5 {
        padding-left: 3rem !important;
    }

    .gap-sm-0 {
        gap: 0 !important;
    }

    .gap-sm-1 {
        gap: 0.25rem !important;
    }

    .gap-sm-2 {
        gap: 0.5rem !important;
    }

    .gap-sm-3 {
        gap: 1rem !important;
    }

    .gap-sm-4 {
        gap: 1.5rem !important;
    }

    .gap-sm-5 {
        gap: 3rem !important;
    }

    .text-sm-start {
        text-align: left !important;
    }

    .text-sm-end {
        text-align: right !important;
    }

    .text-sm-center {
        text-align: center !important;
    }
}

@media (min-width: 768px) {
    .float-md-start {
        float: left !important;
    }

    .float-md-end {
        float: right !important;
    }

    .float-md-none {
        float: none !important;
    }

    .d-md-inline {
        display: inline !important;
    }

    .d-md-inline-block {
        display: inline-block !important;
    }

    .d-md-block {
        display: block !important;
    }

    .d-md-grid {
        display: grid !important;
    }

    .d-md-table {
        display: table !important;
    }

    .d-md-table-row {
        display: table-row !important;
    }

    .d-md-table-cell {
        display: table-cell !important;
    }

    .d-md-flex {
        display: flex !important;
    }

    .d-md-inline-flex {
        display: inline-flex !important;
    }

    .d-md-none {
        display: none !important;
    }

    .flex-md-fill {
        flex: 1 1 auto !important;
    }

    .flex-md-row {
        flex-direction: row !important;
    }

    .flex-md-column {
        flex-direction: column !important;
    }

    .flex-md-row-reverse {
        flex-direction: row-reverse !important;
    }

    .flex-md-column-reverse {
        flex-direction: column-reverse !important;
    }

    .flex-md-grow-0 {
        flex-grow: 0 !important;
    }

    .flex-md-grow-1 {
        flex-grow: 1 !important;
    }

    .flex-md-shrink-0 {
        flex-shrink: 0 !important;
    }

    .flex-md-shrink-1 {
        flex-shrink: 1 !important;
    }

    .flex-md-wrap {
        flex-wrap: wrap !important;
    }

    .flex-md-nowrap {
        flex-wrap: nowrap !important;
    }

    .flex-md-wrap-reverse {
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-md-start {
        justify-content: flex-start !important;
    }

    .justify-content-md-end {
        justify-content: flex-end !important;
    }

    .justify-content-md-center {
        justify-content: center !important;
    }

    .justify-content-md-between {
        justify-content: space-between !important;
    }

    .justify-content-md-around {
        justify-content: space-around !important;
    }

    .justify-content-md-evenly {
        justify-content: space-evenly !important;
    }

    .align-items-md-start {
        align-items: flex-start !important;
    }

    .align-items-md-end {
        align-items: flex-end !important;
    }

    .align-items-md-center {
        align-items: center !important;
    }

    .align-items-md-baseline {
        align-items: baseline !important;
    }

    .align-items-md-stretch {
        align-items: stretch !important;
    }

    .align-content-md-start {
        align-content: flex-start !important;
    }

    .align-content-md-end {
        align-content: flex-end !important;
    }

    .align-content-md-center {
        align-content: center !important;
    }

    .align-content-md-between {
        align-content: space-between !important;
    }

    .align-content-md-around {
        align-content: space-around !important;
    }

    .align-content-md-stretch {
        align-content: stretch !important;
    }

    .align-self-md-auto {
        align-self: auto !important;
    }

    .align-self-md-start {
        align-self: flex-start !important;
    }

    .align-self-md-end {
        align-self: flex-end !important;
    }

    .align-self-md-center {
        align-self: center !important;
    }

    .align-self-md-baseline {
        align-self: baseline !important;
    }

    .align-self-md-stretch {
        align-self: stretch !important;
    }

    .order-md-first {
        order: -1 !important;
    }

    .order-md-0 {
        order: 0 !important;
    }

    .order-md-1 {
        order: 1 !important;
    }

    .order-md-2 {
        order: 2 !important;
    }

    .order-md-3 {
        order: 3 !important;
    }

    .order-md-4 {
        order: 4 !important;
    }

    .order-md-5 {
        order: 5 !important;
    }

    .order-md-last {
        order: 6 !important;
    }

    .m-md-0 {
        margin: 0 !important;
    }

    .m-md-1 {
        margin: 0.25rem !important;
    }

    .m-md-2 {
        margin: 0.5rem !important;
    }

    .m-md-3 {
        margin: 1rem !important;
    }

    .m-md-4 {
        margin: 1.5rem !important;
    }

    .m-md-5 {
        margin: 3rem !important;
    }

    .m-md-auto {
        margin: auto !important;
    }

    .mx-md-0 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .mx-md-1 {
        margin-right: 0.25rem !important;
        margin-left: 0.25rem !important;
    }

    .mx-md-2 {
        margin-right: 0.5rem !important;
        margin-left: 0.5rem !important;
    }

    .mx-md-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important;
    }

    .mx-md-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important;
    }

    .mx-md-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important;
    }

    .mx-md-auto {
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .my-md-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .my-md-1 {
        margin-top: 0.25rem !important;
        margin-bottom: 0.25rem !important;
    }

    .my-md-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }

    .my-md-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .my-md-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }

    .my-md-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
    }

    .my-md-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    .mt-md-0 {
        margin-top: 0 !important;
    }

    .mt-md-1 {
        margin-top: 0.25rem !important;
    }

    .mt-md-2 {
        margin-top: 0.5rem !important;
    }

    .mt-md-3 {
        margin-top: 1rem !important;
    }

    .mt-md-4 {
        margin-top: 1.5rem !important;
    }

    .mt-md-5 {
        margin-top: 3rem !important;
    }

    .mt-md-auto {
        margin-top: auto !important;
    }

    .me-md-0 {
        margin-right: 0 !important;
    }

    .me-md-1 {
        margin-right: 0.25rem !important;
    }

    .me-md-2 {
        margin-right: 0.5rem !important;
    }

    .me-md-3 {
        margin-right: 1rem !important;
    }

    .me-md-4 {
        margin-right: 1.5rem !important;
    }

    .me-md-5 {
        margin-right: 3rem !important;
    }

    .me-md-auto {
        margin-right: auto !important;
    }

    .mb-md-0 {
        margin-bottom: 0 !important;
    }

    .mb-md-1 {
        margin-bottom: 0.25rem !important;
    }

    .mb-md-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-md-3 {
        margin-bottom: 1rem !important;
    }

    .mb-md-4 {
        margin-bottom: 1.5rem !important;
    }

    .mb-md-5 {
        margin-bottom: 3rem !important;
    }

    .mb-md-auto {
        margin-bottom: auto !important;
    }

    .ms-md-0 {
        margin-left: 0 !important;
    }

    .ms-md-1 {
        margin-left: 0.25rem !important;
    }

    .ms-md-2 {
        margin-left: 0.5rem !important;
    }

    .ms-md-3 {
        margin-left: 1rem !important;
    }

    .ms-md-4 {
        margin-left: 1.5rem !important;
    }

    .ms-md-5 {
        margin-left: 3rem !important;
    }

    .ms-md-auto {
        margin-left: auto !important;
    }

    .p-md-0 {
        padding: 0 !important;
    }

    .p-md-1 {
        padding: 0.25rem !important;
    }

    .p-md-2 {
        padding: 0.5rem !important;
    }

    .p-md-3 {
        padding: 1rem !important;
    }

    .p-md-4 {
        padding: 1.5rem !important;
    }

    .p-md-5 {
        padding: 3rem !important;
    }

    .px-md-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .px-md-1 {
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .px-md-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .px-md-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .px-md-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important;
    }

    .px-md-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }

    .py-md-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .py-md-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }

    .py-md-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .py-md-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

    .py-md-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }

    .py-md-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .pt-md-0 {
        padding-top: 0 !important;
    }

    .pt-md-1 {
        padding-top: 0.25rem !important;
    }

    .pt-md-2 {
        padding-top: 0.5rem !important;
    }

    .pt-md-3 {
        padding-top: 1rem !important;
    }

    .pt-md-4 {
        padding-top: 1.5rem !important;
    }

    .pt-md-5 {
        padding-top: 3rem !important;
    }

    .pe-md-0 {
        padding-right: 0 !important;
    }

    .pe-md-1 {
        padding-right: 0.25rem !important;
    }

    .pe-md-2 {
        padding-right: 0.5rem !important;
    }

    .pe-md-3 {
        padding-right: 1rem !important;
    }

    .pe-md-4 {
        padding-right: 1.5rem !important;
    }

    .pe-md-5 {
        padding-right: 3rem !important;
    }

    .pb-md-0 {
        padding-bottom: 0 !important;
    }

    .pb-md-1 {
        padding-bottom: 0.25rem !important;
    }

    .pb-md-2 {
        padding-bottom: 0.5rem !important;
    }

    .pb-md-3 {
        padding-bottom: 1rem !important;
    }

    .pb-md-4 {
        padding-bottom: 1.5rem !important;
    }

    .pb-md-5 {
        padding-bottom: 3rem !important;
    }

    .ps-md-0 {
        padding-left: 0 !important;
    }

    .ps-md-1 {
        padding-left: 0.25rem !important;
    }

    .ps-md-2 {
        padding-left: 0.5rem !important;
    }

    .ps-md-3 {
        padding-left: 1rem !important;
    }

    .ps-md-4 {
        padding-left: 1.5rem !important;
    }

    .ps-md-5 {
        padding-left: 3rem !important;
    }

    .gap-md-0 {
        gap: 0 !important;
    }

    .gap-md-1 {
        gap: 0.25rem !important;
    }

    .gap-md-2 {
        gap: 0.5rem !important;
    }

    .gap-md-3 {
        gap: 1rem !important;
    }

    .gap-md-4 {
        gap: 1.5rem !important;
    }

    .gap-md-5 {
        gap: 3rem !important;
    }

    .text-md-start {
        text-align: left !important;
    }

    .text-md-end {
        text-align: right !important;
    }

    .text-md-center {
        text-align: center !important;
    }
}

@media (min-width: 992px) {
    .float-lg-start {
        float: left !important;
    }

    .float-lg-end {
        float: right !important;
    }

    .float-lg-none {
        float: none !important;
    }

    .d-lg-inline {
        display: inline !important;
    }

    .d-lg-inline-block {
        display: inline-block !important;
    }

    .d-lg-block {
        display: block !important;
    }

    .d-lg-grid {
        display: grid !important;
    }

    .d-lg-table {
        display: table !important;
    }

    .d-lg-table-row {
        display: table-row !important;
    }

    .d-lg-table-cell {
        display: table-cell !important;
    }

    .d-lg-flex {
        display: flex !important;
    }

    .d-lg-inline-flex {
        display: inline-flex !important;
    }

    .d-lg-none {
        display: none !important;
    }

    .flex-lg-fill {
        flex: 1 1 auto !important;
    }

    .flex-lg-row {
        flex-direction: row !important;
    }

    .flex-lg-column {
        flex-direction: column !important;
    }

    .flex-lg-row-reverse {
        flex-direction: row-reverse !important;
    }

    .flex-lg-column-reverse {
        flex-direction: column-reverse !important;
    }

    .flex-lg-grow-0 {
        flex-grow: 0 !important;
    }

    .flex-lg-grow-1 {
        flex-grow: 1 !important;
    }

    .flex-lg-shrink-0 {
        flex-shrink: 0 !important;
    }

    .flex-lg-shrink-1 {
        flex-shrink: 1 !important;
    }

    .flex-lg-wrap {
        flex-wrap: wrap !important;
    }

    .flex-lg-nowrap {
        flex-wrap: nowrap !important;
    }

    .flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-lg-start {
        justify-content: flex-start !important;
    }

    .justify-content-lg-end {
        justify-content: flex-end !important;
    }

    .justify-content-lg-center {
        justify-content: center !important;
    }

    .justify-content-lg-between {
        justify-content: space-between !important;
    }

    .justify-content-lg-around {
        justify-content: space-around !important;
    }

    .justify-content-lg-evenly {
        justify-content: space-evenly !important;
    }

    .align-items-lg-start {
        align-items: flex-start !important;
    }

    .align-items-lg-end {
        align-items: flex-end !important;
    }

    .align-items-lg-center {
        align-items: center !important;
    }

    .align-items-lg-baseline {
        align-items: baseline !important;
    }

    .align-items-lg-stretch {
        align-items: stretch !important;
    }

    .align-content-lg-start {
        align-content: flex-start !important;
    }

    .align-content-lg-end {
        align-content: flex-end !important;
    }

    .align-content-lg-center {
        align-content: center !important;
    }

    .align-content-lg-between {
        align-content: space-between !important;
    }

    .align-content-lg-around {
        align-content: space-around !important;
    }

    .align-content-lg-stretch {
        align-content: stretch !important;
    }

    .align-self-lg-auto {
        align-self: auto !important;
    }

    .align-self-lg-start {
        align-self: flex-start !important;
    }

    .align-self-lg-end {
        align-self: flex-end !important;
    }

    .align-self-lg-center {
        align-self: center !important;
    }

    .align-self-lg-baseline {
        align-self: baseline !important;
    }

    .align-self-lg-stretch {
        align-self: stretch !important;
    }

    .order-lg-first {
        order: -1 !important;
    }

    .order-lg-0 {
        order: 0 !important;
    }

    .order-lg-1 {
        order: 1 !important;
    }

    .order-lg-2 {
        order: 2 !important;
    }

    .order-lg-3 {
        order: 3 !important;
    }

    .order-lg-4 {
        order: 4 !important;
    }

    .order-lg-5 {
        order: 5 !important;
    }

    .order-lg-last {
        order: 6 !important;
    }

    .m-lg-0 {
        margin: 0 !important;
    }

    .m-lg-1 {
        margin: 0.25rem !important;
    }

    .m-lg-2 {
        margin: 0.5rem !important;
    }

    .m-lg-3 {
        margin: 1rem !important;
    }

    .m-lg-4 {
        margin: 1.5rem !important;
    }

    .m-lg-5 {
        margin: 3rem !important;
    }

    .m-lg-auto {
        margin: auto !important;
    }

    .mx-lg-0 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .mx-lg-1 {
        margin-right: 0.25rem !important;
        margin-left: 0.25rem !important;
    }

    .mx-lg-2 {
        margin-right: 0.5rem !important;
        margin-left: 0.5rem !important;
    }

    .mx-lg-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important;
    }

    .mx-lg-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important;
    }

    .mx-lg-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important;
    }

    .mx-lg-auto {
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .my-lg-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .my-lg-1 {
        margin-top: 0.25rem !important;
        margin-bottom: 0.25rem !important;
    }

    .my-lg-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }

    .my-lg-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .my-lg-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }

    .my-lg-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
    }

    .my-lg-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    .mt-lg-0 {
        margin-top: 0 !important;
    }

    .mt-lg-1 {
        margin-top: 0.25rem !important;
    }

    .mt-lg-2 {
        margin-top: 0.5rem !important;
    }

    .mt-lg-3 {
        margin-top: 1rem !important;
    }

    .mt-lg-4 {
        margin-top: 1.5rem !important;
    }

    .mt-lg-5 {
        margin-top: 3rem !important;
    }

    .mt-lg-auto {
        margin-top: auto !important;
    }

    .me-lg-0 {
        margin-right: 0 !important;
    }

    .me-lg-1 {
        margin-right: 0.25rem !important;
    }

    .me-lg-2 {
        margin-right: 0.5rem !important;
    }

    .me-lg-3 {
        margin-right: 1rem !important;
    }

    .me-lg-4 {
        margin-right: 1.5rem !important;
    }

    .me-lg-5 {
        margin-right: 3rem !important;
    }

    .me-lg-auto {
        margin-right: auto !important;
    }

    .mb-lg-0 {
        margin-bottom: 0 !important;
    }

    .mb-lg-1 {
        margin-bottom: 0.25rem !important;
    }

    .mb-lg-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-lg-3 {
        margin-bottom: 1rem !important;
    }

    .mb-lg-4 {
        margin-bottom: 1.5rem !important;
    }

    .mb-lg-5 {
        margin-bottom: 3rem !important;
    }

    .mb-lg-auto {
        margin-bottom: auto !important;
    }

    .ms-lg-0 {
        margin-left: 0 !important;
    }

    .ms-lg-1 {
        margin-left: 0.25rem !important;
    }

    .ms-lg-2 {
        margin-left: 0.5rem !important;
    }

    .ms-lg-3 {
        margin-left: 1rem !important;
    }

    .ms-lg-4 {
        margin-left: 1.5rem !important;
    }

    .ms-lg-5 {
        margin-left: 3rem !important;
    }

    .ms-lg-auto {
        margin-left: auto !important;
    }

    .p-lg-0 {
        padding: 0 !important;
    }

    .p-lg-1 {
        padding: 0.25rem !important;
    }

    .p-lg-2 {
        padding: 0.5rem !important;
    }

    .p-lg-3 {
        padding: 1rem !important;
    }

    .p-lg-4 {
        padding: 1.5rem !important;
    }

    .p-lg-5 {
        padding: 3rem !important;
    }

    .px-lg-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .px-lg-1 {
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .px-lg-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .px-lg-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .px-lg-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important;
    }

    .px-lg-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }

    .py-lg-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .py-lg-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }

    .py-lg-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .py-lg-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

    .py-lg-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }

    .py-lg-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .pt-lg-0 {
        padding-top: 0 !important;
    }

    .pt-lg-1 {
        padding-top: 0.25rem !important;
    }

    .pt-lg-2 {
        padding-top: 0.5rem !important;
    }

    .pt-lg-3 {
        padding-top: 1rem !important;
    }

    .pt-lg-4 {
        padding-top: 1.5rem !important;
    }

    .pt-lg-5 {
        padding-top: 3rem !important;
    }

    .pe-lg-0 {
        padding-right: 0 !important;
    }

    .pe-lg-1 {
        padding-right: 0.25rem !important;
    }

    .pe-lg-2 {
        padding-right: 0.5rem !important;
    }

    .pe-lg-3 {
        padding-right: 1rem !important;
    }

    .pe-lg-4 {
        padding-right: 1.5rem !important;
    }

    .pe-lg-5 {
        padding-right: 3rem !important;
    }

    .pb-lg-0 {
        padding-bottom: 0 !important;
    }

    .pb-lg-1 {
        padding-bottom: 0.25rem !important;
    }

    .pb-lg-2 {
        padding-bottom: 0.5rem !important;
    }

    .pb-lg-3 {
        padding-bottom: 1rem !important;
    }

    .pb-lg-4 {
        padding-bottom: 1.5rem !important;
    }

    .pb-lg-5 {
        padding-bottom: 3rem !important;
    }

    .ps-lg-0 {
        padding-left: 0 !important;
    }

    .ps-lg-1 {
        padding-left: 0.25rem !important;
    }

    .ps-lg-2 {
        padding-left: 0.5rem !important;
    }

    .ps-lg-3 {
        padding-left: 1rem !important;
    }

    .ps-lg-4 {
        padding-left: 1.5rem !important;
    }

    .ps-lg-5 {
        padding-left: 3rem !important;
    }

    .gap-lg-0 {
        gap: 0 !important;
    }

    .gap-lg-1 {
        gap: 0.25rem !important;
    }

    .gap-lg-2 {
        gap: 0.5rem !important;
    }

    .gap-lg-3 {
        gap: 1rem !important;
    }

    .gap-lg-4 {
        gap: 1.5rem !important;
    }

    .gap-lg-5 {
        gap: 3rem !important;
    }

    .text-lg-start {
        text-align: left !important;
    }

    .text-lg-end {
        text-align: right !important;
    }

    .text-lg-center {
        text-align: center !important;
    }
}

@media (min-width: 1200px) {
    .float-xl-start {
        float: left !important;
    }

    .float-xl-end {
        float: right !important;
    }

    .float-xl-none {
        float: none !important;
    }

    .d-xl-inline {
        display: inline !important;
    }

    .d-xl-inline-block {
        display: inline-block !important;
    }

    .d-xl-block {
        display: block !important;
    }

    .d-xl-grid {
        display: grid !important;
    }

    .d-xl-table {
        display: table !important;
    }

    .d-xl-table-row {
        display: table-row !important;
    }

    .d-xl-table-cell {
        display: table-cell !important;
    }

    .d-xl-flex {
        display: flex !important;
    }

    .d-xl-inline-flex {
        display: inline-flex !important;
    }

    .d-xl-none {
        display: none !important;
    }

    .flex-xl-fill {
        flex: 1 1 auto !important;
    }

    .flex-xl-row {
        flex-direction: row !important;
    }

    .flex-xl-column {
        flex-direction: column !important;
    }

    .flex-xl-row-reverse {
        flex-direction: row-reverse !important;
    }

    .flex-xl-column-reverse {
        flex-direction: column-reverse !important;
    }

    .flex-xl-grow-0 {
        flex-grow: 0 !important;
    }

    .flex-xl-grow-1 {
        flex-grow: 1 !important;
    }

    .flex-xl-shrink-0 {
        flex-shrink: 0 !important;
    }

    .flex-xl-shrink-1 {
        flex-shrink: 1 !important;
    }

    .flex-xl-wrap {
        flex-wrap: wrap !important;
    }

    .flex-xl-nowrap {
        flex-wrap: nowrap !important;
    }

    .flex-xl-wrap-reverse {
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-xl-start {
        justify-content: flex-start !important;
    }

    .justify-content-xl-end {
        justify-content: flex-end !important;
    }

    .justify-content-xl-center {
        justify-content: center !important;
    }

    .justify-content-xl-between {
        justify-content: space-between !important;
    }

    .justify-content-xl-around {
        justify-content: space-around !important;
    }

    .justify-content-xl-evenly {
        justify-content: space-evenly !important;
    }

    .align-items-xl-start {
        align-items: flex-start !important;
    }

    .align-items-xl-end {
        align-items: flex-end !important;
    }

    .align-items-xl-center {
        align-items: center !important;
    }

    .align-items-xl-baseline {
        align-items: baseline !important;
    }

    .align-items-xl-stretch {
        align-items: stretch !important;
    }

    .align-content-xl-start {
        align-content: flex-start !important;
    }

    .align-content-xl-end {
        align-content: flex-end !important;
    }

    .align-content-xl-center {
        align-content: center !important;
    }

    .align-content-xl-between {
        align-content: space-between !important;
    }

    .align-content-xl-around {
        align-content: space-around !important;
    }

    .align-content-xl-stretch {
        align-content: stretch !important;
    }

    .align-self-xl-auto {
        align-self: auto !important;
    }

    .align-self-xl-start {
        align-self: flex-start !important;
    }

    .align-self-xl-end {
        align-self: flex-end !important;
    }

    .align-self-xl-center {
        align-self: center !important;
    }

    .align-self-xl-baseline {
        align-self: baseline !important;
    }

    .align-self-xl-stretch {
        align-self: stretch !important;
    }

    .order-xl-first {
        order: -1 !important;
    }

    .order-xl-0 {
        order: 0 !important;
    }

    .order-xl-1 {
        order: 1 !important;
    }

    .order-xl-2 {
        order: 2 !important;
    }

    .order-xl-3 {
        order: 3 !important;
    }

    .order-xl-4 {
        order: 4 !important;
    }

    .order-xl-5 {
        order: 5 !important;
    }

    .order-xl-last {
        order: 6 !important;
    }

    .m-xl-0 {
        margin: 0 !important;
    }

    .m-xl-1 {
        margin: 0.25rem !important;
    }

    .m-xl-2 {
        margin: 0.5rem !important;
    }

    .m-xl-3 {
        margin: 1rem !important;
    }

    .m-xl-4 {
        margin: 1.5rem !important;
    }

    .m-xl-5 {
        margin: 3rem !important;
    }

    .m-xl-auto {
        margin: auto !important;
    }

    .mx-xl-0 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .mx-xl-1 {
        margin-right: 0.25rem !important;
        margin-left: 0.25rem !important;
    }

    .mx-xl-2 {
        margin-right: 0.5rem !important;
        margin-left: 0.5rem !important;
    }

    .mx-xl-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important;
    }

    .mx-xl-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important;
    }

    .mx-xl-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important;
    }

    .mx-xl-auto {
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .my-xl-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .my-xl-1 {
        margin-top: 0.25rem !important;
        margin-bottom: 0.25rem !important;
    }

    .my-xl-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }

    .my-xl-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .my-xl-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }

    .my-xl-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
    }

    .my-xl-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    .mt-xl-0 {
        margin-top: 0 !important;
    }

    .mt-xl-1 {
        margin-top: 0.25rem !important;
    }

    .mt-xl-2 {
        margin-top: 0.5rem !important;
    }

    .mt-xl-3 {
        margin-top: 1rem !important;
    }

    .mt-xl-4 {
        margin-top: 1.5rem !important;
    }

    .mt-xl-5 {
        margin-top: 3rem !important;
    }

    .mt-xl-auto {
        margin-top: auto !important;
    }

    .me-xl-0 {
        margin-right: 0 !important;
    }

    .me-xl-1 {
        margin-right: 0.25rem !important;
    }

    .me-xl-2 {
        margin-right: 0.5rem !important;
    }

    .me-xl-3 {
        margin-right: 1rem !important;
    }

    .me-xl-4 {
        margin-right: 1.5rem !important;
    }

    .me-xl-5 {
        margin-right: 3rem !important;
    }

    .me-xl-auto {
        margin-right: auto !important;
    }

    .mb-xl-0 {
        margin-bottom: 0 !important;
    }

    .mb-xl-1 {
        margin-bottom: 0.25rem !important;
    }

    .mb-xl-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-xl-3 {
        margin-bottom: 1rem !important;
    }

    .mb-xl-4 {
        margin-bottom: 1.5rem !important;
    }

    .mb-xl-5 {
        margin-bottom: 3rem !important;
    }

    .mb-xl-auto {
        margin-bottom: auto !important;
    }

    .ms-xl-0 {
        margin-left: 0 !important;
    }

    .ms-xl-1 {
        margin-left: 0.25rem !important;
    }

    .ms-xl-2 {
        margin-left: 0.5rem !important;
    }

    .ms-xl-3 {
        margin-left: 1rem !important;
    }

    .ms-xl-4 {
        margin-left: 1.5rem !important;
    }

    .ms-xl-5 {
        margin-left: 3rem !important;
    }

    .ms-xl-auto {
        margin-left: auto !important;
    }

    .p-xl-0 {
        padding: 0 !important;
    }

    .p-xl-1 {
        padding: 0.25rem !important;
    }

    .p-xl-2 {
        padding: 0.5rem !important;
    }

    .p-xl-3 {
        padding: 1rem !important;
    }

    .p-xl-4 {
        padding: 1.5rem !important;
    }

    .p-xl-5 {
        padding: 3rem !important;
    }

    .px-xl-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .px-xl-1 {
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .px-xl-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .px-xl-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .px-xl-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important;
    }

    .px-xl-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }

    .py-xl-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .py-xl-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }

    .py-xl-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .py-xl-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

    .py-xl-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }

    .py-xl-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .pt-xl-0 {
        padding-top: 0 !important;
    }

    .pt-xl-1 {
        padding-top: 0.25rem !important;
    }

    .pt-xl-2 {
        padding-top: 0.5rem !important;
    }

    .pt-xl-3 {
        padding-top: 1rem !important;
    }

    .pt-xl-4 {
        padding-top: 1.5rem !important;
    }

    .pt-xl-5 {
        padding-top: 3rem !important;
    }

    .pe-xl-0 {
        padding-right: 0 !important;
    }

    .pe-xl-1 {
        padding-right: 0.25rem !important;
    }

    .pe-xl-2 {
        padding-right: 0.5rem !important;
    }

    .pe-xl-3 {
        padding-right: 1rem !important;
    }

    .pe-xl-4 {
        padding-right: 1.5rem !important;
    }

    .pe-xl-5 {
        padding-right: 3rem !important;
    }

    .pb-xl-0 {
        padding-bottom: 0 !important;
    }

    .pb-xl-1 {
        padding-bottom: 0.25rem !important;
    }

    .pb-xl-2 {
        padding-bottom: 0.5rem !important;
    }

    .pb-xl-3 {
        padding-bottom: 1rem !important;
    }

    .pb-xl-4 {
        padding-bottom: 1.5rem !important;
    }

    .pb-xl-5 {
        padding-bottom: 3rem !important;
    }

    .ps-xl-0 {
        padding-left: 0 !important;
    }

    .ps-xl-1 {
        padding-left: 0.25rem !important;
    }

    .ps-xl-2 {
        padding-left: 0.5rem !important;
    }

    .ps-xl-3 {
        padding-left: 1rem !important;
    }

    .ps-xl-4 {
        padding-left: 1.5rem !important;
    }

    .ps-xl-5 {
        padding-left: 3rem !important;
    }

    .gap-xl-0 {
        gap: 0 !important;
    }

    .gap-xl-1 {
        gap: 0.25rem !important;
    }

    .gap-xl-2 {
        gap: 0.5rem !important;
    }

    .gap-xl-3 {
        gap: 1rem !important;
    }

    .gap-xl-4 {
        gap: 1.5rem !important;
    }

    .gap-xl-5 {
        gap: 3rem !important;
    }

    .text-xl-start {
        text-align: left !important;
    }

    .text-xl-end {
        text-align: right !important;
    }

    .text-xl-center {
        text-align: center !important;
    }
}

@media (min-width: 1400px) {
    .float-xxl-start {
        float: left !important;
    }

    .float-xxl-end {
        float: right !important;
    }

    .float-xxl-none {
        float: none !important;
    }

    .d-xxl-inline {
        display: inline !important;
    }

    .d-xxl-inline-block {
        display: inline-block !important;
    }

    .d-xxl-block {
        display: block !important;
    }

    .d-xxl-grid {
        display: grid !important;
    }

    .d-xxl-table {
        display: table !important;
    }

    .d-xxl-table-row {
        display: table-row !important;
    }

    .d-xxl-table-cell {
        display: table-cell !important;
    }

    .d-xxl-flex {
        display: flex !important;
    }

    .d-xxl-inline-flex {
        display: inline-flex !important;
    }

    .d-xxl-none {
        display: none !important;
    }

    .flex-xxl-fill {
        flex: 1 1 auto !important;
    }

    .flex-xxl-row {
        flex-direction: row !important;
    }

    .flex-xxl-column {
        flex-direction: column !important;
    }

    .flex-xxl-row-reverse {
        flex-direction: row-reverse !important;
    }

    .flex-xxl-column-reverse {
        flex-direction: column-reverse !important;
    }

    .flex-xxl-grow-0 {
        flex-grow: 0 !important;
    }

    .flex-xxl-grow-1 {
        flex-grow: 1 !important;
    }

    .flex-xxl-shrink-0 {
        flex-shrink: 0 !important;
    }

    .flex-xxl-shrink-1 {
        flex-shrink: 1 !important;
    }

    .flex-xxl-wrap {
        flex-wrap: wrap !important;
    }

    .flex-xxl-nowrap {
        flex-wrap: nowrap !important;
    }

    .flex-xxl-wrap-reverse {
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-xxl-start {
        justify-content: flex-start !important;
    }

    .justify-content-xxl-end {
        justify-content: flex-end !important;
    }

    .justify-content-xxl-center {
        justify-content: center !important;
    }

    .justify-content-xxl-between {
        justify-content: space-between !important;
    }

    .justify-content-xxl-around {
        justify-content: space-around !important;
    }

    .justify-content-xxl-evenly {
        justify-content: space-evenly !important;
    }

    .align-items-xxl-start {
        align-items: flex-start !important;
    }

    .align-items-xxl-end {
        align-items: flex-end !important;
    }

    .align-items-xxl-center {
        align-items: center !important;
    }

    .align-items-xxl-baseline {
        align-items: baseline !important;
    }

    .align-items-xxl-stretch {
        align-items: stretch !important;
    }

    .align-content-xxl-start {
        align-content: flex-start !important;
    }

    .align-content-xxl-end {
        align-content: flex-end !important;
    }

    .align-content-xxl-center {
        align-content: center !important;
    }

    .align-content-xxl-between {
        align-content: space-between !important;
    }

    .align-content-xxl-around {
        align-content: space-around !important;
    }

    .align-content-xxl-stretch {
        align-content: stretch !important;
    }

    .align-self-xxl-auto {
        align-self: auto !important;
    }

    .align-self-xxl-start {
        align-self: flex-start !important;
    }

    .align-self-xxl-end {
        align-self: flex-end !important;
    }

    .align-self-xxl-center {
        align-self: center !important;
    }

    .align-self-xxl-baseline {
        align-self: baseline !important;
    }

    .align-self-xxl-stretch {
        align-self: stretch !important;
    }

    .order-xxl-first {
        order: -1 !important;
    }

    .order-xxl-0 {
        order: 0 !important;
    }

    .order-xxl-1 {
        order: 1 !important;
    }

    .order-xxl-2 {
        order: 2 !important;
    }

    .order-xxl-3 {
        order: 3 !important;
    }

    .order-xxl-4 {
        order: 4 !important;
    }

    .order-xxl-5 {
        order: 5 !important;
    }

    .order-xxl-last {
        order: 6 !important;
    }

    .m-xxl-0 {
        margin: 0 !important;
    }

    .m-xxl-1 {
        margin: 0.25rem !important;
    }

    .m-xxl-2 {
        margin: 0.5rem !important;
    }

    .m-xxl-3 {
        margin: 1rem !important;
    }

    .m-xxl-4 {
        margin: 1.5rem !important;
    }

    .m-xxl-5 {
        margin: 3rem !important;
    }

    .m-xxl-auto {
        margin: auto !important;
    }

    .mx-xxl-0 {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .mx-xxl-1 {
        margin-right: 0.25rem !important;
        margin-left: 0.25rem !important;
    }

    .mx-xxl-2 {
        margin-right: 0.5rem !important;
        margin-left: 0.5rem !important;
    }

    .mx-xxl-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important;
    }

    .mx-xxl-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important;
    }

    .mx-xxl-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important;
    }

    .mx-xxl-auto {
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .my-xxl-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .my-xxl-1 {
        margin-top: 0.25rem !important;
        margin-bottom: 0.25rem !important;
    }

    .my-xxl-2 {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
    }

    .my-xxl-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .my-xxl-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important;
    }

    .my-xxl-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important;
    }

    .my-xxl-auto {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    .mt-xxl-0 {
        margin-top: 0 !important;
    }

    .mt-xxl-1 {
        margin-top: 0.25rem !important;
    }

    .mt-xxl-2 {
        margin-top: 0.5rem !important;
    }

    .mt-xxl-3 {
        margin-top: 1rem !important;
    }

    .mt-xxl-4 {
        margin-top: 1.5rem !important;
    }

    .mt-xxl-5 {
        margin-top: 3rem !important;
    }

    .mt-xxl-auto {
        margin-top: auto !important;
    }

    .me-xxl-0 {
        margin-right: 0 !important;
    }

    .me-xxl-1 {
        margin-right: 0.25rem !important;
    }

    .me-xxl-2 {
        margin-right: 0.5rem !important;
    }

    .me-xxl-3 {
        margin-right: 1rem !important;
    }

    .me-xxl-4 {
        margin-right: 1.5rem !important;
    }

    .me-xxl-5 {
        margin-right: 3rem !important;
    }

    .me-xxl-auto {
        margin-right: auto !important;
    }

    .mb-xxl-0 {
        margin-bottom: 0 !important;
    }

    .mb-xxl-1 {
        margin-bottom: 0.25rem !important;
    }

    .mb-xxl-2 {
        margin-bottom: 0.5rem !important;
    }

    .mb-xxl-3 {
        margin-bottom: 1rem !important;
    }

    .mb-xxl-4 {
        margin-bottom: 1.5rem !important;
    }

    .mb-xxl-5 {
        margin-bottom: 3rem !important;
    }

    .mb-xxl-auto {
        margin-bottom: auto !important;
    }

    .ms-xxl-0 {
        margin-left: 0 !important;
    }

    .ms-xxl-1 {
        margin-left: 0.25rem !important;
    }

    .ms-xxl-2 {
        margin-left: 0.5rem !important;
    }

    .ms-xxl-3 {
        margin-left: 1rem !important;
    }

    .ms-xxl-4 {
        margin-left: 1.5rem !important;
    }

    .ms-xxl-5 {
        margin-left: 3rem !important;
    }

    .ms-xxl-auto {
        margin-left: auto !important;
    }

    .p-xxl-0 {
        padding: 0 !important;
    }

    .p-xxl-1 {
        padding: 0.25rem !important;
    }

    .p-xxl-2 {
        padding: 0.5rem !important;
    }

    .p-xxl-3 {
        padding: 1rem !important;
    }

    .p-xxl-4 {
        padding: 1.5rem !important;
    }

    .p-xxl-5 {
        padding: 3rem !important;
    }

    .px-xxl-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .px-xxl-1 {
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .px-xxl-2 {
        padding-right: 0.5rem !important;
        padding-left: 0.5rem !important;
    }

    .px-xxl-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .px-xxl-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important;
    }

    .px-xxl-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important;
    }

    .py-xxl-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .py-xxl-1 {
        padding-top: 0.25rem !important;
        padding-bottom: 0.25rem !important;
    }

    .py-xxl-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .py-xxl-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
    }

    .py-xxl-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
    }

    .py-xxl-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .pt-xxl-0 {
        padding-top: 0 !important;
    }

    .pt-xxl-1 {
        padding-top: 0.25rem !important;
    }

    .pt-xxl-2 {
        padding-top: 0.5rem !important;
    }

    .pt-xxl-3 {
        padding-top: 1rem !important;
    }

    .pt-xxl-4 {
        padding-top: 1.5rem !important;
    }

    .pt-xxl-5 {
        padding-top: 3rem !important;
    }

    .pe-xxl-0 {
        padding-right: 0 !important;
    }

    .pe-xxl-1 {
        padding-right: 0.25rem !important;
    }

    .pe-xxl-2 {
        padding-right: 0.5rem !important;
    }

    .pe-xxl-3 {
        padding-right: 1rem !important;
    }

    .pe-xxl-4 {
        padding-right: 1.5rem !important;
    }

    .pe-xxl-5 {
        padding-right: 3rem !important;
    }

    .pb-xxl-0 {
        padding-bottom: 0 !important;
    }

    .pb-xxl-1 {
        padding-bottom: 0.25rem !important;
    }

    .pb-xxl-2 {
        padding-bottom: 0.5rem !important;
    }

    .pb-xxl-3 {
        padding-bottom: 1rem !important;
    }

    .pb-xxl-4 {
        padding-bottom: 1.5rem !important;
    }

    .pb-xxl-5 {
        padding-bottom: 3rem !important;
    }

    .ps-xxl-0 {
        padding-left: 0 !important;
    }

    .ps-xxl-1 {
        padding-left: 0.25rem !important;
    }

    .ps-xxl-2 {
        padding-left: 0.5rem !important;
    }

    .ps-xxl-3 {
        padding-left: 1rem !important;
    }

    .ps-xxl-4 {
        padding-left: 1.5rem !important;
    }

    .ps-xxl-5 {
        padding-left: 3rem !important;
    }

    .gap-xxl-0 {
        gap: 0 !important;
    }

    .gap-xxl-1 {
        gap: 0.25rem !important;
    }

    .gap-xxl-2 {
        gap: 0.5rem !important;
    }

    .gap-xxl-3 {
        gap: 1rem !important;
    }

    .gap-xxl-4 {
        gap: 1.5rem !important;
    }

    .gap-xxl-5 {
        gap: 3rem !important;
    }

    .text-xxl-start {
        text-align: left !important;
    }

    .text-xxl-end {
        text-align: right !important;
    }

    .text-xxl-center {
        text-align: center !important;
    }
}

@media (min-width: 1200px) {
    .fs-1 {
        font-size: 2.5rem !important;
    }

    .fs-2 {
        font-size: 2rem !important;
    }

    .fs-3 {
        font-size: 1.75rem !important;
    }

    .fs-4 {
        font-size: 1.5rem !important;
    }
}

@media print {
    .d-print-inline {
        display: inline !important;
    }

    .d-print-inline-block {
        display: inline-block !important;
    }

    .d-print-block {
        display: block !important;
    }

    .d-print-grid {
        display: grid !important;
    }

    .d-print-table {
        display: table !important;
    }

    .d-print-table-row {
        display: table-row !important;
    }

    .d-print-table-cell {
        display: table-cell !important;
    }

    .d-print-flex {
        display: flex !important;
    }

    .d-print-inline-flex {
        display: inline-flex !important;
    }

    .d-print-none {
        display: none !important;
    }
}

html {
    height: 100%;
    scroll-padding-top: calc(4.5rem - 1px);
}

.page-section {
    padding: 6rem 0;
}

.page-section .page-section-heading {
    font-size: 2.25rem;
    line-height: 2rem;
}

@media (min-width: 992px) {
    .page-section .page-section-heading {
        font-size: 3rem;
        line-height: 2.5rem;
    }
}

.divider-custom {
    margin: 1.25rem 0 1.5rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.divider-custom .divider-custom-line {
    width: 100%;
    max-width: 7rem;
    height: 0.25rem;
    background-color: #2c3e50;
    border-radius: 1rem;
    border-color: #2c3e50;
}

.divider-custom .divider-custom-line:first-child {
    margin-right: 1rem;
}

.divider-custom .divider-custom-line:last-child {
    margin-left: 1rem;
}

.divider-custom .divider-custom-icon {
    color: #2c3e50;
    font-size: 2rem;
}

.divider-custom.divider-light .divider-custom-line {
    background-color: #fff;
}

.divider-custom.divider-light .divider-custom-icon {
    color: #fff;
}

.btn-xl {
    padding: 1rem 1.75rem;
    font-size: 1.25rem;
}

.btn-social {
    border-radius: 100%;
    display: inline-flex;
    width: 3.25rem;
    height: 3.25rem;
    font-size: 1.25rem;
    justify-content: center;
    align-items: center;
}

#mainNav {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: 700;
}

#mainNav .navbar-brand {
    color: #fff;
}

#mainNav .navbar-nav {
    margin-top: 1rem;
}

#mainNav .navbar-nav li.nav-item a.nav-link {
    color: #fff;
}

#mainNav .navbar-nav li.nav-item a.nav-link:hover {
    color: #0085CA;
}

#mainNav .navbar-nav li.nav-item a.nav-link:active,
#mainNav .navbar-nav li.nav-item a.nav-link:focus {
    color: #fff;
}

#mainNav .navbar-nav li.nav-item a.nav-link.active {
    color: #0085CA;
}

#mainNav .navbar-toggler {
    font-size: 80%;
    padding: 0.8rem;
}

@media (min-width: 992px) {
    #mainNav {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
        transition: padding-top 0.3s, padding-bottom 0.3s;
    }

    #mainNav .navbar-brand {
        font-size: 1.75em;
        transition: font-size 0.3s;
    }

    #mainNav .navbar-nav {
        margin-top: 0;
    }

    #mainNav .navbar-nav>li.nav-item>a.nav-link.active {
        color: #fff;
        background: #0085CA;
    }

    #mainNav .navbar-nav>li.nav-item>a.nav-link.active:active,
    #mainNav .navbar-nav>li.nav-item>a.nav-link.active:focus,
    #mainNav .navbar-nav>li.nav-item>a.nav-link.active:hover {
        color: #fff;
        background: #0085CA;
    }

    #mainNav.navbar-shrink {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    #mainNav.navbar-shrink .navbar-brand {
        font-size: 1.5em;
    }
}

.form-floating input.form-control,
.form-floating textarea.form-control {
    font-size: 1.5rem;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-radius: 0;
    border-width: 1px;
}

.form-floating input.form-control:focus,
.form-floating textarea.form-control:focus {
    box-shadow: none;
}

.form-floating label {
    font-size: 1.5rem;
    color: #6c757d;
}

.masthead {
    padding-top: calc(6rem + 74px);
    padding-bottom: 6rem;
}

.masthead .masthead-heading {
    font-size: 2.75rem;
    line-height: 2.75rem;
}

.masthead .masthead-subheading {
    font-size: 1.25rem;
}

.masthead .masthead-avatar {
    width: 15rem;
}

@media (min-width: 992px) {
    .masthead {
        padding-top: calc(6rem + 104px);
        padding-bottom: 6rem;
    }

    .masthead .masthead-heading {
        font-size: 4rem;
        line-height: 3.5rem;
    }

    .masthead .masthead-subheading {
        font-size: 1.5rem;
    }
}

.portfolio .portfolio-item {
    cursor: pointer;
    position: relative;
    display: block;
    max-width: 25rem;
    border-radius: 0.5rem;
    overflow: hidden;
}

.portfolio .portfolio-item .portfolio-item-caption {
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    background-color: rgba(26, 188, 156, 0.9);
}

.portfolio .portfolio-item .portfolio-item-caption:hover {
    opacity: 1;
}

.portfolio .portfolio-item .portfolio-item-caption .portfolio-item-caption-content {
    font-size: 1.5rem;
}

.portfolio-modal .btn-close {
    color: #0085CA;
    font-size: 2rem;
    padding: 1rem;
}

.portfolio-modal .portfolio-modal-title {
    font-size: 2.25rem;
    line-height: 2rem;
}

@media (min-width: 992px) {
    .portfolio-modal .portfolio-modal-title {
        font-size: 3rem;
        line-height: 2.5rem;
    }
}

.footer {
    padding-top: 5rem;
    padding-bottom: 5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    ;
    color: #fff;
}

.copyright {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}`, "",{"version":3,"sources":["webpack://./src/css/footer.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;;;CAIC;AACD;;;;;EAKE;AACF;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,+BAA+B;IAC/B,+BAA+B;IAC/B,mNAAmN;IACnN,yGAAyG;IACzG,yFAAyF;IACzF,gDAAgD;IAChD,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,0BAA0B;IAC1B,mDAAmD;IACnD,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,SAAS;IACT,uCAAuC;IACvC,mCAAmC;IACnC,uCAAuC;IACvC,uCAAuC;IACvC,2BAA2B;IAC3B,qCAAqC;IACrC,mCAAmC;IACnC,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;IACd,SAAS;IACT,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;;;;;;;;;;;;IAYI,aAAa;IACb,qBAAqB;IACrB,gNAAgN;IAChN,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,iCAAiC;IACjC,YAAY;IAEZ,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;IAII,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;;;;;;IAMI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT,SAAS;AACb;;AAEA;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;IAOI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;;;;;;;CAOC;AACD;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,6CAA6C;IAC7C,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;;;;;IAOI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,6CAA6C;IAC7C,4CAA4C;IAC5C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;;QAGI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;;;QAII,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;;;;QAKI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;;;;;QAMI,iBAAiB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yCAAyC;IACzC,6CAA6C;IAC7C,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,6CAA6C;IAC7C,4CAA4C;IAC5C,8BAA8B;AAClC;;AAEA;IACI,SAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI;QACI,SAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,SAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,SAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,SAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,SAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,+CAA+C;IAC/C,iCAAiC;IACjC,8CAA8C;IAC9C,0CAA0C;IAC1C,6CAA6C;IAC7C,wCAAwC;IACxC,4CAA4C;IAC5C,yCAAyC;IACzC,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,6BAA6B;IAC7B,wDAAwD;AAC5D;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;IAC/C,mCAAmC;AACvC;;AAEA;IACI,8CAA8C;IAC9C,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAG9B,gBAAgB;IAChB,qBAAqB;IACrB,wEAAwE;AAC5E;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAOA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAE1B,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,qIAAqI;AACzI;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IAExB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IAErB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,0CAA0C;IAC1C,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yDAAiP;IACjP,4BAA4B;IAC5B,yCAAyC;IACzC,0BAA0B;IAC1B,8BAA8B;IAC9B,qBAAqB;IACrB,wEAAwE;IAGxE,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kDAAkD;AACtD;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,qCAAqC;IAGrC,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yDAA+O;AACnP;;AAEA;IACI,yDAAuJ;AAC3J;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,yDAAyO;AAC7O;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,yDAAwK;IACxK,gCAAgC;IAChC,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,yDAA0J;AAC9J;;AAEA;IACI,iCAAiC;IACjC,yDAAuJ;AAC3J;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;IACpB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,6BAA6B;IAG7B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IAEnB,oHAA4G;IAA5G,4GAA4G;IAE5G,gBAAgB;AACpB;;AAEA;IACI;QAEI,wBAAgB;QAAhB,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IAEnB,iHAA4G;IAA5G,4GAA4G;IAE5G,gBAAgB;AACpB;;AAEA;IACI;QAEI,qBAAgB;QAAhB,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,kCAAkC;IAClC,qBAAqB;IACrB,gEAAgE;AACpE;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,iBAAiB;AACrB;;AAOA;;IAEI,kBAAkB;AACtB;;AAQA;;;;IAII,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAOA;;;;IAII,aAAa;IACb,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,2DAA2D;AAC/D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,WAAW;AACf;;AAEA;;;IAGI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY;AAChB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;;;;IAII,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;;;IAII,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;;IAII,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;;;IAII,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,oCAAoC;IACpC,yDAA2P;IAC3P,4BAA4B;IAC5B,2DAA2D;IAC3D,gEAAgE;AACpE;;AAEA;;IAEI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;;IAEI,oCAAoC;IACpC,kFAAkF;AACtF;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;;;IAII,uBAAuB;IACvB,kGAA4d;IAC5d,+DAA+D;IAC/D,2EAA2E;AAC/E;;AAEA;;IAEI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;;;IAMI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,oCAAoC;IACpC,yDAA4U;IAC5U,4BAA4B;IAC5B,2DAA2D;IAC3D,gEAAgE;AACpE;;AAEA;;IAEI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;;IAEI,oCAAoC;IACpC,kFAAkF;AACtF;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;;;IAII,uBAAuB;IACvB,kGAA6iB;IAC7iB,+DAA+D;IAC/D,2EAA2E;AAC/E;;AAEA;;IAEI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;;;IAMI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,+BAA+B;IAC/B,kCAAkC;IAClC,8BAA8B;IAC9B,wCAAwC;IACxC,4FAA4F;IAC5F,+BAA+B;IAC/B,iFAAiF;IACjF,qBAAqB;IACrB,wDAAwD;IACxD,sCAAsC;IACtC,kCAAkC;IAClC,sCAAsC;IACtC,sCAAsC;IACtC,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IAEzB,iBAAiB;IACjB,mEAAmE;IACnE,0CAA0C;IAC1C,kCAAkC;IAClC,qIAAqI;AACzI;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,8CAA8C;IAC9C,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,8CAA8C;IAC9C,UAAU;IACV,0CAA0C;AAC9C;;AAEA;;;;;IAKI,iCAAiC;IACjC,yCAAyC;IACzC,+CAA+C;AACnD;;AAEA;;;;;IAKI,0CAA0C;AAC9C;;AAEA;;;IAGI,mCAAmC;IACnC,oBAAoB;IACpB,2CAA2C;IAC3C,iDAAiD;IACjD,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,wBAAwB;IACxB,kCAAkC;IAClC,gDAAgD;IAChD,wCAAwC;IACxC,iDAAiD;IACjD,yCAAyC;IACzC,gCAAgC;IAChC,2CAA2C;IAC3C,yBAAyB;IACzB,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;IAC1B,wBAAwB;IACxB,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;;;;;IAMI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,qCAAqC;IACrC,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,sBAAsB;IACtB,8DAA8D;IAC9D,mCAAmC;IACnC,oCAAoC;IACpC,2CAA2C;IAC3C,4DAA4D;IAC5D,sCAAsC;IACtC,2DAA2D;IAC3D,iCAAiC;IACjC,uCAAuC;IACvC,oCAAoC;IACpC,qCAAqC;IACrC,qCAAqC;IACrC,0CAA0C;IAC1C,kCAAkC;IAClC,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,sCAAsC;IACtC,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,uCAAuC;IACvC,kEAAkE;IAClE,SAAS;IACT,uCAAuC;IACvC,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;IACvC,4BAA4B;IAC5B,6EAA6E;IAC7E,+CAA+C;AACnD;;AAEA;IACI,SAAS;IACT,OAAO;IACP,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,mCAAmC;IACnC,eAAe;IACf,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,mCAAmC;IACnC,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,6CAA6C;IAC7C,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;AACd;;AAEA;IACI,cAAc;IACd,WAAW;IACX,4EAA4E;IAC5E,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;;IAEI,0CAA0C;IAC1C,kDAAkD;AACtD;;AAEA;;IAEI,2CAA2C;IAC3C,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;;IAEI,6CAA6C;IAC7C,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gFAAgF;IAChF,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4EAA4E;IAC5E,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,8DAA8D;IAC9D,0BAA0B;IAC1B,iCAAiC;IACjC,oCAAoC;IACpC,4DAA4D;IAC5D,sDAAsD;IACtD,qCAAqC;IACrC,qCAAqC;IACrC,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;;;;;;;;;;IAYI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;;IAGI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;;IAGI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;IAC3B,yCAAyC;IACzC,qDAAqD;IACrD,qCAAqC;IACrC,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kEAAkE;IAClE,uCAAuC;IACvC,2CAA2C;IAC3C,+BAA+B;IAC/B,qBAAqB;IACrB,uGAAuG;AAC3G;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;IACnC,8DAA8D;IAC9D,wCAAwC;IACxC,kCAAkC;IAClC,4DAA4D;IAC5D,oFAAoF;AACxF;;AAEA;IACI,yDAAyD;IACzD,gBAAgB;IAChB,yDAAyD;IACzD,wDAAwD;IACxD,yDAAyD;AAC7D;;AAEA;;IAEI,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;;IAEI,wCAAwC;IACxC,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,2CAA2C;IAC3C,mDAAmD;IACnD,yDAAyD;AAC7D;;AAEA;IACI,sDAAsD;IACtD,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gDAAgD;AACpD;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,4CAA4C;IAC5C,oDAAoD;AACxD;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,sCAAsC;IACtC,2CAA2C;IAC3C,8CAA8C;IAC9C,4CAA4C;IAC5C,sCAAsC;IACtC,kCAAkC;IAClC,oCAAoC;IACpC,2CAA2C;IAC3C,iDAAiD;IACjD,sCAAsC;IACtC,sCAAsC;IACtC,sCAAsC;IACtC,sCAAsC;IACtC,oEAAwQ;IACxQ,oDAAoD;IACpD,yCAAyC;IACzC,wCAAwC;IACxC,4DAA4D;IAC5D,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,8DAA8D;AAClE;;AAEA;;;;;;;IAOI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,6CAA6C;IAC7C,gDAAgD;IAChD,+CAA+C;IAC/C,2CAA2C;IAC3C,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,2BAA2B;IAC3B,2CAA2C;IAC3C,uDAAuD;IACvD,6DAA6D;IAC7D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8EAA8E;IAC9E,6CAA6C;IAC7C,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;IAC7B,0EAA0E;IAC1E,qDAAqD;IACrD,+CAA+C;AACnD;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,sDAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kDAAkD;IAClD,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kDAAkD;QAClD,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,wCAAwC;QACxC,oBAAoB;QACpB,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kDAAkD;QAClD,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,wCAAwC;QACxC,oBAAoB;QACpB,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kDAAkD;QAClD,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,wCAAwC;QACxC,oBAAoB;QACpB,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kDAAkD;QAClD,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,wCAAwC;QACxC,oBAAoB;QACpB,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kDAAkD;QAClD,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,wCAAwC;QACxC,oBAAoB;QACpB,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,kDAAkD;IAClD,qDAAqD;IACrD,8BAA8B;IAC9B,6BAA6B;IAC7B,mCAAmC;IACnC,0DAA0D;IAC1D,qEAA8Q;AAClR;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,gCAAgC;IAChC,gCAAgC;IAChC,0DAA0D;IAC1D,+BAA+B;IAC/B,sBAAsB;IACtB,uCAAuC;IACvC,+BAA+B;IAC/B,6BAA6B;IAC7B,qCAAqC;IACrC,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;IAC7B,qBAAqB;IACrB,mCAAmC;IACnC,2BAA2B;IAC3B,qEAAqE;IACrE,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;IAC1D,2DAA2D;AAC/D;;AAEA;IACI,sBAAsB;IACtB,8DAA8D;IAC9D,6DAA6D;AACjE;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,wDAAwD;IACxD,2BAA2B;AAC/B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kEAAkE;IAClE,gBAAgB;IAChB,+BAA+B;IAC/B,uCAAuC;IACvC,4EAA4E;AAChF;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,kEAAkE;IAClE,+BAA+B;IAC/B,uCAAuC;IACvC,yEAAyE;AAC7E;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,uDAAuD;IACvD,sDAAsD;IACtD,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,uDAAuD;IACvD,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,2CAA2C;IAC3C,iDAAiD;AACrD;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;IAEI,0DAA0D;IAC1D,2DAA2D;AAC/D;;AAEA;;IAEI,8DAA8D;IAC9D,6DAA6D;AACjE;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,SAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,4BAA4B;IAChC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,8KAA8K;IAC9K,mDAAmD;IACnD,qCAAqC;IACrC,oCAAoC;IACpC,4CAA4C;IAC5C,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,6CAA6C;IAC7C,iEAAwS;IACxS,sCAAsC;IACtC,kDAAkD;IAClD,8DAA8D;IAC9D,wEAA+S;IAC/S,8CAA8C;IAC9C,2EAA2E;IAC3E,sCAAsC;IACtC,mCAAmC;IACnC,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,4EAA4E;IAC5E,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,4CAA4C;IAC5C,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;IAC/C,kGAAkG;AACtG;;AAEA;IACI,qDAAqD;IACrD,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,0CAA0C;IAC1C,iBAAiB;IACjB,WAAW;IACX,8CAA8C;IAC9C,4BAA4B;IAC5B,mDAAmD;IACnD,mDAAmD;AACvD;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,wDAAwD;IACxD,UAAU;IACV,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,+EAA+E;AACnF;;AAEA;IACI,yDAAyD;IACzD,0DAA0D;AAC9D;;AAEA;IACI,+DAA+D;IAC/D,gEAAgE;AACpE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6DAA6D;IAC7D,4DAA4D;AAChE;;AAEA;IACI,mEAAmE;IACnE,kEAAkE;AACtE;;AAEA;IACI,6DAA6D;IAC7D,4DAA4D;AAChE;;AAEA;IACI,8EAA8E;AAClF;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,mCAAmC;IACnC,oBAAoB;IACpB,+BAA+B;IAC/B,sCAAsC;IACtC,sCAAsC;IACtC,0CAA0C;IAC1C,aAAa;IACb,eAAe;IACf,sEAAsE;IACtE,iDAAiD;IACjD,yCAAyC;IACzC,gBAAgB;IAChB,yCAAyC;IACzC,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,kDAAkD;IAClD,yCAAyC;IACzC;;IAEA;AACJ;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,+BAA+B;IAC/B,2CAA2C;IAC3C,wBAAwB;IACxB,sCAAsC;IACtC,qCAAqC;IACrC,qCAAqC;IACrC,uDAAuD;IACvD,iCAAiC;IACjC,2CAA2C;IAC3C,uDAAuD;IACvD,iCAAiC;IACjC,wEAAwE;IACxE,kCAAkC;IAClC,kCAAkC;IAClC,4CAA4C;IAC5C,uCAAuC;IACvC,iCAAiC;IACjC,8CAA8C;IAC9C,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sEAAsE;IACtE,yCAAyC;IACzC,iCAAiC;IACjC,qBAAqB;IACrB,yCAAyC;IACzC,iFAAiF;IACjF,qIAAqI;AACzI;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,+CAA+C;IAC/C,qDAAqD;AACzD;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,+CAA+C;IAC/C,UAAU;IACV,iDAAiD;AACrD;;AAEA;;IAEI,UAAU;IACV,wCAAwC;IACxC,gDAAgD;IAChD,sDAAsD;AAC1D;;AAEA;;IAEI,0CAA0C;IAC1C,oBAAoB;IACpB,kDAAkD;IAClD,wDAAwD;AAC5D;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0DAA0D;IAC1D,6DAA6D;AACjE;;AAEA;IACI,2DAA2D;IAC3D,8DAA8D;AAClE;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,gCAAgC;IAChC,qBAAqB;IACrB,4DAA4D;IAC5D,oCAAoC;IACpC,wCAAwC;IACxC,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;IACzB,oCAAoC;IACpC,8DAA8D;IAC9D,gCAAgC;IAChC,kBAAkB;IAClB,4DAA4D;IAC5D,4CAA4C;IAC5C,4BAA4B;IAC5B,oCAAoC;IACpC,8BAA8B;IAC9B,4CAA4C;AAChD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,yBAAyB;IACzB,mCAAmC;IACnC,8DAA8D;IAC9D,6BAA6B;IAC7B,6BAA6B;IAC7B,6CAA6C;IAC7C,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,uCAAuC;IACvC,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,6CAA6C;AACjD;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,qMAAqM;IACrM,oEAAoE;AACxE;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,kDAAkD;IAClD,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,sCAAsC;IACtC,qCAAqC;IACrC,2CAA2C;IAC3C,wCAAwC;IACxC,4CAA4C;IAC5C,yCAAyC;IACzC,uCAAuC;IACvC,iCAAiC;IACjC,kCAAkC;IAClC,kCAAkC;IAClC,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,8CAA8C;IAC9C,qBAAqB;IACrB,sDAAsD;AAC1D;;AAEA;IACI,+CAA+C;IAC/C,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gFAAgF;IAChF,iCAAiC;IACjC,qBAAqB;IACrB,yCAAyC;IACzC,iFAAiF;AACrF;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;;IAEI,0CAA0C;IAC1C,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,wCAAwC;IACxC,gDAAgD;IAChD,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wDAAwD;IACxD,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,0BAA0B;AAC9B;;AAEA;IACI,2DAA2D;IAC3D,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mDAAmD;IACnD,oBAAoB;AACxB;;AAEA;IACI,yDAAyD;IACzD,oDAAoD;AACxD;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,6DAA6D;QAC7D,0BAA0B;IAC9B;;IAEA;QACI,2DAA2D;QAC3D,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mDAAmD;QACnD,oBAAoB;IACxB;;IAEA;QACI,yDAAyD;QACzD,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,6DAA6D;QAC7D,0BAA0B;IAC9B;;IAEA;QACI,2DAA2D;QAC3D,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mDAAmD;QACnD,oBAAoB;IACxB;;IAEA;QACI,yDAAyD;QACzD,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,6DAA6D;QAC7D,0BAA0B;IAC9B;;IAEA;QACI,2DAA2D;QAC3D,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mDAAmD;QACnD,oBAAoB;IACxB;;IAEA;QACI,yDAAyD;QACzD,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,6DAA6D;QAC7D,0BAA0B;IAC9B;;IAEA;QACI,2DAA2D;QAC3D,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mDAAmD;QACnD,oBAAoB;IACxB;;IAEA;QACI,yDAAyD;QACzD,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,6DAA6D;QAC7D,0BAA0B;IAC9B;;IAEA;QACI,2DAA2D;QAC3D,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mDAAmD;QACnD,oBAAoB;IACxB;;IAEA;QACI,yDAAyD;QACzD,oDAAoD;IACxD;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,0FAAmX;IACnX,SAAS;IACT,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,kDAAkD;IAClD,UAAU;AACd;;AAEA;;IAEI,oBAAoB;IACpB,yBAAyB;IAEzB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;IACxC,iCAAiC;IACjC,2DAA2D;IAC3D,gCAAgC;IAChC,wDAAwD;IACxD,gCAAgC;IAChC,+CAA+C;IAC/C,mDAAmD;IACnD,gCAAgC;IAChC,eAAe;IACf,oCAAoC;IACpC,4BAA4B;IAC5B,oBAAoB;IACpB,oCAAoC;IACpC,4BAA4B;IAC5B,uEAAuE;IACvE,sCAAsC;IACtC,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAE/B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4DAA4D;IAC5D,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,qFAAqF;IACrF,0FAA0F;IAC1F,2FAA2F;AAC/F;;AAEA;IACI,oDAAoD;IACpD,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,2DAA2D;IAC3D,iCAAiC;IACjC,iCAAiC;IACjC,8DAA8D;IAC9D,wCAAwC;IACxC,iCAAiC;IACjC,iCAAiC;IACjC,oCAAoC;IACpC,sDAAsD;IACtD,wCAAwC;IACxC,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;IACtB,sDAAsD;IACtD,wCAAwC;IACxC,eAAe;IACf,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,4BAA4B;IAC5B,oBAAoB;IACpB,oCAAoC;IACpC,4BAA4B;IAC5B,uEAAuE;IACvE,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,MAAM;IACN,OAAO;IACP,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,uCAAuC;IACvC,4FAA4F;IAC5F,2DAA2D;IAC3D,4DAA4D;AAChE;;AAEA;IACI,kGAAkG;IAClG,sJAAsJ;AAC1J;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,yEAAyE;IACzE,2CAA2C;IAC3C,yFAAyF;IACzF,+DAA+D;IAC/D,8DAA8D;AAClE;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI;QACI,0BAA0B;QAC1B,wDAAwD;IAC5D;;IAEA;QACI,gCAAgC;QAChC,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI;;QAEI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,qBAAqB;IACrB,gCAAgC;IAChC,wBAAwB;IACxB,qBAAqB;IACrB,kCAAkC;IAClC,yBAAyB;IACzB,gCAAgC;IAChC,iCAAiC;IACjC,iCAAiC;IACjC,cAAc;IACd,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,SAAS;IACT,wFAAwF;IACxF,sCAAsC;AAC1C;;AAEA,qBAAqB;AACrB;;IAEI,OAAO;IACP,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;;IAEI,WAAW;IACX,kIAAkI;IAClI,wCAAwC;AAC5C;;AAEA,mBAAmB;AACnB;;IAEI,MAAM;AACV;;AAEA;;IAEI,YAAY;IACZ,wFAAwF;IACxF,yCAAyC;AAC7C;;AAEA,qBAAqB;AACrB;;IAEI,QAAQ;IACR,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;;IAEI,UAAU;IACV,kIAAkI;IAClI,uCAAuC;AAC3C;;AAEA,mBAAmB;AACnB;IACI,sCAAsC;IACtC,gEAAgE;IAChE,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,qBAAqB;IACrB,mCAAmC;IACnC,6DAA6D;IAC7D,mCAAmC;IACnC,0CAA0C;IAC1C,0DAA0D;IAC1D,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,iCAAiC;IACjC,gCAAgC;IAChC,8BAA8B;IAC9B,iCAAiC;IACjC,yDAAyD;IACzD,iCAAiC;IACjC,cAAc;IACd,sCAAsC;IACtC,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,sCAAsC;IACtC,4BAA4B;IAC5B,2EAA2E;IAC3E,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,oFAAoF;AACxF;;AAEA;;;;IAII,wFAAwF;AAC5F;;AAEA;;IAEI,SAAS;IACT,gDAAgD;AACpD;;AAEA;;IAEI,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA,qBAAqB;AACrB;;IAEI,kFAAkF;IAClF,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;;;;IAII,kIAAkI;AACtI;;AAEA;;IAEI,OAAO;IACP,kDAAkD;AACtD;;AAEA;;IAEI,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA,mBAAmB;AACnB;;IAEI,iFAAiF;AACrF;;AAEA;;;;IAII,wFAAwF;AAC5F;;AAEA;;IAEI,MAAM;IACN,mDAAmD;AACvD;;AAEA;;IAEI,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,oCAAoC;IACpC,uDAAuD;IACvD,WAAW;IACX,+EAA+E;AACnF;;AAEA,qBAAqB;AACrB;;IAEI,mFAAmF;IACnF,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;;;;IAII,kIAAkI;AACtI;;AAEA;;IAEI,QAAQ;IACR,iDAAiD;AACrD;;AAEA;;IAEI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA,mBAAmB;AACnB;IACI,8EAA8E;IAC9E,gBAAgB;IAChB,6CAA6C;IAC7C,qCAAqC;IACrC,6CAA6C;IAC7C,kFAAkF;IAClF,6DAA6D;IAC7D,8DAA8D;AAClE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0EAA0E;IAC1E,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IAEnB,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;;;IAGI,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,UAAU;IACV,2BAA2B;AAC/B;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;;;IAII,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;;;;;;;GAOG;AACH;IACI,0DAAyQ;AAC7Q;;AAEA;IACI,0DAA0Q;AAC9Q;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,8BAA8B;IAC9B,gCAAgC;IAChC,gDAAgD;IAChD,kBAAkB;IAClB,6FAA6F;AACjG;;AAEA;IACI;QACI;;QAEA;IACJ;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,qCAAqC;IACrC,iCAAiC;IACjC,mCAAmC;IACnC,2CAA2C;IAC3C,yDAAyD;IACzD,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,qCAAqC;IACrC,mCAAmC;IACnC,yCAAyC;IACzC,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;;IAEI;;QAEI,kCAAkC;IACtC;AACJ;;AAEA;;;;;;IAMI,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,qCAAqC;IACrC,+DAA+D;IAC/D,kEAAkE;AACtE;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,wCAAwC;IAC5C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,wCAAwC;IAC5C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,wCAAwC;IAC5C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,wCAAwC;IAC5C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,mCAAmC;QACnC,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,gCAAgC;QAChC,kBAAkB;QAClB,wCAAwC;QACxC,4BAA4B;QAC5B,UAAU;QACV,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,gCAAgC;QAChC,qFAAqF;QACrF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,gCAAgC;QAChC,oFAAoF;QACpF,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,MAAM;QACN,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,sFAAsF;QACtF,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,kCAAkC;QAClC,gBAAgB;QAChB,mFAAmF;QACnF,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,wCAAwC;IAC5C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,wCAAwC;IAC5C;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,wCAAwC;IACxC,4BAA4B;IAC5B,UAAU;IACV,sCAAsC;AAC1C;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,MAAM;IACN,OAAO;IACP,gCAAgC;IAChC,qFAAqF;IACrF,4BAA4B;AAChC;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,gCAAgC;IAChC,oFAAoF;IACpF,2BAA2B;AAC/B;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAAkC;IAClC,gBAAgB;IAChB,sFAAsF;IACtF,4BAA4B;AAChC;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,kCAAkC;IAClC,gBAAgB;IAChB,mFAAmF;IACnF,2BAA2B;AAC/B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oEAAoE;AACxE;;AAEA;IACI,4FAA4F;IAC5F,sDAAsD;IACtD,wDAAwD;IACxD,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oEAAoE;IACpE,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IAEI,+EAA+E;IAE/E,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI;QAEI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,sBAAsB;IACtB,sEAAsE;AAC1E;;AAEA;IACI,sBAAsB;IACtB,uEAAuE;AAC3E;;AAEA;IACI,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,sBAAsB;IACtB,uEAAuE;AAC3E;;AAEA;IACI,sBAAsB;IACtB,uEAAuE;AAC3E;;AAEA;IACI,sBAAsB;IACtB,yEAAyE;AAC7E;;AAEA;IACI,sBAAsB;IACtB,sEAAsE;AAC1E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6FAA6F;AACjG;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8FAA8F;AAClG;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4FAA4F;AAChG;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,8EAA8E;AAClF;;AAEA;IACI,sBAAsB;IACtB,gFAAgF;AACpF;;AAEA;IACI,sBAAsB;IACtB,8EAA8E;AAClF;;AAEA;IACI,sBAAsB;IACtB,2EAA2E;AAC/E;;AAEA;IACI,sBAAsB;IACtB,8EAA8E;AAClF;;AAEA;IACI,sBAAsB;IACtB,6EAA6E;AACjF;;AAEA;IACI,sBAAsB;IACtB,4EAA4E;AAChF;;AAEA;IACI,sBAAsB;IACtB,2EAA2E;AAC/E;;AAEA;IACI,sBAAsB;IACtB,4EAA4E;AAChF;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA,mBAAmB;AACnB;IACI,oBAAoB;IACpB,qEAAqE;AACzE;;AAEA;IACI,oBAAoB;IACpB,uEAAuE;AAC3E;;AAEA;IACI,oBAAoB;IACpB,qEAAqE;AACzE;;AAEA;IACI,oBAAoB;IACpB,kEAAkE;AACtE;;AAEA;IACI,oBAAoB;IACpB,qEAAqE;AACzE;;AAEA;IACI,oBAAoB;IACpB,oEAAoE;AACxE;;AAEA;IACI,oBAAoB;IACpB,mEAAmE;AACvE;;AAEA;IACI,oBAAoB;IACpB,kEAAkE;AACtE;;AAEA;IACI,oBAAoB;IACpB,mEAAmE;AACvE;;AAEA;IACI,oBAAoB;IACpB,mEAAmE;AACvE;;AAEA;IACI,oBAAoB;IACpB,wEAAwE;AAC5E;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,8EAA8E;AAClF;;AAEA;IACI,kBAAkB;IAClB,gFAAgF;AACpF;;AAEA;IACI,kBAAkB;IAClB,8EAA8E;AAClF;;AAEA;IACI,kBAAkB;IAClB,2EAA2E;AAC/E;;AAEA;IACI,kBAAkB;IAClB,8EAA8E;AAClF;;AAEA;IACI,kBAAkB;IAClB,6EAA6E;AACjF;;AAEA;IACI,kBAAkB;IAClB,4EAA4E;AAChF;;AAEA;IACI,kBAAkB;IAClB,2EAA2E;AAC/E;;AAEA;IACI,kBAAkB;IAClB,4EAA4E;AAChF;;AAEA;IACI,kBAAkB;IAClB,4EAA4E;AAChF;;AAEA;IACI,kBAAkB;IAClB,8EAA8E;AAClF;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,mCAAmC;IAEnC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IAEpC,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IAEpC,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,0DAA0D;IAC1D,2DAA2D;AAC/D;;AAEA;IACI,2DAA2D;IAC3D,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;IAC9D,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,0DAA0D;AAC9D;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;QAC9B,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gNAAgN;IAChN,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,mBAAmB;QACnB,sBAAsB;QACtB,iDAAiD;IACrD;;IAEA;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;;;QAGI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,+BAA+B;QAC/B,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gCAAgC;IAChC,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,0DAA0C;;IAE1C,WAAW;AACf;;AAEA;IACI,0DAA0C;AAC9C","sourcesContent":["@charset \"UTF-8\";\n\n/*!\n* Start Bootstrap - Freelancer v7.0.7 (https://startbootstrap.com/theme/freelancer)\n* Copyright 2013-2023 Start Bootstrap\n* Licensed under MIT (https://github.com/StartBootstrap/startbootstrap-freelancer/blob/master/LICENSE)\n*/\n/*!\n * Bootstrap  v5.2.3 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n    --bs-blue: #0d6efd;\n    --bs-indigo: #6610f2;\n    --bs-purple: #6f42c1;\n    --bs-pink: #d63384;\n    --bs-red: #dc3545;\n    --bs-orange: #fd7e14;\n    --bs-yellow: #ffc107;\n    --bs-green: #198754;\n    --bs-teal: #0085CA;\n    --bs-cyan: #0dcaf0;\n    --bs-black: #000;\n    --bs-white: #fff;\n    --bs-gray: #6c757d;\n    --bs-gray-dark: #343a40;\n    --bs-gray-100: #f8f9fa;\n    --bs-gray-200: #e9ecef;\n    --bs-gray-300: #dee2e6;\n    --bs-gray-400: #ced4da;\n    --bs-gray-500: #adb5bd;\n    --bs-gray-600: #6c757d;\n    --bs-gray-700: #495057;\n    --bs-gray-800: #343a40;\n    --bs-gray-900: #212529;\n    --bs-primary: #0085CA;\n    --bs-secondary: #0085CA;\n    --bs-success: #0085CA;\n    --bs-info: #0dcaf0;\n    --bs-warning: #ffc107;\n    --bs-danger: #dc3545;\n    --bs-light: #f8f9fa;\n    --bs-dark: #212529;\n    --bs-primary-rgb: 26, 188, 156;\n    --bs-secondary-rgb: 44, 62, 80;\n    --bs-success-rgb: 25, 135, 84;\n    --bs-info-rgb: 13, 202, 240;\n    --bs-warning-rgb: 255, 193, 7;\n    --bs-danger-rgb: 220, 53, 69;\n    --bs-light-rgb: 248, 249, 250;\n    --bs-dark-rgb: 33, 37, 41;\n    --bs-white-rgb: 255, 255, 255;\n    --bs-black-rgb: 0, 0, 0;\n    --bs-body-color-rgb: 33, 37, 41;\n    --bs-body-bg-rgb: 255, 255, 255;\n    --bs-font-sans-serif: \"Lato\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n    --bs-body-font-family: var(--bs-font-sans-serif);\n    --bs-body-font-size: 1rem;\n    --bs-body-font-weight: 400;\n    --bs-body-line-height: 1.5;\n    --bs-body-color: #212529;\n    --bs-body-bg: #fff;\n    --bs-border-width: 0.125rem;\n    --bs-border-style: solid;\n    --bs-border-color: #dee2e6;\n    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n    --bs-border-radius: 0.5rem;\n    --bs-border-radius-sm: 0.25rem;\n    --bs-border-radius-lg: 0.75rem;\n    --bs-border-radius-xl: 1rem;\n    --bs-border-radius-2xl: 2rem;\n    --bs-border-radius-pill: 50rem;\n    --bs-link-color: #ffffff;\n    --bs-link-hover-color: #15967d;\n    --bs-code-color: #d63384;\n    --bs-highlight-bg: #fff3cd;\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    :root {\n        scroll-behavior: smooth;\n    }\n}\n\nbody {\n    margin: 0;\n    font-family: var(--bs-body-font-family);\n    font-size: var(--bs-body-font-size);\n    font-weight: var(--bs-body-font-weight);\n    line-height: var(--bs-body-line-height);\n    color: var(--bs-body-color);\n    text-align: var(--bs-body-text-align);\n    background-color: var(--bs-body-bg);\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n    margin: 1rem 0;\n    color: inherit;\n    border: 0;\n    border-top: 0.125rem solid;\n    opacity: 0.25;\n}\n\nh6,\n.h6,\nh5,\n.h5,\nh4,\n.h4,\nh3,\n.h3,\nh2,\n.h2,\nh1,\n.h1 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-weight: 700;\n    line-height: 1.2;\n}\n\nh1,\n.h1 {\n    font-size: calc(1.375rem + 1.5vw);\n}\n\n@media (min-width: 1200px) {\n\n    h1,\n    .h1 {\n        font-size: 2.5rem;\n    }\n}\n\nh2,\n.h2 {\n    font-size: calc(1.325rem + 0.9vw);\n}\n\n@media (min-width: 1200px) {\n\n    h2,\n    .h2 {\n        font-size: 2rem;\n    }\n}\n\nh3,\n.h3 {\n    font-size: calc(1.3rem + 0.6vw);\n}\n\n@media (min-width: 1200px) {\n\n    h3,\n    .h3 {\n        font-size: 1.75rem;\n    }\n}\n\nh4,\n.h4 {\n    font-size: calc(1.275rem + 0.3vw);\n}\n\n@media (min-width: 1200px) {\n\n    h4,\n    .h4 {\n        font-size: 1.5rem;\n    }\n}\n\nh5,\n.h5 {\n    font-size: 1.25rem;\n}\n\nh6,\n.h6 {\n    font-size: 1rem;\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\nabbr[title] {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    -webkit-text-decoration-skip-ink: none;\n    text-decoration-skip-ink: none;\n}\n\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit;\n}\n\nol,\nul {\n    padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n    margin-bottom: 0;\n}\n\ndt {\n    font-weight: 700;\n}\n\ndd {\n    margin-bottom: 0.5rem;\n    margin-left: 0;\n}\n\nblockquote {\n    margin: 0 0 1rem;\n}\n\nb,\nstrong {\n    font-weight: bolder;\n}\n\nsmall,\n.small {\n    font-size: 0.875em;\n}\n\nmark,\n.mark {\n    padding: 0.1875em;\n    background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n    position: relative;\n    font-size: 0.75em;\n    line-height: 0;\n    vertical-align: baseline;\n}\n\nsub {\n    bottom: -0.25em;\n}\n\nsup {\n    top: -0.5em;\n}\n\na {\n    color: var(--bs-link-color);\n    text-decoration: underline;\n}\n\na:hover {\n    color: var(--bs-link-hover-color);\n}\n\na:not([href]):not([class]),\na:not([href]):not([class]):hover {\n    color: inherit;\n    text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n    font-family: var(--bs-font-monospace);\n    font-size: 1em;\n}\n\npre {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    font-size: 0.875em;\n}\n\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal;\n}\n\ncode {\n    font-size: 0.875em;\n    color: var(--bs-code-color);\n    word-wrap: break-word;\n}\n\na>code {\n    color: inherit;\n}\n\nkbd {\n    padding: 0.1875rem 0.375rem;\n    font-size: 0.875em;\n    color: var(--bs-body-bg);\n    background-color: var(--bs-body-color);\n    border-radius: 0.25rem;\n}\n\nkbd kbd {\n    padding: 0;\n    font-size: 1em;\n}\n\nfigure {\n    margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n    vertical-align: middle;\n}\n\ntable {\n    caption-side: bottom;\n    border-collapse: collapse;\n}\n\ncaption {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    color: #6c757d;\n    text-align: left;\n}\n\nth {\n    text-align: inherit;\n    text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n}\n\nlabel {\n    display: inline-block;\n}\n\nbutton {\n    border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n    outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\n\nbutton,\nselect {\n    text-transform: none;\n}\n\n[role=button] {\n    cursor: pointer;\n}\n\nselect {\n    word-wrap: normal;\n}\n\nselect:disabled {\n    opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n    display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n    -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n    cursor: pointer;\n}\n\n::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n}\n\ntextarea {\n    resize: vertical;\n}\n\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n}\n\nlegend {\n    float: left;\n    width: 100%;\n    padding: 0;\n    margin-bottom: 0.5rem;\n    font-size: calc(1.275rem + 0.3vw);\n    line-height: inherit;\n}\n\n@media (min-width: 1200px) {\n    legend {\n        font-size: 1.5rem;\n    }\n}\n\nlegend+* {\n    clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n    padding: 0;\n}\n\n::-webkit-inner-spin-button {\n    height: auto;\n}\n\n[type=search] {\n    outline-offset: -2px;\n    -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n    padding: 0;\n}\n\n::file-selector-button {\n    font: inherit;\n    -webkit-appearance: button;\n}\n\noutput {\n    display: inline-block;\n}\n\niframe {\n    border: 0;\n}\n\nsummary {\n    display: list-item;\n    cursor: pointer;\n}\n\nprogress {\n    vertical-align: baseline;\n}\n\n[hidden] {\n    display: none !important;\n}\n\n.lead {\n    font-size: 1.25rem;\n    font-weight: 300;\n}\n\n.display-1 {\n    font-size: calc(1.625rem + 4.5vw);\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n    .display-1 {\n        font-size: 5rem;\n    }\n}\n\n.display-2 {\n    font-size: calc(1.575rem + 3.9vw);\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n    .display-2 {\n        font-size: 4.5rem;\n    }\n}\n\n.display-3 {\n    font-size: calc(1.525rem + 3.3vw);\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n    .display-3 {\n        font-size: 4rem;\n    }\n}\n\n.display-4 {\n    font-size: calc(1.475rem + 2.7vw);\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n    .display-4 {\n        font-size: 3.5rem;\n    }\n}\n\n.display-5 {\n    font-size: calc(1.425rem + 2.1vw);\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n    .display-5 {\n        font-size: 3rem;\n    }\n}\n\n.display-6 {\n    font-size: calc(1.375rem + 1.5vw);\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n@media (min-width: 1200px) {\n    .display-6 {\n        font-size: 2.5rem;\n    }\n}\n\n.list-unstyled {\n    padding-left: 0;\n    list-style: none;\n}\n\n.list-inline {\n    padding-left: 0;\n    list-style: none;\n}\n\n.list-inline-item {\n    display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n    margin-right: 0.5rem;\n}\n\n.initialism {\n    font-size: 0.875em;\n    text-transform: uppercase;\n}\n\n.blockquote {\n    margin-bottom: 1rem;\n    font-size: 1.25rem;\n}\n\n.blockquote> :last-child {\n    margin-bottom: 0;\n}\n\n.blockquote-footer {\n    margin-top: -1rem;\n    margin-bottom: 1rem;\n    font-size: 0.875em;\n    color: #6c757d;\n}\n\n.blockquote-footer::before {\n    content: \"— \";\n}\n\n.img-fluid {\n    max-width: 100%;\n    height: auto;\n}\n\n.img-thumbnail {\n    padding: 0.25rem;\n    background-color: #fff;\n    border: 0.125rem solid var(--bs-border-color);\n    border-radius: 0.5rem;\n    max-width: 100%;\n    height: auto;\n}\n\n.figure {\n    display: inline-block;\n}\n\n.figure-img {\n    margin-bottom: 0.5rem;\n    line-height: 1;\n}\n\n.figure-caption {\n    font-size: 0.875em;\n    color: #6c757d;\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    width: 100%;\n    padding-right: calc(var(--bs-gutter-x) * 0.5);\n    padding-left: calc(var(--bs-gutter-x) * 0.5);\n    margin-right: auto;\n    margin-left: auto;\n}\n\n@media (min-width: 576px) {\n\n    .container-sm,\n    .container {\n        max-width: 540px;\n    }\n}\n\n@media (min-width: 768px) {\n\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 720px;\n    }\n}\n\n@media (min-width: 992px) {\n\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 960px;\n    }\n}\n\n@media (min-width: 1200px) {\n\n    .container-xl,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 1140px;\n    }\n}\n\n@media (min-width: 1400px) {\n\n    .container-xxl,\n    .container-xl,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container {\n        max-width: 1320px;\n    }\n}\n\n.row {\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(-1 * var(--bs-gutter-y));\n    margin-right: calc(-0.5 * var(--bs-gutter-x));\n    margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n\n.row>* {\n    flex-shrink: 0;\n    width: 100%;\n    max-width: 100%;\n    padding-right: calc(var(--bs-gutter-x) * 0.5);\n    padding-left: calc(var(--bs-gutter-x) * 0.5);\n    margin-top: var(--bs-gutter-y);\n}\n\n.col {\n    flex: 1 0 0%;\n}\n\n.row-cols-auto>* {\n    flex: 0 0 auto;\n    width: auto;\n}\n\n.row-cols-1>* {\n    flex: 0 0 auto;\n    width: 100%;\n}\n\n.row-cols-2>* {\n    flex: 0 0 auto;\n    width: 50%;\n}\n\n.row-cols-3>* {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n}\n\n.row-cols-4>* {\n    flex: 0 0 auto;\n    width: 25%;\n}\n\n.row-cols-5>* {\n    flex: 0 0 auto;\n    width: 20%;\n}\n\n.row-cols-6>* {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n}\n\n.col-auto {\n    flex: 0 0 auto;\n    width: auto;\n}\n\n.col-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n}\n\n.col-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n}\n\n.col-3 {\n    flex: 0 0 auto;\n    width: 25%;\n}\n\n.col-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n}\n\n.col-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n}\n\n.col-6 {\n    flex: 0 0 auto;\n    width: 50%;\n}\n\n.col-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n}\n\n.col-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n}\n\n.col-9 {\n    flex: 0 0 auto;\n    width: 75%;\n}\n\n.col-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n}\n\n.col-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n}\n\n.col-12 {\n    flex: 0 0 auto;\n    width: 100%;\n}\n\n.offset-1 {\n    margin-left: 8.33333333%;\n}\n\n.offset-2 {\n    margin-left: 16.66666667%;\n}\n\n.offset-3 {\n    margin-left: 25%;\n}\n\n.offset-4 {\n    margin-left: 33.33333333%;\n}\n\n.offset-5 {\n    margin-left: 41.66666667%;\n}\n\n.offset-6 {\n    margin-left: 50%;\n}\n\n.offset-7 {\n    margin-left: 58.33333333%;\n}\n\n.offset-8 {\n    margin-left: 66.66666667%;\n}\n\n.offset-9 {\n    margin-left: 75%;\n}\n\n.offset-10 {\n    margin-left: 83.33333333%;\n}\n\n.offset-11 {\n    margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n    --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n    --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n    --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n    --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n    --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n    --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n    --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n    --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n    --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n    --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n    --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n    --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n    .col-sm {\n        flex: 1 0 0%;\n    }\n\n    .row-cols-sm-auto>* {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .row-cols-sm-1>* {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row-cols-sm-2>* {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .row-cols-sm-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%;\n    }\n\n    .row-cols-sm-4>* {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .row-cols-sm-5>* {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .row-cols-sm-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%;\n    }\n\n    .col-sm-auto {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .col-sm-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%;\n    }\n\n    .col-sm-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-sm-3 {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .col-sm-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .col-sm-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%;\n    }\n\n    .col-sm-6 {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .col-sm-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%;\n    }\n\n    .col-sm-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%;\n    }\n\n    .col-sm-9 {\n        flex: 0 0 auto;\n        width: 75%;\n    }\n\n    .col-sm-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%;\n    }\n\n    .col-sm-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%;\n    }\n\n    .col-sm-12 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .offset-sm-0 {\n        margin-left: 0;\n    }\n\n    .offset-sm-1 {\n        margin-left: 8.33333333%;\n    }\n\n    .offset-sm-2 {\n        margin-left: 16.66666667%;\n    }\n\n    .offset-sm-3 {\n        margin-left: 25%;\n    }\n\n    .offset-sm-4 {\n        margin-left: 33.33333333%;\n    }\n\n    .offset-sm-5 {\n        margin-left: 41.66666667%;\n    }\n\n    .offset-sm-6 {\n        margin-left: 50%;\n    }\n\n    .offset-sm-7 {\n        margin-left: 58.33333333%;\n    }\n\n    .offset-sm-8 {\n        margin-left: 66.66666667%;\n    }\n\n    .offset-sm-9 {\n        margin-left: 75%;\n    }\n\n    .offset-sm-10 {\n        margin-left: 83.33333333%;\n    }\n\n    .offset-sm-11 {\n        margin-left: 91.66666667%;\n    }\n\n    .g-sm-0,\n    .gx-sm-0 {\n        --bs-gutter-x: 0;\n    }\n\n    .g-sm-0,\n    .gy-sm-0 {\n        --bs-gutter-y: 0;\n    }\n\n    .g-sm-1,\n    .gx-sm-1 {\n        --bs-gutter-x: 0.25rem;\n    }\n\n    .g-sm-1,\n    .gy-sm-1 {\n        --bs-gutter-y: 0.25rem;\n    }\n\n    .g-sm-2,\n    .gx-sm-2 {\n        --bs-gutter-x: 0.5rem;\n    }\n\n    .g-sm-2,\n    .gy-sm-2 {\n        --bs-gutter-y: 0.5rem;\n    }\n\n    .g-sm-3,\n    .gx-sm-3 {\n        --bs-gutter-x: 1rem;\n    }\n\n    .g-sm-3,\n    .gy-sm-3 {\n        --bs-gutter-y: 1rem;\n    }\n\n    .g-sm-4,\n    .gx-sm-4 {\n        --bs-gutter-x: 1.5rem;\n    }\n\n    .g-sm-4,\n    .gy-sm-4 {\n        --bs-gutter-y: 1.5rem;\n    }\n\n    .g-sm-5,\n    .gx-sm-5 {\n        --bs-gutter-x: 3rem;\n    }\n\n    .g-sm-5,\n    .gy-sm-5 {\n        --bs-gutter-y: 3rem;\n    }\n}\n\n@media (min-width: 768px) {\n    .col-md {\n        flex: 1 0 0%;\n    }\n\n    .row-cols-md-auto>* {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .row-cols-md-1>* {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row-cols-md-2>* {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .row-cols-md-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%;\n    }\n\n    .row-cols-md-4>* {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .row-cols-md-5>* {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .row-cols-md-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%;\n    }\n\n    .col-md-auto {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .col-md-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%;\n    }\n\n    .col-md-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-md-3 {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .col-md-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .col-md-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%;\n    }\n\n    .col-md-6 {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .col-md-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%;\n    }\n\n    .col-md-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%;\n    }\n\n    .col-md-9 {\n        flex: 0 0 auto;\n        width: 75%;\n    }\n\n    .col-md-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%;\n    }\n\n    .col-md-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%;\n    }\n\n    .col-md-12 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .offset-md-0 {\n        margin-left: 0;\n    }\n\n    .offset-md-1 {\n        margin-left: 8.33333333%;\n    }\n\n    .offset-md-2 {\n        margin-left: 16.66666667%;\n    }\n\n    .offset-md-3 {\n        margin-left: 25%;\n    }\n\n    .offset-md-4 {\n        margin-left: 33.33333333%;\n    }\n\n    .offset-md-5 {\n        margin-left: 41.66666667%;\n    }\n\n    .offset-md-6 {\n        margin-left: 50%;\n    }\n\n    .offset-md-7 {\n        margin-left: 58.33333333%;\n    }\n\n    .offset-md-8 {\n        margin-left: 66.66666667%;\n    }\n\n    .offset-md-9 {\n        margin-left: 75%;\n    }\n\n    .offset-md-10 {\n        margin-left: 83.33333333%;\n    }\n\n    .offset-md-11 {\n        margin-left: 91.66666667%;\n    }\n\n    .g-md-0,\n    .gx-md-0 {\n        --bs-gutter-x: 0;\n    }\n\n    .g-md-0,\n    .gy-md-0 {\n        --bs-gutter-y: 0;\n    }\n\n    .g-md-1,\n    .gx-md-1 {\n        --bs-gutter-x: 0.25rem;\n    }\n\n    .g-md-1,\n    .gy-md-1 {\n        --bs-gutter-y: 0.25rem;\n    }\n\n    .g-md-2,\n    .gx-md-2 {\n        --bs-gutter-x: 0.5rem;\n    }\n\n    .g-md-2,\n    .gy-md-2 {\n        --bs-gutter-y: 0.5rem;\n    }\n\n    .g-md-3,\n    .gx-md-3 {\n        --bs-gutter-x: 1rem;\n    }\n\n    .g-md-3,\n    .gy-md-3 {\n        --bs-gutter-y: 1rem;\n    }\n\n    .g-md-4,\n    .gx-md-4 {\n        --bs-gutter-x: 1.5rem;\n    }\n\n    .g-md-4,\n    .gy-md-4 {\n        --bs-gutter-y: 1.5rem;\n    }\n\n    .g-md-5,\n    .gx-md-5 {\n        --bs-gutter-x: 3rem;\n    }\n\n    .g-md-5,\n    .gy-md-5 {\n        --bs-gutter-y: 3rem;\n    }\n}\n\n@media (min-width: 992px) {\n    .col-lg {\n        flex: 1 0 0%;\n    }\n\n    .row-cols-lg-auto>* {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .row-cols-lg-1>* {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row-cols-lg-2>* {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .row-cols-lg-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%;\n    }\n\n    .row-cols-lg-4>* {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .row-cols-lg-5>* {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .row-cols-lg-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%;\n    }\n\n    .col-lg-auto {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .col-lg-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%;\n    }\n\n    .col-lg-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-lg-3 {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .col-lg-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .col-lg-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%;\n    }\n\n    .col-lg-6 {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .col-lg-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%;\n    }\n\n    .col-lg-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%;\n    }\n\n    .col-lg-9 {\n        flex: 0 0 auto;\n        width: 75%;\n    }\n\n    .col-lg-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%;\n    }\n\n    .col-lg-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%;\n    }\n\n    .col-lg-12 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .offset-lg-0 {\n        margin-left: 0;\n    }\n\n    .offset-lg-1 {\n        margin-left: 8.33333333%;\n    }\n\n    .offset-lg-2 {\n        margin-left: 16.66666667%;\n    }\n\n    .offset-lg-3 {\n        margin-left: 25%;\n    }\n\n    .offset-lg-4 {\n        margin-left: 33.33333333%;\n    }\n\n    .offset-lg-5 {\n        margin-left: 41.66666667%;\n    }\n\n    .offset-lg-6 {\n        margin-left: 50%;\n    }\n\n    .offset-lg-7 {\n        margin-left: 58.33333333%;\n    }\n\n    .offset-lg-8 {\n        margin-left: 66.66666667%;\n    }\n\n    .offset-lg-9 {\n        margin-left: 75%;\n    }\n\n    .offset-lg-10 {\n        margin-left: 83.33333333%;\n    }\n\n    .offset-lg-11 {\n        margin-left: 91.66666667%;\n    }\n\n    .g-lg-0,\n    .gx-lg-0 {\n        --bs-gutter-x: 0;\n    }\n\n    .g-lg-0,\n    .gy-lg-0 {\n        --bs-gutter-y: 0;\n    }\n\n    .g-lg-1,\n    .gx-lg-1 {\n        --bs-gutter-x: 0.25rem;\n    }\n\n    .g-lg-1,\n    .gy-lg-1 {\n        --bs-gutter-y: 0.25rem;\n    }\n\n    .g-lg-2,\n    .gx-lg-2 {\n        --bs-gutter-x: 0.5rem;\n    }\n\n    .g-lg-2,\n    .gy-lg-2 {\n        --bs-gutter-y: 0.5rem;\n    }\n\n    .g-lg-3,\n    .gx-lg-3 {\n        --bs-gutter-x: 1rem;\n    }\n\n    .g-lg-3,\n    .gy-lg-3 {\n        --bs-gutter-y: 1rem;\n    }\n\n    .g-lg-4,\n    .gx-lg-4 {\n        --bs-gutter-x: 1.5rem;\n    }\n\n    .g-lg-4,\n    .gy-lg-4 {\n        --bs-gutter-y: 1.5rem;\n    }\n\n    .g-lg-5,\n    .gx-lg-5 {\n        --bs-gutter-x: 3rem;\n    }\n\n    .g-lg-5,\n    .gy-lg-5 {\n        --bs-gutter-y: 3rem;\n    }\n}\n\n@media (min-width: 1200px) {\n    .col-xl {\n        flex: 1 0 0%;\n    }\n\n    .row-cols-xl-auto>* {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .row-cols-xl-1>* {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row-cols-xl-2>* {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .row-cols-xl-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%;\n    }\n\n    .row-cols-xl-4>* {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .row-cols-xl-5>* {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .row-cols-xl-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%;\n    }\n\n    .col-xl-auto {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .col-xl-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%;\n    }\n\n    .col-xl-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-xl-3 {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .col-xl-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .col-xl-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%;\n    }\n\n    .col-xl-6 {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .col-xl-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%;\n    }\n\n    .col-xl-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%;\n    }\n\n    .col-xl-9 {\n        flex: 0 0 auto;\n        width: 75%;\n    }\n\n    .col-xl-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%;\n    }\n\n    .col-xl-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%;\n    }\n\n    .col-xl-12 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .offset-xl-0 {\n        margin-left: 0;\n    }\n\n    .offset-xl-1 {\n        margin-left: 8.33333333%;\n    }\n\n    .offset-xl-2 {\n        margin-left: 16.66666667%;\n    }\n\n    .offset-xl-3 {\n        margin-left: 25%;\n    }\n\n    .offset-xl-4 {\n        margin-left: 33.33333333%;\n    }\n\n    .offset-xl-5 {\n        margin-left: 41.66666667%;\n    }\n\n    .offset-xl-6 {\n        margin-left: 50%;\n    }\n\n    .offset-xl-7 {\n        margin-left: 58.33333333%;\n    }\n\n    .offset-xl-8 {\n        margin-left: 66.66666667%;\n    }\n\n    .offset-xl-9 {\n        margin-left: 75%;\n    }\n\n    .offset-xl-10 {\n        margin-left: 83.33333333%;\n    }\n\n    .offset-xl-11 {\n        margin-left: 91.66666667%;\n    }\n\n    .g-xl-0,\n    .gx-xl-0 {\n        --bs-gutter-x: 0;\n    }\n\n    .g-xl-0,\n    .gy-xl-0 {\n        --bs-gutter-y: 0;\n    }\n\n    .g-xl-1,\n    .gx-xl-1 {\n        --bs-gutter-x: 0.25rem;\n    }\n\n    .g-xl-1,\n    .gy-xl-1 {\n        --bs-gutter-y: 0.25rem;\n    }\n\n    .g-xl-2,\n    .gx-xl-2 {\n        --bs-gutter-x: 0.5rem;\n    }\n\n    .g-xl-2,\n    .gy-xl-2 {\n        --bs-gutter-y: 0.5rem;\n    }\n\n    .g-xl-3,\n    .gx-xl-3 {\n        --bs-gutter-x: 1rem;\n    }\n\n    .g-xl-3,\n    .gy-xl-3 {\n        --bs-gutter-y: 1rem;\n    }\n\n    .g-xl-4,\n    .gx-xl-4 {\n        --bs-gutter-x: 1.5rem;\n    }\n\n    .g-xl-4,\n    .gy-xl-4 {\n        --bs-gutter-y: 1.5rem;\n    }\n\n    .g-xl-5,\n    .gx-xl-5 {\n        --bs-gutter-x: 3rem;\n    }\n\n    .g-xl-5,\n    .gy-xl-5 {\n        --bs-gutter-y: 3rem;\n    }\n}\n\n@media (min-width: 1400px) {\n    .col-xxl {\n        flex: 1 0 0%;\n    }\n\n    .row-cols-xxl-auto>* {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .row-cols-xxl-1>* {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .row-cols-xxl-2>* {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .row-cols-xxl-3>* {\n        flex: 0 0 auto;\n        width: 33.3333333333%;\n    }\n\n    .row-cols-xxl-4>* {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .row-cols-xxl-5>* {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .row-cols-xxl-6>* {\n        flex: 0 0 auto;\n        width: 16.6666666667%;\n    }\n\n    .col-xxl-auto {\n        flex: 0 0 auto;\n        width: auto;\n    }\n\n    .col-xxl-1 {\n        flex: 0 0 auto;\n        width: 8.33333333%;\n    }\n\n    .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 16.66666667%;\n    }\n\n    .col-xxl-3 {\n        flex: 0 0 auto;\n        width: 25%;\n    }\n\n    .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 33.33333333%;\n    }\n\n    .col-xxl-5 {\n        flex: 0 0 auto;\n        width: 41.66666667%;\n    }\n\n    .col-xxl-6 {\n        flex: 0 0 auto;\n        width: 50%;\n    }\n\n    .col-xxl-7 {\n        flex: 0 0 auto;\n        width: 58.33333333%;\n    }\n\n    .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 66.66666667%;\n    }\n\n    .col-xxl-9 {\n        flex: 0 0 auto;\n        width: 75%;\n    }\n\n    .col-xxl-10 {\n        flex: 0 0 auto;\n        width: 83.33333333%;\n    }\n\n    .col-xxl-11 {\n        flex: 0 0 auto;\n        width: 91.66666667%;\n    }\n\n    .col-xxl-12 {\n        flex: 0 0 auto;\n        width: 100%;\n    }\n\n    .offset-xxl-0 {\n        margin-left: 0;\n    }\n\n    .offset-xxl-1 {\n        margin-left: 8.33333333%;\n    }\n\n    .offset-xxl-2 {\n        margin-left: 16.66666667%;\n    }\n\n    .offset-xxl-3 {\n        margin-left: 25%;\n    }\n\n    .offset-xxl-4 {\n        margin-left: 33.33333333%;\n    }\n\n    .offset-xxl-5 {\n        margin-left: 41.66666667%;\n    }\n\n    .offset-xxl-6 {\n        margin-left: 50%;\n    }\n\n    .offset-xxl-7 {\n        margin-left: 58.33333333%;\n    }\n\n    .offset-xxl-8 {\n        margin-left: 66.66666667%;\n    }\n\n    .offset-xxl-9 {\n        margin-left: 75%;\n    }\n\n    .offset-xxl-10 {\n        margin-left: 83.33333333%;\n    }\n\n    .offset-xxl-11 {\n        margin-left: 91.66666667%;\n    }\n\n    .g-xxl-0,\n    .gx-xxl-0 {\n        --bs-gutter-x: 0;\n    }\n\n    .g-xxl-0,\n    .gy-xxl-0 {\n        --bs-gutter-y: 0;\n    }\n\n    .g-xxl-1,\n    .gx-xxl-1 {\n        --bs-gutter-x: 0.25rem;\n    }\n\n    .g-xxl-1,\n    .gy-xxl-1 {\n        --bs-gutter-y: 0.25rem;\n    }\n\n    .g-xxl-2,\n    .gx-xxl-2 {\n        --bs-gutter-x: 0.5rem;\n    }\n\n    .g-xxl-2,\n    .gy-xxl-2 {\n        --bs-gutter-y: 0.5rem;\n    }\n\n    .g-xxl-3,\n    .gx-xxl-3 {\n        --bs-gutter-x: 1rem;\n    }\n\n    .g-xxl-3,\n    .gy-xxl-3 {\n        --bs-gutter-y: 1rem;\n    }\n\n    .g-xxl-4,\n    .gx-xxl-4 {\n        --bs-gutter-x: 1.5rem;\n    }\n\n    .g-xxl-4,\n    .gy-xxl-4 {\n        --bs-gutter-y: 1.5rem;\n    }\n\n    .g-xxl-5,\n    .gx-xxl-5 {\n        --bs-gutter-x: 3rem;\n    }\n\n    .g-xxl-5,\n    .gy-xxl-5 {\n        --bs-gutter-y: 3rem;\n    }\n}\n\n.table {\n    --bs-table-color: var(--bs-body-color);\n    --bs-table-bg: transparent;\n    --bs-table-border-color: var(--bs-border-color);\n    --bs-table-accent-bg: transparent;\n    --bs-table-striped-color: var(--bs-body-color);\n    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n    --bs-table-active-color: var(--bs-body-color);\n    --bs-table-active-bg: rgba(0, 0, 0, 0.1);\n    --bs-table-hover-color: var(--bs-body-color);\n    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);\n    width: 100%;\n    margin-bottom: 1rem;\n    color: var(--bs-table-color);\n    vertical-align: top;\n    border-color: var(--bs-table-border-color);\n}\n\n.table> :not(caption)>*>* {\n    padding: 0.5rem 0.5rem;\n    background-color: var(--bs-table-bg);\n    border-bottom-width: 0.125rem;\n    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n\n.table>tbody {\n    vertical-align: inherit;\n}\n\n.table>thead {\n    vertical-align: bottom;\n}\n\n.table-group-divider {\n    border-top: 0.25rem solid currentcolor;\n}\n\n.caption-top {\n    caption-side: top;\n}\n\n.table-sm> :not(caption)>*>* {\n    padding: 0.25rem 0.25rem;\n}\n\n.table-bordered> :not(caption)>* {\n    border-width: 0.125rem 0;\n}\n\n.table-bordered> :not(caption)>*>* {\n    border-width: 0 0.125rem;\n}\n\n.table-borderless> :not(caption)>*>* {\n    border-bottom-width: 0;\n}\n\n.table-borderless> :not(:first-child) {\n    border-top-width: 0;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n    --bs-table-accent-bg: var(--bs-table-striped-bg);\n    color: var(--bs-table-striped-color);\n}\n\n.table-striped-columns> :not(caption)>tr> :nth-child(even) {\n    --bs-table-accent-bg: var(--bs-table-striped-bg);\n    color: var(--bs-table-striped-color);\n}\n\n.table-active {\n    --bs-table-accent-bg: var(--bs-table-active-bg);\n    color: var(--bs-table-active-color);\n}\n\n.table-hover>tbody>tr:hover>* {\n    --bs-table-accent-bg: var(--bs-table-hover-bg);\n    color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n    --bs-table-color: #000;\n    --bs-table-bg: #d1f2eb;\n    --bs-table-border-color: #bcdad4;\n    --bs-table-striped-bg: #c7e6df;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #bcdad4;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #c1e0d9;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n    --bs-table-color: #000;\n    --bs-table-bg: #d5d8dc;\n    --bs-table-border-color: #c0c2c6;\n    --bs-table-striped-bg: #cacdd1;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #c0c2c6;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #c5c8cc;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n    --bs-table-color: #000;\n    --bs-table-bg: #d1e7dd;\n    --bs-table-border-color: #bcd0c7;\n    --bs-table-striped-bg: #c7dbd2;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #bcd0c7;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #c1d6cc;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n    --bs-table-color: #000;\n    --bs-table-bg: #cff4fc;\n    --bs-table-border-color: #badce3;\n    --bs-table-striped-bg: #c5e8ef;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #badce3;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #bfe2e9;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n    --bs-table-color: #000;\n    --bs-table-bg: #fff3cd;\n    --bs-table-border-color: #e6dbb9;\n    --bs-table-striped-bg: #f2e7c3;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #e6dbb9;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #ece1be;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n    --bs-table-color: #000;\n    --bs-table-bg: #f8d7da;\n    --bs-table-border-color: #dfc2c4;\n    --bs-table-striped-bg: #eccccf;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #dfc2c4;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #e5c7ca;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n    --bs-table-color: #000;\n    --bs-table-bg: #f8f9fa;\n    --bs-table-border-color: #dfe0e1;\n    --bs-table-striped-bg: #ecedee;\n    --bs-table-striped-color: #000;\n    --bs-table-active-bg: #dfe0e1;\n    --bs-table-active-color: #000;\n    --bs-table-hover-bg: #e5e6e7;\n    --bs-table-hover-color: #000;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n    --bs-table-color: #fff;\n    --bs-table-bg: #212529;\n    --bs-table-border-color: #373b3e;\n    --bs-table-striped-bg: #2c3034;\n    --bs-table-striped-color: #fff;\n    --bs-table-active-bg: #373b3e;\n    --bs-table-active-color: #fff;\n    --bs-table-hover-bg: #323539;\n    --bs-table-hover-color: #fff;\n    color: var(--bs-table-color);\n    border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n    .table-responsive-sm {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .table-responsive-md {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n@media (max-width: 991.98px) {\n    .table-responsive-lg {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .table-responsive-xl {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .table-responsive-xxl {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n.form-label {\n    margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    margin-bottom: 0;\n    font-size: inherit;\n    line-height: 1.5;\n}\n\n.col-form-label-lg {\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n    font-size: 1.25rem;\n}\n\n.col-form-label-sm {\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n    font-size: 0.875rem;\n}\n\n.form-text {\n    margin-top: 0.25rem;\n    font-size: 0.875em;\n    color: #6c757d;\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0.125rem solid #ced4da;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0.5rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-control {\n        transition: none;\n    }\n}\n\n.form-control[type=file] {\n    overflow: hidden;\n}\n\n.form-control[type=file]:not(:disabled):not([readonly]) {\n    cursor: pointer;\n}\n\n.form-control:focus {\n    color: #212529;\n    background-color: #fff;\n    border-color: #8ddece;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n}\n\n.form-control::-webkit-date-and-time-value {\n    height: 1.5em;\n}\n\n.form-control::-moz-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control::placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control:disabled {\n    background-color: #e9ecef;\n    opacity: 1;\n}\n\n.form-control::file-selector-button {\n    padding: 0.375rem 0.75rem;\n    margin: -0.375rem -0.75rem;\n    -webkit-margin-end: 0.75rem;\n    margin-inline-end: 0.75rem;\n    color: #212529;\n    background-color: #e9ecef;\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: 0.125rem;\n    border-radius: 0;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-control::file-selector-button {\n        transition: none;\n    }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: #dde0e3;\n}\n\n.form-control-plaintext {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0;\n    margin-bottom: 0;\n    line-height: 1.5;\n    color: #212529;\n    background-color: transparent;\n    border: solid transparent;\n    border-width: 0.125rem 0;\n}\n\n.form-control-plaintext:focus {\n    outline: 0;\n}\n\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.form-control-sm {\n    min-height: calc(1.5em + 0.75rem);\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border-radius: 0.25rem;\n}\n\n.form-control-sm::file-selector-button {\n    padding: 0.25rem 0.5rem;\n    margin: -0.25rem -0.5rem;\n    -webkit-margin-end: 0.5rem;\n    margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n    min-height: calc(1.5em + 1.25rem);\n    padding: 0.5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: 0.75rem;\n}\n\n.form-control-lg::file-selector-button {\n    padding: 0.5rem 1rem;\n    margin: -0.5rem -1rem;\n    -webkit-margin-end: 1rem;\n    margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n    min-height: calc(1.5em + 1rem);\n}\n\ntextarea.form-control-sm {\n    min-height: calc(1.5em + 0.75rem);\n}\n\ntextarea.form-control-lg {\n    min-height: calc(1.5em + 1.25rem);\n}\n\n.form-control-color {\n    width: 3rem;\n    height: calc(1.5em + 1rem);\n    padding: 0.375rem;\n}\n\n.form-control-color:not(:disabled):not([readonly]) {\n    cursor: pointer;\n}\n\n.form-control-color::-moz-color-swatch {\n    border: 0 !important;\n    border-radius: 0.5rem;\n}\n\n.form-control-color::-webkit-color-swatch {\n    border-radius: 0.5rem;\n}\n\n.form-control-color.form-control-sm {\n    height: calc(1.5em + 0.75rem);\n}\n\n.form-control-color.form-control-lg {\n    height: calc(1.5em + 1.25rem);\n}\n\n.form-select {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n    -moz-padding-start: calc(0.75rem - 3px);\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 16px 12px;\n    border: 0.125rem solid #ced4da;\n    border-radius: 0.5rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-select {\n        transition: none;\n    }\n}\n\n.form-select:focus {\n    border-color: #8ddece;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n}\n\n.form-select[multiple],\n.form-select[size]:not([size=\"1\"]) {\n    padding-right: 0.75rem;\n    background-image: none;\n}\n\n.form-select:disabled {\n    background-color: #e9ecef;\n}\n\n.form-select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #212529;\n}\n\n.form-select-sm {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    padding-left: 0.5rem;\n    font-size: 0.875rem;\n    border-radius: 0.25rem;\n}\n\n.form-select-lg {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    padding-left: 1rem;\n    font-size: 1.25rem;\n    border-radius: 0.75rem;\n}\n\n.form-check {\n    display: block;\n    min-height: 1.5rem;\n    padding-left: 1.5em;\n    margin-bottom: 0.125rem;\n}\n\n.form-check .form-check-input {\n    float: left;\n    margin-left: -1.5em;\n}\n\n.form-check-reverse {\n    padding-right: 1.5em;\n    padding-left: 0;\n    text-align: right;\n}\n\n.form-check-reverse .form-check-input {\n    float: right;\n    margin-right: -1.5em;\n    margin-left: 0;\n}\n\n.form-check-input {\n    width: 1em;\n    height: 1em;\n    margin-top: 0.25em;\n    vertical-align: top;\n    background-color: #fff;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n}\n\n.form-check-input[type=checkbox] {\n    border-radius: 0.25em;\n}\n\n.form-check-input[type=radio] {\n    border-radius: 50%;\n}\n\n.form-check-input:active {\n    filter: brightness(90%);\n}\n\n.form-check-input:focus {\n    border-color: #8ddece;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n}\n\n.form-check-input:checked {\n    background-color: #0085CA;\n    border-color: #0085CA;\n}\n\n.form-check-input:checked[type=checkbox] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:checked[type=radio] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-input[type=checkbox]:indeterminate {\n    background-color: #0085CA;\n    border-color: #0085CA;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: 0.5;\n}\n\n.form-check-input[disabled]~.form-check-label,\n.form-check-input:disabled~.form-check-label {\n    cursor: default;\n    opacity: 0.5;\n}\n\n.form-switch {\n    padding-left: 2.5em;\n}\n\n.form-switch .form-check-input {\n    width: 2em;\n    margin-left: -2.5em;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n    background-position: left center;\n    border-radius: 2em;\n    transition: background-position 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-switch .form-check-input {\n        transition: none;\n    }\n}\n\n.form-switch .form-check-input:focus {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%238ddece'/%3e%3c/svg%3e\");\n}\n\n.form-switch .form-check-input:checked {\n    background-position: right center;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-switch.form-check-reverse {\n    padding-right: 2.5em;\n    padding-left: 0;\n}\n\n.form-switch.form-check-reverse .form-check-input {\n    margin-right: -2.5em;\n    margin-left: 0;\n}\n\n.form-check-inline {\n    display: inline-block;\n    margin-right: 1rem;\n}\n\n.btn-check {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none;\n}\n\n.btn-check[disabled]+.btn,\n.btn-check:disabled+.btn {\n    pointer-events: none;\n    filter: none;\n    opacity: 0.65;\n}\n\n.form-range {\n    width: 100%;\n    height: 1.5rem;\n    padding: 0;\n    background-color: transparent;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n.form-range:focus {\n    outline: 0;\n}\n\n.form-range:focus::-webkit-slider-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n}\n\n.form-range:focus::-moz-range-thumb {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n}\n\n.form-range::-moz-focus-outer {\n    border: 0;\n}\n\n.form-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -0.25rem;\n    background-color: #0085CA;\n    border: 0;\n    border-radius: 1rem;\n    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-range::-webkit-slider-thumb {\n        -webkit-transition: none;\n        transition: none;\n    }\n}\n\n.form-range::-webkit-slider-thumb:active {\n    background-color: #baebe1;\n}\n\n.form-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dee2e6;\n    border-color: transparent;\n    border-radius: 1rem;\n}\n\n.form-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #0085CA;\n    border: 0;\n    border-radius: 1rem;\n    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-range::-moz-range-thumb {\n        -moz-transition: none;\n        transition: none;\n    }\n}\n\n.form-range::-moz-range-thumb:active {\n    background-color: #baebe1;\n}\n\n.form-range::-moz-range-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dee2e6;\n    border-color: transparent;\n    border-radius: 1rem;\n}\n\n.form-range:disabled {\n    pointer-events: none;\n}\n\n.form-range:disabled::-webkit-slider-thumb {\n    background-color: #adb5bd;\n}\n\n.form-range:disabled::-moz-range-thumb {\n    background-color: #adb5bd;\n}\n\n.form-floating {\n    position: relative;\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext,\n.form-floating>.form-select {\n    height: 5.5rem;\n    line-height: 1.25;\n}\n\n.form-floating>label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    padding: 1.5rem 0;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: 0.125rem solid transparent;\n    transform-origin: 0 0;\n    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-floating>label {\n        transition: none;\n    }\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext {\n    padding: 1.5rem 0;\n}\n\n.form-floating>.form-control::-moz-placeholder,\n.form-floating>.form-control-plaintext::-moz-placeholder {\n    color: transparent;\n}\n\n.form-floating>.form-control::placeholder,\n.form-floating>.form-control-plaintext::placeholder {\n    color: transparent;\n}\n\n.form-floating>.form-control:not(:-moz-placeholder-shown),\n.form-floating>.form-control-plaintext:not(:-moz-placeholder-shown) {\n    padding-top: 2.5rem;\n    padding-bottom: 1.5rem;\n}\n\n.form-floating>.form-control:focus,\n.form-floating>.form-control:not(:placeholder-shown),\n.form-floating>.form-control-plaintext:focus,\n.form-floating>.form-control-plaintext:not(:placeholder-shown) {\n    padding-top: 2.5rem;\n    padding-bottom: 1.5rem;\n}\n\n.form-floating>.form-control:-webkit-autofill,\n.form-floating>.form-control-plaintext:-webkit-autofill {\n    padding-top: 2.5rem;\n    padding-bottom: 1.5rem;\n}\n\n.form-floating>.form-select {\n    padding-top: 2.5rem;\n    padding-bottom: 1.5rem;\n}\n\n.form-floating>.form-control:not(:-moz-placeholder-shown)~label {\n    opacity: 0.65;\n    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);\n}\n\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-control-plaintext~label,\n.form-floating>.form-select~label {\n    opacity: 0.65;\n    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);\n}\n\n.form-floating>.form-control:-webkit-autofill~label {\n    opacity: 0.65;\n    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);\n}\n\n.form-floating>.form-control-plaintext~label {\n    border-width: 0.125rem 0;\n}\n\n.input-group {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    width: 100%;\n}\n\n.input-group>.form-control,\n.input-group>.form-select,\n.input-group>.form-floating {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0;\n}\n\n.input-group>.form-control:focus,\n.input-group>.form-select:focus,\n.input-group>.form-floating:focus-within {\n    z-index: 5;\n}\n\n.input-group .btn {\n    position: relative;\n    z-index: 2;\n}\n\n.input-group .btn:focus {\n    z-index: 5;\n}\n\n.input-group-text {\n    display: flex;\n    align-items: center;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #e9ecef;\n    border: 0.125rem solid #ced4da;\n    border-radius: 0.5rem;\n}\n\n.input-group-lg>.form-control,\n.input-group-lg>.form-select,\n.input-group-lg>.input-group-text,\n.input-group-lg>.btn {\n    padding: 0.5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: 0.75rem;\n}\n\n.input-group-sm>.form-control,\n.input-group-sm>.form-select,\n.input-group-sm>.input-group-text,\n.input-group-sm>.btn {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border-radius: 0.25rem;\n}\n\n.input-group-lg>.form-select,\n.input-group-sm>.form-select {\n    padding-right: 3rem;\n}\n\n.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    margin-left: -0.125rem;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.input-group>.form-floating:not(:first-child)>.form-control,\n.input-group>.form-floating:not(:first-child)>.form-select {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 0.875em;\n    color: #198754;\n}\n\n.valid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: 0.25rem 0.5rem;\n    margin-top: 0.1rem;\n    font-size: 0.875rem;\n    color: #fff;\n    background-color: rgba(25, 135, 84, 0.9);\n    border-radius: 0.5rem;\n}\n\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip,\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip {\n    display: block;\n}\n\n.was-validated .form-control:valid,\n.form-control.is-valid {\n    border-color: #198754;\n    padding-right: calc(1.5em + 0.75rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(0.375em + 0.1875rem) center;\n    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n    border-color: #198754;\n    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n    padding-right: calc(1.5em + 0.75rem);\n    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid,\n.form-select.is-valid {\n    border-color: #198754;\n}\n\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size=\"1\"],\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size=\"1\"] {\n    padding-right: 4.125rem;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    background-position: right 0.75rem center, center right 2.25rem;\n    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-select:valid:focus,\n.form-select.is-valid:focus {\n    border-color: #198754;\n    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);\n}\n\n.was-validated .form-control-color:valid,\n.form-control-color.is-valid {\n    width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid,\n.form-check-input.is-valid {\n    border-color: #198754;\n}\n\n.was-validated .form-check-input:valid:checked,\n.form-check-input.is-valid:checked {\n    background-color: #198754;\n}\n\n.was-validated .form-check-input:valid:focus,\n.form-check-input.is-valid:focus {\n    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);\n}\n\n.was-validated .form-check-input:valid~.form-check-label,\n.form-check-input.is-valid~.form-check-label {\n    color: #198754;\n}\n\n.form-check-inline .form-check-input~.valid-feedback {\n    margin-left: 0.5em;\n}\n\n.was-validated .input-group>.form-control:not(:focus):valid,\n.input-group>.form-control:not(:focus).is-valid,\n.was-validated .input-group>.form-select:not(:focus):valid,\n.input-group>.form-select:not(:focus).is-valid,\n.was-validated .input-group>.form-floating:not(:focus-within):valid,\n.input-group>.form-floating:not(:focus-within).is-valid {\n    z-index: 3;\n}\n\n.invalid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 0.875em;\n    color: #dc3545;\n}\n\n.invalid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: 0.25rem 0.5rem;\n    margin-top: 0.1rem;\n    font-size: 0.875rem;\n    color: #fff;\n    background-color: rgba(220, 53, 69, 0.9);\n    border-radius: 0.5rem;\n}\n\n.was-validated :invalid~.invalid-feedback,\n.was-validated :invalid~.invalid-tooltip,\n.is-invalid~.invalid-feedback,\n.is-invalid~.invalid-tooltip {\n    display: block;\n}\n\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n    border-color: #dc3545;\n    padding-right: calc(1.5em + 0.75rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(0.375em + 0.1875rem) center;\n    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n    padding-right: calc(1.5em + 0.75rem);\n    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid,\n.form-select.is-invalid {\n    border-color: #dc3545;\n}\n\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"],\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size=\"1\"] {\n    padding-right: 4.125rem;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n    background-position: right 0.75rem center, center right 2.25rem;\n    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-select:invalid:focus,\n.form-select.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .form-control-color:invalid,\n.form-control-color.is-invalid {\n    width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid,\n.form-check-input.is-invalid {\n    border-color: #dc3545;\n}\n\n.was-validated .form-check-input:invalid:checked,\n.form-check-input.is-invalid:checked {\n    background-color: #dc3545;\n}\n\n.was-validated .form-check-input:invalid:focus,\n.form-check-input.is-invalid:focus {\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .form-check-input:invalid~.form-check-label,\n.form-check-input.is-invalid~.form-check-label {\n    color: #dc3545;\n}\n\n.form-check-inline .form-check-input~.invalid-feedback {\n    margin-left: 0.5em;\n}\n\n.was-validated .input-group>.form-control:not(:focus):invalid,\n.input-group>.form-control:not(:focus).is-invalid,\n.was-validated .input-group>.form-select:not(:focus):invalid,\n.input-group>.form-select:not(:focus).is-invalid,\n.was-validated .input-group>.form-floating:not(:focus-within):invalid,\n.input-group>.form-floating:not(:focus-within).is-invalid {\n    z-index: 4;\n}\n\n.btn {\n    --bs-btn-padding-x: 0.75rem;\n    --bs-btn-padding-y: 0.375rem;\n    --bs-btn-font-family: ;\n    --bs-btn-font-size: 1rem;\n    --bs-btn-font-weight: 400;\n    --bs-btn-line-height: 1.5;\n    --bs-btn-color: #212529;\n    --bs-btn-bg: transparent;\n    --bs-btn-border-width: 0.125rem;\n    --bs-btn-border-color: transparent;\n    --bs-btn-border-radius: 0.5rem;\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n    --bs-btn-disabled-opacity: 0.65;\n    --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n    display: inline-block;\n    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n    font-family: var(--bs-btn-font-family);\n    font-size: var(--bs-btn-font-size);\n    font-weight: var(--bs-btn-font-weight);\n    line-height: var(--bs-btn-line-height);\n    color: var(--bs-btn-color);\n    text-align: center;\n    text-decoration: none;\n    vertical-align: middle;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n    border-radius: var(--bs-btn-border-radius);\n    background-color: var(--bs-btn-bg);\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .btn {\n        transition: none;\n    }\n}\n\n.btn:hover {\n    color: var(--bs-btn-hover-color);\n    background-color: var(--bs-btn-hover-bg);\n    border-color: var(--bs-btn-hover-border-color);\n}\n\n.btn-check+.btn:hover {\n    color: var(--bs-btn-color);\n    background-color: var(--bs-btn-bg);\n    border-color: var(--bs-btn-border-color);\n}\n\n.btn:focus-visible {\n    color: var(--bs-btn-hover-color);\n    background-color: var(--bs-btn-hover-bg);\n    border-color: var(--bs-btn-hover-border-color);\n    outline: 0;\n    box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn-check:focus-visible+.btn {\n    border-color: var(--bs-btn-hover-border-color);\n    outline: 0;\n    box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn-check:checked+.btn,\n:not(.btn-check)+.btn:active,\n.btn:first-child:active,\n.btn.active,\n.btn.show {\n    color: var(--bs-btn-active-color);\n    background-color: var(--bs-btn-active-bg);\n    border-color: var(--bs-btn-active-border-color);\n}\n\n.btn-check:checked+.btn:focus-visible,\n:not(.btn-check)+.btn:active:focus-visible,\n.btn:first-child:active:focus-visible,\n.btn.active:focus-visible,\n.btn.show:focus-visible {\n    box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn:disabled,\n.btn.disabled,\nfieldset:disabled .btn {\n    color: var(--bs-btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--bs-btn-disabled-bg);\n    border-color: var(--bs-btn-disabled-border-color);\n    opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #0085CA;\n    --bs-btn-border-color: #0085CA;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #16a085;\n    --bs-btn-hover-border-color: #15967d;\n    --bs-btn-focus-shadow-rgb: 60, 198, 171;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #15967d;\n    --bs-btn-active-border-color: #148d75;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #0085CA;\n    --bs-btn-disabled-border-color: #0085CA;\n}\n\n.btn-secondary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #2c3e50;\n    --bs-btn-border-color: #2c3e50;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #253544;\n    --bs-btn-hover-border-color: #233240;\n    --bs-btn-focus-shadow-rgb: 76, 91, 106;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #233240;\n    --bs-btn-active-border-color: #212f3c;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #2c3e50;\n    --bs-btn-disabled-border-color: #2c3e50;\n}\n\n.btn-success {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #198754;\n    --bs-btn-border-color: #198754;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #157347;\n    --bs-btn-hover-border-color: #146c43;\n    --bs-btn-focus-shadow-rgb: 60, 153, 110;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #146c43;\n    --bs-btn-active-border-color: #13653f;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #198754;\n    --bs-btn-disabled-border-color: #198754;\n}\n\n.btn-info {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #0dcaf0;\n    --bs-btn-border-color: #0dcaf0;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #31d2f2;\n    --bs-btn-hover-border-color: #25cff2;\n    --bs-btn-focus-shadow-rgb: 11, 172, 204;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #3dd5f3;\n    --bs-btn-active-border-color: #25cff2;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #0dcaf0;\n    --bs-btn-disabled-border-color: #0dcaf0;\n}\n\n.btn-warning {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #ffc107;\n    --bs-btn-border-color: #ffc107;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #ffca2c;\n    --bs-btn-hover-border-color: #ffc720;\n    --bs-btn-focus-shadow-rgb: 217, 164, 6;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #ffcd39;\n    --bs-btn-active-border-color: #ffc720;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #ffc107;\n    --bs-btn-disabled-border-color: #ffc107;\n}\n\n.btn-danger {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #dc3545;\n    --bs-btn-border-color: #dc3545;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #bb2d3b;\n    --bs-btn-hover-border-color: #b02a37;\n    --bs-btn-focus-shadow-rgb: 225, 83, 97;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #b02a37;\n    --bs-btn-active-border-color: #a52834;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #dc3545;\n    --bs-btn-disabled-border-color: #dc3545;\n}\n\n.btn-light {\n    --bs-btn-color: #000;\n    --bs-btn-bg: #f8f9fa;\n    --bs-btn-border-color: #f8f9fa;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #d3d4d5;\n    --bs-btn-hover-border-color: #c6c7c8;\n    --bs-btn-focus-shadow-rgb: 211, 212, 213;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #c6c7c8;\n    --bs-btn-active-border-color: #babbbc;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #000;\n    --bs-btn-disabled-bg: #f8f9fa;\n    --bs-btn-disabled-border-color: #f8f9fa;\n}\n\n.btn-dark {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #212529;\n    --bs-btn-border-color: #212529;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #424649;\n    --bs-btn-hover-border-color: #373b3e;\n    --bs-btn-focus-shadow-rgb: 66, 70, 73;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #4d5154;\n    --bs-btn-active-border-color: #373b3e;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #212529;\n    --bs-btn-disabled-border-color: #212529;\n}\n\n.btn-outline-primary {\n    --bs-btn-color: #0085CA;\n    --bs-btn-border-color: #0085CA;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #0085CA;\n    --bs-btn-hover-border-color: #0085CA;\n    --bs-btn-focus-shadow-rgb: 26, 188, 156;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #0085CA;\n    --bs-btn-active-border-color: #0085CA;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #0085CA;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #0085CA;\n    --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n    --bs-btn-color: #2c3e50;\n    --bs-btn-border-color: #2c3e50;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #2c3e50;\n    --bs-btn-hover-border-color: #2c3e50;\n    --bs-btn-focus-shadow-rgb: 44, 62, 80;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #2c3e50;\n    --bs-btn-active-border-color: #2c3e50;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #2c3e50;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #2c3e50;\n    --bs-gradient: none;\n}\n\n.btn-outline-success {\n    --bs-btn-color: #198754;\n    --bs-btn-border-color: #198754;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #198754;\n    --bs-btn-hover-border-color: #198754;\n    --bs-btn-focus-shadow-rgb: 25, 135, 84;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #198754;\n    --bs-btn-active-border-color: #198754;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #198754;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #198754;\n    --bs-gradient: none;\n}\n\n.btn-outline-info {\n    --bs-btn-color: #0dcaf0;\n    --bs-btn-border-color: #0dcaf0;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #0dcaf0;\n    --bs-btn-hover-border-color: #0dcaf0;\n    --bs-btn-focus-shadow-rgb: 13, 202, 240;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #0dcaf0;\n    --bs-btn-active-border-color: #0dcaf0;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #0dcaf0;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #0dcaf0;\n    --bs-gradient: none;\n}\n\n.btn-outline-warning {\n    --bs-btn-color: #ffc107;\n    --bs-btn-border-color: #ffc107;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #ffc107;\n    --bs-btn-hover-border-color: #ffc107;\n    --bs-btn-focus-shadow-rgb: 255, 193, 7;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #ffc107;\n    --bs-btn-active-border-color: #ffc107;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #ffc107;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #ffc107;\n    --bs-gradient: none;\n}\n\n.btn-outline-danger {\n    --bs-btn-color: #dc3545;\n    --bs-btn-border-color: #dc3545;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #dc3545;\n    --bs-btn-hover-border-color: #dc3545;\n    --bs-btn-focus-shadow-rgb: 220, 53, 69;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #dc3545;\n    --bs-btn-active-border-color: #dc3545;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #dc3545;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #dc3545;\n    --bs-gradient: none;\n}\n\n.btn-outline-light {\n    --bs-btn-color: #f8f9fa;\n    --bs-btn-border-color: #f8f9fa;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #f8f9fa;\n    --bs-btn-hover-border-color: #f8f9fa;\n    --bs-btn-focus-shadow-rgb: 248, 249, 250;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #f8f9fa;\n    --bs-btn-active-border-color: #f8f9fa;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #f8f9fa;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #f8f9fa;\n    --bs-gradient: none;\n}\n\n.btn-outline-dark {\n    --bs-btn-color: #212529;\n    --bs-btn-border-color: #212529;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #212529;\n    --bs-btn-hover-border-color: #212529;\n    --bs-btn-focus-shadow-rgb: 33, 37, 41;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #212529;\n    --bs-btn-active-border-color: #212529;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #212529;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #212529;\n    --bs-gradient: none;\n}\n\n.btn-link {\n    --bs-btn-font-weight: 400;\n    --bs-btn-color: var(--bs-link-color);\n    --bs-btn-bg: transparent;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-color: var(--bs-link-hover-color);\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-active-color: var(--bs-link-hover-color);\n    --bs-btn-active-border-color: transparent;\n    --bs-btn-disabled-color: #6c757d;\n    --bs-btn-disabled-border-color: transparent;\n    --bs-btn-box-shadow: none;\n    --bs-btn-focus-shadow-rgb: 60, 198, 171;\n    text-decoration: underline;\n}\n\n.btn-link:focus-visible {\n    color: var(--bs-btn-color);\n}\n\n.btn-link:hover {\n    color: var(--bs-btn-hover-color);\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n    --bs-btn-padding-y: 0.5rem;\n    --bs-btn-padding-x: 1rem;\n    --bs-btn-font-size: 1.25rem;\n    --bs-btn-border-radius: 0.75rem;\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n    --bs-btn-padding-y: 0.25rem;\n    --bs-btn-padding-x: 0.5rem;\n    --bs-btn-font-size: 0.875rem;\n    --bs-btn-border-radius: 0.25rem;\n}\n\n.fade {\n    transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .fade {\n        transition: none;\n    }\n}\n\n.fade:not(.show) {\n    opacity: 0;\n}\n\n.collapse:not(.show) {\n    display: none;\n}\n\n.collapsing {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .collapsing {\n        transition: none;\n    }\n}\n\n.collapsing.collapse-horizontal {\n    width: 0;\n    height: auto;\n    transition: width 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .collapsing.collapse-horizontal {\n        transition: none;\n    }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n    position: relative;\n}\n\n.dropdown-toggle {\n    white-space: nowrap;\n}\n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropdown-menu {\n    --bs-dropdown-zindex: 1000;\n    --bs-dropdown-min-width: 10rem;\n    --bs-dropdown-padding-x: 0;\n    --bs-dropdown-padding-y: 0.5rem;\n    --bs-dropdown-spacer: 0.125rem;\n    --bs-dropdown-font-size: 1rem;\n    --bs-dropdown-color: #212529;\n    --bs-dropdown-bg: #fff;\n    --bs-dropdown-border-color: var(--bs-border-color-translucent);\n    --bs-dropdown-border-radius: 0.5rem;\n    --bs-dropdown-border-width: 0.125rem;\n    --bs-dropdown-inner-border-radius: 0.375rem;\n    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n    --bs-dropdown-divider-margin-y: 0.5rem;\n    --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-dropdown-link-color: #212529;\n    --bs-dropdown-link-hover-color: #1e2125;\n    --bs-dropdown-link-hover-bg: #e9ecef;\n    --bs-dropdown-link-active-color: #fff;\n    --bs-dropdown-link-active-bg: #0085CA;\n    --bs-dropdown-link-disabled-color: #adb5bd;\n    --bs-dropdown-item-padding-x: 1rem;\n    --bs-dropdown-item-padding-y: 0.25rem;\n    --bs-dropdown-header-color: #6c757d;\n    --bs-dropdown-header-padding-x: 1rem;\n    --bs-dropdown-header-padding-y: 0.5rem;\n    position: absolute;\n    z-index: var(--bs-dropdown-zindex);\n    display: none;\n    min-width: var(--bs-dropdown-min-width);\n    padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n    margin: 0;\n    font-size: var(--bs-dropdown-font-size);\n    color: var(--bs-dropdown-color);\n    text-align: left;\n    list-style: none;\n    background-color: var(--bs-dropdown-bg);\n    background-clip: padding-box;\n    border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n    border-radius: var(--bs-dropdown-border-radius);\n}\n\n.dropdown-menu[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n    --bs-position: start;\n}\n\n.dropdown-menu-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n}\n\n.dropdown-menu-end {\n    --bs-position: end;\n}\n\n.dropdown-menu-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n}\n\n@media (min-width: 576px) {\n    .dropdown-menu-sm-start {\n        --bs-position: start;\n    }\n\n    .dropdown-menu-sm-start[data-bs-popper] {\n        right: auto;\n        left: 0;\n    }\n\n    .dropdown-menu-sm-end {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-sm-end[data-bs-popper] {\n        right: 0;\n        left: auto;\n    }\n}\n\n@media (min-width: 768px) {\n    .dropdown-menu-md-start {\n        --bs-position: start;\n    }\n\n    .dropdown-menu-md-start[data-bs-popper] {\n        right: auto;\n        left: 0;\n    }\n\n    .dropdown-menu-md-end {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-md-end[data-bs-popper] {\n        right: 0;\n        left: auto;\n    }\n}\n\n@media (min-width: 992px) {\n    .dropdown-menu-lg-start {\n        --bs-position: start;\n    }\n\n    .dropdown-menu-lg-start[data-bs-popper] {\n        right: auto;\n        left: 0;\n    }\n\n    .dropdown-menu-lg-end {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-lg-end[data-bs-popper] {\n        right: 0;\n        left: auto;\n    }\n}\n\n@media (min-width: 1200px) {\n    .dropdown-menu-xl-start {\n        --bs-position: start;\n    }\n\n    .dropdown-menu-xl-start[data-bs-popper] {\n        right: auto;\n        left: 0;\n    }\n\n    .dropdown-menu-xl-end {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-xl-end[data-bs-popper] {\n        right: 0;\n        left: auto;\n    }\n}\n\n@media (min-width: 1400px) {\n    .dropdown-menu-xxl-start {\n        --bs-position: start;\n    }\n\n    .dropdown-menu-xxl-start[data-bs-popper] {\n        right: auto;\n        left: 0;\n    }\n\n    .dropdown-menu-xxl-end {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-xxl-end[data-bs-popper] {\n        right: 0;\n        left: auto;\n    }\n}\n\n.dropup .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--bs-dropdown-spacer);\n}\n\n.dropup .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0.3em solid;\n    border-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--bs-dropdown-spacer);\n}\n\n.dropend .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid transparent;\n    border-right: 0;\n    border-bottom: 0.3em solid transparent;\n    border-left: 0.3em solid;\n}\n\n.dropend .dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropend .dropdown-toggle::after {\n    vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--bs-dropdown-spacer);\n}\n\n.dropstart .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n}\n\n.dropstart .dropdown-toggle::after {\n    display: none;\n}\n\n.dropstart .dropdown-toggle::before {\n    display: inline-block;\n    margin-right: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid transparent;\n    border-right: 0.3em solid;\n    border-bottom: 0.3em solid transparent;\n}\n\n.dropstart .dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropstart .dropdown-toggle::before {\n    vertical-align: 0;\n}\n\n.dropdown-divider {\n    height: 0;\n    margin: var(--bs-dropdown-divider-margin-y) 0;\n    overflow: hidden;\n    border-top: 1px solid var(--bs-dropdown-divider-bg);\n    opacity: 1;\n}\n\n.dropdown-item {\n    display: block;\n    width: 100%;\n    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n    clear: both;\n    font-weight: 400;\n    color: var(--bs-dropdown-link-color);\n    text-align: inherit;\n    text-decoration: none;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0;\n}\n\n.dropdown-item:hover,\n.dropdown-item:focus {\n    color: var(--bs-dropdown-link-hover-color);\n    background-color: var(--bs-dropdown-link-hover-bg);\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n    color: var(--bs-dropdown-link-active-color);\n    text-decoration: none;\n    background-color: var(--bs-dropdown-link-active-bg);\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n    color: var(--bs-dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n}\n\n.dropdown-menu.show {\n    display: block;\n}\n\n.dropdown-header {\n    display: block;\n    padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n    margin-bottom: 0;\n    font-size: 0.875rem;\n    color: var(--bs-dropdown-header-color);\n    white-space: nowrap;\n}\n\n.dropdown-item-text {\n    display: block;\n    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n    color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n    --bs-dropdown-color: #dee2e6;\n    --bs-dropdown-bg: #343a40;\n    --bs-dropdown-border-color: var(--bs-border-color-translucent);\n    --bs-dropdown-box-shadow: ;\n    --bs-dropdown-link-color: #dee2e6;\n    --bs-dropdown-link-hover-color: #fff;\n    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n    --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n    --bs-dropdown-link-active-color: #fff;\n    --bs-dropdown-link-active-bg: #0085CA;\n    --bs-dropdown-link-disabled-color: #adb5bd;\n    --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n    position: relative;\n    display: inline-flex;\n    vertical-align: middle;\n}\n\n.btn-group>.btn,\n.btn-group-vertical>.btn {\n    position: relative;\n    flex: 1 1 auto;\n}\n\n.btn-group>.btn-check:checked+.btn,\n.btn-group>.btn-check:focus+.btn,\n.btn-group>.btn:hover,\n.btn-group>.btn:focus,\n.btn-group>.btn:active,\n.btn-group>.btn.active,\n.btn-group-vertical>.btn-check:checked+.btn,\n.btn-group-vertical>.btn-check:focus+.btn,\n.btn-group-vertical>.btn:hover,\n.btn-group-vertical>.btn:focus,\n.btn-group-vertical>.btn:active,\n.btn-group-vertical>.btn.active {\n    z-index: 1;\n}\n\n.btn-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n    width: auto;\n}\n\n.btn-group {\n    border-radius: 0.5rem;\n}\n\n.btn-group> :not(.btn-check:first-child)+.btn,\n.btn-group>.btn-group:not(:first-child) {\n    margin-left: -0.125rem;\n}\n\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn.dropdown-toggle-split:first-child,\n.btn-group>.btn-group:not(:last-child)>.btn {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.btn-group>.btn:nth-child(n+3),\n.btn-group> :not(.btn-check)+.btn,\n.btn-group>.btn-group:not(:first-child)>.btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n    padding-right: 0.5625rem;\n    padding-left: 0.5625rem;\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropend .dropdown-toggle-split::after {\n    margin-left: 0;\n}\n\n.dropstart .dropdown-toggle-split::before {\n    margin-right: 0;\n}\n\n.btn-sm+.dropdown-toggle-split,\n.btn-group-sm>.btn+.dropdown-toggle-split {\n    padding-right: 0.375rem;\n    padding-left: 0.375rem;\n}\n\n.btn-lg+.dropdown-toggle-split,\n.btn-group-lg>.btn+.dropdown-toggle-split {\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.btn-group-vertical>.btn,\n.btn-group-vertical>.btn-group {\n    width: 100%;\n}\n\n.btn-group-vertical>.btn:not(:first-child),\n.btn-group-vertical>.btn-group:not(:first-child) {\n    margin-top: -0.125rem;\n}\n\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical>.btn-group:not(:last-child)>.btn {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical>.btn~.btn,\n.btn-group-vertical>.btn-group:not(:first-child)>.btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.nav {\n    --bs-nav-link-padding-x: 1rem;\n    --bs-nav-link-padding-y: 0.5rem;\n    --bs-nav-link-font-weight: ;\n    --bs-nav-link-color: var(--bs-link-color);\n    --bs-nav-link-hover-color: var(--bs-link-hover-color);\n    --bs-nav-link-disabled-color: #6c757d;\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n\n.nav-link {\n    display: block;\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n    font-size: var(--bs-nav-link-font-size);\n    font-weight: var(--bs-nav-link-font-weight);\n    color: var(--bs-nav-link-color);\n    text-decoration: none;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .nav-link {\n        transition: none;\n    }\n}\n\n.nav-link:hover,\n.nav-link:focus {\n    color: var(--bs-nav-link-hover-color);\n}\n\n.nav-link.disabled {\n    color: var(--bs-nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n}\n\n.nav-tabs {\n    --bs-nav-tabs-border-width: 0.125rem;\n    --bs-nav-tabs-border-color: #dee2e6;\n    --bs-nav-tabs-border-radius: 0.5rem;\n    --bs-nav-tabs-link-hover-border-color: #e9ecef #e9ecef #dee2e6;\n    --bs-nav-tabs-link-active-color: #495057;\n    --bs-nav-tabs-link-active-bg: #fff;\n    --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;\n    border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n\n.nav-tabs .nav-link {\n    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n    background: none;\n    border: var(--bs-nav-tabs-border-width) solid transparent;\n    border-top-left-radius: var(--bs-nav-tabs-border-radius);\n    border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n    isolation: isolate;\n    border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n\n.nav-tabs .nav-link.disabled,\n.nav-tabs .nav-link:disabled {\n    color: var(--bs-nav-link-disabled-color);\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n    color: var(--bs-nav-tabs-link-active-color);\n    background-color: var(--bs-nav-tabs-link-active-bg);\n    border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.nav-pills {\n    --bs-nav-pills-border-radius: 0.5rem;\n    --bs-nav-pills-link-active-color: #fff;\n    --bs-nav-pills-link-active-bg: #0085CA;\n}\n\n.nav-pills .nav-link {\n    background: none;\n    border: 0;\n    border-radius: var(--bs-nav-pills-border-radius);\n}\n\n.nav-pills .nav-link:disabled {\n    color: var(--bs-nav-link-disabled-color);\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n    color: var(--bs-nav-pills-link-active-color);\n    background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-fill>.nav-link,\n.nav-fill .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n}\n\n.nav-justified>.nav-link,\n.nav-justified .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n    width: 100%;\n}\n\n.tab-content>.tab-pane {\n    display: none;\n}\n\n.tab-content>.active {\n    display: block;\n}\n\n.navbar {\n    --bs-navbar-padding-x: 0;\n    --bs-navbar-padding-y: 0.5rem;\n    --bs-navbar-color: rgba(0, 0, 0, 0.55);\n    --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);\n    --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);\n    --bs-navbar-active-color: rgba(0, 0, 0, 0.9);\n    --bs-navbar-brand-padding-y: 0.3125rem;\n    --bs-navbar-brand-margin-end: 1rem;\n    --bs-navbar-brand-font-size: 1.25rem;\n    --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);\n    --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);\n    --bs-navbar-nav-link-padding-x: 0.5rem;\n    --bs-navbar-toggler-padding-y: 0.25rem;\n    --bs-navbar-toggler-padding-x: 0.75rem;\n    --bs-navbar-toggler-font-size: 1.25rem;\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n    --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\n    --bs-navbar-toggler-border-radius: 0.5rem;\n    --bs-navbar-toggler-focus-width: 0.25rem;\n    --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n\n.navbar>.container,\n.navbar>.container-fluid,\n.navbar>.container-sm,\n.navbar>.container-md,\n.navbar>.container-lg,\n.navbar>.container-xl,\n.navbar>.container-xxl {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.navbar-brand {\n    padding-top: var(--bs-navbar-brand-padding-y);\n    padding-bottom: var(--bs-navbar-brand-padding-y);\n    margin-right: var(--bs-navbar-brand-margin-end);\n    font-size: var(--bs-navbar-brand-font-size);\n    color: var(--bs-navbar-brand-color);\n    text-decoration: none;\n    white-space: nowrap;\n}\n\n.navbar-brand:hover,\n.navbar-brand:focus {\n    color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n    --bs-nav-link-padding-x: 0;\n    --bs-nav-link-padding-y: 0.5rem;\n    --bs-nav-link-font-weight: ;\n    --bs-nav-link-color: var(--bs-navbar-color);\n    --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n    --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n\n.navbar-nav .show>.nav-link,\n.navbar-nav .nav-link.active {\n    color: var(--bs-navbar-active-color);\n}\n\n.navbar-nav .dropdown-menu {\n    position: static;\n}\n\n.navbar-text {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    color: var(--bs-navbar-color);\n}\n\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n    color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n    flex-basis: 100%;\n    flex-grow: 1;\n    align-items: center;\n}\n\n.navbar-toggler {\n    padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n    font-size: var(--bs-navbar-toggler-font-size);\n    line-height: 1;\n    color: var(--bs-navbar-color);\n    background-color: transparent;\n    border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n    border-radius: var(--bs-navbar-toggler-border-radius);\n    transition: var(--bs-navbar-toggler-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .navbar-toggler {\n        transition: none;\n    }\n}\n\n.navbar-toggler:hover {\n    text-decoration: none;\n}\n\n.navbar-toggler:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n    display: inline-block;\n    width: 1.5em;\n    height: 1.5em;\n    vertical-align: middle;\n    background-image: var(--bs-navbar-toggler-icon-bg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 100%;\n}\n\n.navbar-nav-scroll {\n    max-height: var(--bs-scroll-height, 75vh);\n    overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n    .navbar-expand-sm {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-sm .navbar-nav {\n        flex-direction: row;\n    }\n\n    .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x);\n    }\n\n    .navbar-expand-sm .navbar-nav-scroll {\n        overflow: visible;\n    }\n\n    .navbar-expand-sm .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-sm .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-sm .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: transparent !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none;\n    }\n\n    .navbar-expand-sm .offcanvas .offcanvas-header {\n        display: none;\n    }\n\n    .navbar-expand-sm .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n    }\n}\n\n@media (min-width: 768px) {\n    .navbar-expand-md {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-md .navbar-nav {\n        flex-direction: row;\n    }\n\n    .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x);\n    }\n\n    .navbar-expand-md .navbar-nav-scroll {\n        overflow: visible;\n    }\n\n    .navbar-expand-md .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-md .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-md .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: transparent !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none;\n    }\n\n    .navbar-expand-md .offcanvas .offcanvas-header {\n        display: none;\n    }\n\n    .navbar-expand-md .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n    }\n}\n\n@media (min-width: 992px) {\n    .navbar-expand-lg {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-lg .navbar-nav {\n        flex-direction: row;\n    }\n\n    .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x);\n    }\n\n    .navbar-expand-lg .navbar-nav-scroll {\n        overflow: visible;\n    }\n\n    .navbar-expand-lg .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-lg .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-lg .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: transparent !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none;\n    }\n\n    .navbar-expand-lg .offcanvas .offcanvas-header {\n        display: none;\n    }\n\n    .navbar-expand-lg .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n    }\n}\n\n@media (min-width: 1200px) {\n    .navbar-expand-xl {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-xl .navbar-nav {\n        flex-direction: row;\n    }\n\n    .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x);\n    }\n\n    .navbar-expand-xl .navbar-nav-scroll {\n        overflow: visible;\n    }\n\n    .navbar-expand-xl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-xl .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-xl .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: transparent !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none;\n    }\n\n    .navbar-expand-xl .offcanvas .offcanvas-header {\n        display: none;\n    }\n\n    .navbar-expand-xl .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n    }\n}\n\n@media (min-width: 1400px) {\n    .navbar-expand-xxl {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-xxl .navbar-nav {\n        flex-direction: row;\n    }\n\n    .navbar-expand-xxl .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-xxl .navbar-nav .nav-link {\n        padding-right: var(--bs-navbar-nav-link-padding-x);\n        padding-left: var(--bs-navbar-nav-link-padding-x);\n    }\n\n    .navbar-expand-xxl .navbar-nav-scroll {\n        overflow: visible;\n    }\n\n    .navbar-expand-xxl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-xxl .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-xxl .offcanvas {\n        position: static;\n        z-index: auto;\n        flex-grow: 1;\n        width: auto !important;\n        height: auto !important;\n        visibility: visible !important;\n        background-color: transparent !important;\n        border: 0 !important;\n        transform: none !important;\n        transition: none;\n    }\n\n    .navbar-expand-xxl .offcanvas .offcanvas-header {\n        display: none;\n    }\n\n    .navbar-expand-xxl .offcanvas .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n    }\n}\n\n.navbar-expand {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n}\n\n.navbar-expand .navbar-nav {\n    flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n    position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n\n.navbar-expand .navbar-nav-scroll {\n    overflow: visible;\n}\n\n.navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n    display: none;\n}\n\n.navbar-expand .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n}\n\n.navbar-expand .offcanvas .offcanvas-header {\n    display: none;\n}\n\n.navbar-expand .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n}\n\n.navbar-dark {\n    --bs-navbar-color: rgba(255, 255, 255, 0.55);\n    --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n    --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n    --bs-navbar-active-color: #fff;\n    --bs-navbar-brand-color: #fff;\n    --bs-navbar-brand-hover-color: #fff;\n    --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n    --bs-card-spacer-y: 1rem;\n    --bs-card-spacer-x: 1rem;\n    --bs-card-title-spacer-y: 0.5rem;\n    --bs-card-border-width: 0.125rem;\n    --bs-card-border-color: var(--bs-border-color-translucent);\n    --bs-card-border-radius: 0.5rem;\n    --bs-card-box-shadow: ;\n    --bs-card-inner-border-radius: 0.375rem;\n    --bs-card-cap-padding-y: 0.5rem;\n    --bs-card-cap-padding-x: 1rem;\n    --bs-card-cap-bg: rgba(0, 0, 0, 0.03);\n    --bs-card-cap-color: ;\n    --bs-card-height: ;\n    --bs-card-color: ;\n    --bs-card-bg: #fff;\n    --bs-card-img-overlay-padding: 1rem;\n    --bs-card-group-margin: 0.75rem;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    height: var(--bs-card-height);\n    word-wrap: break-word;\n    background-color: var(--bs-card-bg);\n    background-clip: border-box;\n    border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n    border-radius: var(--bs-card-border-radius);\n}\n\n.card>hr {\n    margin-right: 0;\n    margin-left: 0;\n}\n\n.card>.list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n}\n\n.card>.list-group:first-child {\n    border-top-width: 0;\n    border-top-left-radius: var(--bs-card-inner-border-radius);\n    border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card>.list-group:last-child {\n    border-bottom-width: 0;\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\n    border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card>.card-header+.list-group,\n.card>.list-group+.card-footer {\n    border-top: 0;\n}\n\n.card-body {\n    flex: 1 1 auto;\n    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n    color: var(--bs-card-color);\n}\n\n.card-title {\n    margin-bottom: var(--bs-card-title-spacer-y);\n}\n\n.card-subtitle {\n    margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n    margin-bottom: 0;\n}\n\n.card-text:last-child {\n    margin-bottom: 0;\n}\n\n.card-link+.card-link {\n    margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n    margin-bottom: 0;\n    color: var(--bs-card-cap-color);\n    background-color: var(--bs-card-cap-bg);\n    border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n\n.card-header:first-child {\n    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n    color: var(--bs-card-cap-color);\n    background-color: var(--bs-card-cap-bg);\n    border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n\n.card-footer:last-child {\n    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n    margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n    margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n    margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n    border-bottom: 0;\n}\n\n.card-header-tabs .nav-link.active {\n    background-color: var(--bs-card-bg);\n    border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n    margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n    margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: var(--bs-card-img-overlay-padding);\n    border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n    width: 100%;\n}\n\n.card-img,\n.card-img-top {\n    border-top-left-radius: var(--bs-card-inner-border-radius);\n    border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\n    border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group>.card {\n    margin-bottom: var(--bs-card-group-margin);\n}\n\n@media (min-width: 576px) {\n    .card-group {\n        display: flex;\n        flex-flow: row wrap;\n    }\n\n    .card-group>.card {\n        flex: 1 0 0%;\n        margin-bottom: 0;\n    }\n\n    .card-group>.card+.card {\n        margin-left: 0;\n        border-left: 0;\n    }\n\n    .card-group>.card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    .card-group>.card:not(:last-child) .card-img-top,\n    .card-group>.card:not(:last-child) .card-header {\n        border-top-right-radius: 0;\n    }\n\n    .card-group>.card:not(:last-child) .card-img-bottom,\n    .card-group>.card:not(:last-child) .card-footer {\n        border-bottom-right-radius: 0;\n    }\n\n    .card-group>.card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .card-group>.card:not(:first-child) .card-img-top,\n    .card-group>.card:not(:first-child) .card-header {\n        border-top-left-radius: 0;\n    }\n\n    .card-group>.card:not(:first-child) .card-img-bottom,\n    .card-group>.card:not(:first-child) .card-footer {\n        border-bottom-left-radius: 0;\n    }\n}\n\n.accordion {\n    --bs-accordion-color: #212529;\n    --bs-accordion-bg: #fff;\n    --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n    --bs-accordion-border-color: var(--bs-border-color);\n    --bs-accordion-border-width: 0.125rem;\n    --bs-accordion-border-radius: 0.5rem;\n    --bs-accordion-inner-border-radius: 0.375rem;\n    --bs-accordion-btn-padding-x: 1.25rem;\n    --bs-accordion-btn-padding-y: 1rem;\n    --bs-accordion-btn-color: #212529;\n    --bs-accordion-btn-bg: var(--bs-accordion-bg);\n    --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    --bs-accordion-btn-icon-width: 1.25rem;\n    --bs-accordion-btn-icon-transform: rotate(-180deg);\n    --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n    --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2317a98c'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    --bs-accordion-btn-focus-border-color: #8ddece;\n    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n    --bs-accordion-body-padding-x: 1.25rem;\n    --bs-accordion-body-padding-y: 1rem;\n    --bs-accordion-active-color: #17a98c;\n    --bs-accordion-active-bg: #e8f8f5;\n}\n\n.accordion-button {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n    font-size: 1rem;\n    color: var(--bs-accordion-btn-color);\n    text-align: left;\n    background-color: var(--bs-accordion-btn-bg);\n    border: 0;\n    border-radius: 0;\n    overflow-anchor: none;\n    transition: var(--bs-accordion-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .accordion-button {\n        transition: none;\n    }\n}\n\n.accordion-button:not(.collapsed) {\n    color: var(--bs-accordion-active-color);\n    background-color: var(--bs-accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n\n.accordion-button:not(.collapsed)::after {\n    background-image: var(--bs-accordion-btn-active-icon);\n    transform: var(--bs-accordion-btn-icon-transform);\n}\n\n.accordion-button::after {\n    flex-shrink: 0;\n    width: var(--bs-accordion-btn-icon-width);\n    height: var(--bs-accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--bs-accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--bs-accordion-btn-icon-width);\n    transition: var(--bs-accordion-btn-icon-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .accordion-button::after {\n        transition: none;\n    }\n}\n\n.accordion-button:hover {\n    z-index: 2;\n}\n\n.accordion-button:focus {\n    z-index: 3;\n    border-color: var(--bs-accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n    margin-bottom: 0;\n}\n\n.accordion-item {\n    color: var(--bs-accordion-color);\n    background-color: var(--bs-accordion-bg);\n    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n\n.accordion-item:first-of-type {\n    border-top-left-radius: var(--bs-accordion-border-radius);\n    border-top-right-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-item:first-of-type .accordion-button {\n    border-top-left-radius: var(--bs-accordion-inner-border-radius);\n    border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n\n.accordion-item:not(:first-of-type) {\n    border-top: 0;\n}\n\n.accordion-item:last-of-type {\n    border-bottom-right-radius: var(--bs-accordion-border-radius);\n    border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-item:last-of-type .accordion-button.collapsed {\n    border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n    border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n\n.accordion-item:last-of-type .accordion-collapse {\n    border-bottom-right-radius: var(--bs-accordion-border-radius);\n    border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n    border-width: 0;\n}\n\n.accordion-flush .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0;\n}\n\n.accordion-flush .accordion-item:first-child {\n    border-top: 0;\n}\n\n.accordion-flush .accordion-item:last-child {\n    border-bottom: 0;\n}\n\n.accordion-flush .accordion-item .accordion-button,\n.accordion-flush .accordion-item .accordion-button.collapsed {\n    border-radius: 0;\n}\n\n.breadcrumb {\n    --bs-breadcrumb-padding-x: 0;\n    --bs-breadcrumb-padding-y: 0;\n    --bs-breadcrumb-margin-bottom: 1rem;\n    --bs-breadcrumb-bg: ;\n    --bs-breadcrumb-border-radius: ;\n    --bs-breadcrumb-divider-color: #6c757d;\n    --bs-breadcrumb-item-padding-x: 0.5rem;\n    --bs-breadcrumb-item-active-color: #6c757d;\n    display: flex;\n    flex-wrap: wrap;\n    padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n    margin-bottom: var(--bs-breadcrumb-margin-bottom);\n    font-size: var(--bs-breadcrumb-font-size);\n    list-style: none;\n    background-color: var(--bs-breadcrumb-bg);\n    border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item+.breadcrumb-item {\n    padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n    float: left;\n    padding-right: var(--bs-breadcrumb-item-padding-x);\n    color: var(--bs-breadcrumb-divider-color);\n    content: var(--bs-breadcrumb-divider, \"/\")\n        /* rtl: var(--bs-breadcrumb-divider, \"/\") */\n    ;\n}\n\n.breadcrumb-item.active {\n    color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n    --bs-pagination-padding-x: 0.75rem;\n    --bs-pagination-padding-y: 0.375rem;\n    --bs-pagination-font-size: 1rem;\n    --bs-pagination-color: var(--bs-link-color);\n    --bs-pagination-bg: #fff;\n    --bs-pagination-border-width: 0.125rem;\n    --bs-pagination-border-color: #dee2e6;\n    --bs-pagination-border-radius: 0.5rem;\n    --bs-pagination-hover-color: var(--bs-link-hover-color);\n    --bs-pagination-hover-bg: #e9ecef;\n    --bs-pagination-hover-border-color: #dee2e6;\n    --bs-pagination-focus-color: var(--bs-link-hover-color);\n    --bs-pagination-focus-bg: #e9ecef;\n    --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n    --bs-pagination-active-color: #fff;\n    --bs-pagination-active-bg: #0085CA;\n    --bs-pagination-active-border-color: #0085CA;\n    --bs-pagination-disabled-color: #6c757d;\n    --bs-pagination-disabled-bg: #fff;\n    --bs-pagination-disabled-border-color: #dee2e6;\n    display: flex;\n    padding-left: 0;\n    list-style: none;\n}\n\n.page-link {\n    position: relative;\n    display: block;\n    padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n    font-size: var(--bs-pagination-font-size);\n    color: var(--bs-pagination-color);\n    text-decoration: none;\n    background-color: var(--bs-pagination-bg);\n    border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .page-link {\n        transition: none;\n    }\n}\n\n.page-link:hover {\n    z-index: 2;\n    color: var(--bs-pagination-hover-color);\n    background-color: var(--bs-pagination-hover-bg);\n    border-color: var(--bs-pagination-hover-border-color);\n}\n\n.page-link:focus {\n    z-index: 3;\n    color: var(--bs-pagination-focus-color);\n    background-color: var(--bs-pagination-focus-bg);\n    outline: 0;\n    box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n\n.page-link.active,\n.active>.page-link {\n    z-index: 3;\n    color: var(--bs-pagination-active-color);\n    background-color: var(--bs-pagination-active-bg);\n    border-color: var(--bs-pagination-active-border-color);\n}\n\n.page-link.disabled,\n.disabled>.page-link {\n    color: var(--bs-pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--bs-pagination-disabled-bg);\n    border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n    margin-left: -0.125rem;\n}\n\n.page-item:first-child .page-link {\n    border-top-left-radius: var(--bs-pagination-border-radius);\n    border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n\n.page-item:last-child .page-link {\n    border-top-right-radius: var(--bs-pagination-border-radius);\n    border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n    --bs-pagination-padding-x: 1.5rem;\n    --bs-pagination-padding-y: 0.75rem;\n    --bs-pagination-font-size: 1.25rem;\n    --bs-pagination-border-radius: 0.75rem;\n}\n\n.pagination-sm {\n    --bs-pagination-padding-x: 0.5rem;\n    --bs-pagination-padding-y: 0.25rem;\n    --bs-pagination-font-size: 0.875rem;\n    --bs-pagination-border-radius: 0.25rem;\n}\n\n.badge {\n    --bs-badge-padding-x: 0.65em;\n    --bs-badge-padding-y: 0.35em;\n    --bs-badge-font-size: 0.75em;\n    --bs-badge-font-weight: 700;\n    --bs-badge-color: #fff;\n    --bs-badge-border-radius: 0.5rem;\n    display: inline-block;\n    padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n    font-size: var(--bs-badge-font-size);\n    font-weight: var(--bs-badge-font-weight);\n    line-height: 1;\n    color: var(--bs-badge-color);\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: var(--bs-badge-border-radius);\n}\n\n.badge:empty {\n    display: none;\n}\n\n.btn .badge {\n    position: relative;\n    top: -1px;\n}\n\n.alert {\n    --bs-alert-bg: transparent;\n    --bs-alert-padding-x: 1rem;\n    --bs-alert-padding-y: 1rem;\n    --bs-alert-margin-bottom: 1rem;\n    --bs-alert-color: inherit;\n    --bs-alert-border-color: transparent;\n    --bs-alert-border: 0.125rem solid var(--bs-alert-border-color);\n    --bs-alert-border-radius: 0.5rem;\n    position: relative;\n    padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n    margin-bottom: var(--bs-alert-margin-bottom);\n    color: var(--bs-alert-color);\n    background-color: var(--bs-alert-bg);\n    border: var(--bs-alert-border);\n    border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n    color: inherit;\n}\n\n.alert-link {\n    font-weight: 700;\n}\n\n.alert-dismissible {\n    padding-right: 3rem;\n}\n\n.alert-dismissible .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n    --bs-alert-color: #10715e;\n    --bs-alert-bg: #d1f2eb;\n    --bs-alert-border-color: #baebe1;\n}\n\n.alert-primary .alert-link {\n    color: #0d5a4b;\n}\n\n.alert-secondary {\n    --bs-alert-color: #1a2530;\n    --bs-alert-bg: #d5d8dc;\n    --bs-alert-border-color: #c0c5cb;\n}\n\n.alert-secondary .alert-link {\n    color: #151e26;\n}\n\n.alert-success {\n    --bs-alert-color: #0f5132;\n    --bs-alert-bg: #d1e7dd;\n    --bs-alert-border-color: #badbcc;\n}\n\n.alert-success .alert-link {\n    color: #0c4128;\n}\n\n.alert-info {\n    --bs-alert-color: #087990;\n    --bs-alert-bg: #cff4fc;\n    --bs-alert-border-color: #b6effb;\n}\n\n.alert-info .alert-link {\n    color: #066173;\n}\n\n.alert-warning {\n    --bs-alert-color: #997404;\n    --bs-alert-bg: #fff3cd;\n    --bs-alert-border-color: #ffecb5;\n}\n\n.alert-warning .alert-link {\n    color: #7a5d03;\n}\n\n.alert-danger {\n    --bs-alert-color: #842029;\n    --bs-alert-bg: #f8d7da;\n    --bs-alert-border-color: #f5c2c7;\n}\n\n.alert-danger .alert-link {\n    color: #6a1a21;\n}\n\n.alert-light {\n    --bs-alert-color: #959596;\n    --bs-alert-bg: #fefefe;\n    --bs-alert-border-color: #fdfdfe;\n}\n\n.alert-light .alert-link {\n    color: #777778;\n}\n\n.alert-dark {\n    --bs-alert-color: #141619;\n    --bs-alert-bg: #d3d3d4;\n    --bs-alert-border-color: #bcbebf;\n}\n\n.alert-dark .alert-link {\n    color: #101214;\n}\n\n@keyframes progress-bar-stripes {\n    0% {\n        background-position-x: 1rem;\n    }\n}\n\n.progress {\n    --bs-progress-height: 1rem;\n    --bs-progress-font-size: 0.75rem;\n    --bs-progress-bg: #e9ecef;\n    --bs-progress-border-radius: 0.5rem;\n    --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n    --bs-progress-bar-color: #fff;\n    --bs-progress-bar-bg: #0085CA;\n    --bs-progress-bar-transition: width 0.6s ease;\n    display: flex;\n    height: var(--bs-progress-height);\n    overflow: hidden;\n    font-size: var(--bs-progress-font-size);\n    background-color: var(--bs-progress-bg);\n    border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    color: var(--bs-progress-bar-color);\n    text-align: center;\n    white-space: nowrap;\n    background-color: var(--bs-progress-bar-bg);\n    transition: var(--bs-progress-bar-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .progress-bar {\n        transition: none;\n    }\n}\n\n.progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-bar-animated {\n    animation: 1s linear infinite progress-bar-stripes;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .progress-bar-animated {\n        animation: none;\n    }\n}\n\n.list-group {\n    --bs-list-group-color: #212529;\n    --bs-list-group-bg: #fff;\n    --bs-list-group-border-color: rgba(0, 0, 0, 0.125);\n    --bs-list-group-border-width: 0.125rem;\n    --bs-list-group-border-radius: 0.5rem;\n    --bs-list-group-item-padding-x: 1rem;\n    --bs-list-group-item-padding-y: 0.5rem;\n    --bs-list-group-action-color: #495057;\n    --bs-list-group-action-hover-color: #495057;\n    --bs-list-group-action-hover-bg: #f8f9fa;\n    --bs-list-group-action-active-color: #212529;\n    --bs-list-group-action-active-bg: #e9ecef;\n    --bs-list-group-disabled-color: #6c757d;\n    --bs-list-group-disabled-bg: #fff;\n    --bs-list-group-active-color: #fff;\n    --bs-list-group-active-bg: #0085CA;\n    --bs-list-group-active-border-color: #0085CA;\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n    list-style-type: none;\n    counter-reset: section;\n}\n\n.list-group-numbered>.list-group-item::before {\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n}\n\n.list-group-item-action {\n    width: 100%;\n    color: var(--bs-list-group-action-color);\n    text-align: inherit;\n}\n\n.list-group-item-action:hover,\n.list-group-item-action:focus {\n    z-index: 1;\n    color: var(--bs-list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--bs-list-group-action-hover-bg);\n}\n\n.list-group-item-action:active {\n    color: var(--bs-list-group-action-active-color);\n    background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n    color: var(--bs-list-group-color);\n    text-decoration: none;\n    background-color: var(--bs-list-group-bg);\n    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit;\n}\n\n.list-group-item:last-child {\n    border-bottom-right-radius: inherit;\n    border-bottom-left-radius: inherit;\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n    color: var(--bs-list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--bs-list-group-disabled-bg);\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: var(--bs-list-group-active-color);\n    background-color: var(--bs-list-group-active-bg);\n    border-color: var(--bs-list-group-active-border-color);\n}\n\n.list-group-item+.list-group-item {\n    border-top-width: 0;\n}\n\n.list-group-item+.list-group-item.active {\n    margin-top: calc(-1 * var(--bs-list-group-border-width));\n    border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n    flex-direction: row;\n}\n\n.list-group-horizontal>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item.active {\n    margin-top: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n    .list-group-horizontal-sm {\n        flex-direction: row;\n    }\n\n    .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0;\n    }\n\n    .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0;\n    }\n\n    .list-group-horizontal-sm>.list-group-item.active {\n        margin-top: 0;\n    }\n\n    .list-group-horizontal-sm>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0;\n    }\n\n    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1 * var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width);\n    }\n}\n\n@media (min-width: 768px) {\n    .list-group-horizontal-md {\n        flex-direction: row;\n    }\n\n    .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0;\n    }\n\n    .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0;\n    }\n\n    .list-group-horizontal-md>.list-group-item.active {\n        margin-top: 0;\n    }\n\n    .list-group-horizontal-md>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0;\n    }\n\n    .list-group-horizontal-md>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1 * var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width);\n    }\n}\n\n@media (min-width: 992px) {\n    .list-group-horizontal-lg {\n        flex-direction: row;\n    }\n\n    .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0;\n    }\n\n    .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0;\n    }\n\n    .list-group-horizontal-lg>.list-group-item.active {\n        margin-top: 0;\n    }\n\n    .list-group-horizontal-lg>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0;\n    }\n\n    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1 * var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width);\n    }\n}\n\n@media (min-width: 1200px) {\n    .list-group-horizontal-xl {\n        flex-direction: row;\n    }\n\n    .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0;\n    }\n\n    .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0;\n    }\n\n    .list-group-horizontal-xl>.list-group-item.active {\n        margin-top: 0;\n    }\n\n    .list-group-horizontal-xl>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0;\n    }\n\n    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1 * var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width);\n    }\n}\n\n@media (min-width: 1400px) {\n    .list-group-horizontal-xxl {\n        flex-direction: row;\n    }\n\n    .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\n        border-top-right-radius: 0;\n    }\n\n    .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {\n        border-top-right-radius: var(--bs-list-group-border-radius);\n        border-bottom-left-radius: 0;\n    }\n\n    .list-group-horizontal-xxl>.list-group-item.active {\n        margin-top: 0;\n    }\n\n    .list-group-horizontal-xxl>.list-group-item+.list-group-item {\n        border-top-width: var(--bs-list-group-border-width);\n        border-left-width: 0;\n    }\n\n    .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {\n        margin-left: calc(-1 * var(--bs-list-group-border-width));\n        border-left-width: var(--bs-list-group-border-width);\n    }\n}\n\n.list-group-flush {\n    border-radius: 0;\n}\n\n.list-group-flush>.list-group-item {\n    border-width: 0 0 var(--bs-list-group-border-width);\n}\n\n.list-group-flush>.list-group-item:last-child {\n    border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n    color: #10715e;\n    background-color: #d1f2eb;\n}\n\n.list-group-item-primary.list-group-item-action:hover,\n.list-group-item-primary.list-group-item-action:focus {\n    color: #10715e;\n    background-color: #bcdad4;\n}\n\n.list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #10715e;\n    border-color: #10715e;\n}\n\n.list-group-item-secondary {\n    color: #1a2530;\n    background-color: #d5d8dc;\n}\n\n.list-group-item-secondary.list-group-item-action:hover,\n.list-group-item-secondary.list-group-item-action:focus {\n    color: #1a2530;\n    background-color: #c0c2c6;\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #1a2530;\n    border-color: #1a2530;\n}\n\n.list-group-item-success {\n    color: #0f5132;\n    background-color: #d1e7dd;\n}\n\n.list-group-item-success.list-group-item-action:hover,\n.list-group-item-success.list-group-item-action:focus {\n    color: #0f5132;\n    background-color: #bcd0c7;\n}\n\n.list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #0f5132;\n    border-color: #0f5132;\n}\n\n.list-group-item-info {\n    color: #087990;\n    background-color: #cff4fc;\n}\n\n.list-group-item-info.list-group-item-action:hover,\n.list-group-item-info.list-group-item-action:focus {\n    color: #087990;\n    background-color: #badce3;\n}\n\n.list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #087990;\n    border-color: #087990;\n}\n\n.list-group-item-warning {\n    color: #997404;\n    background-color: #fff3cd;\n}\n\n.list-group-item-warning.list-group-item-action:hover,\n.list-group-item-warning.list-group-item-action:focus {\n    color: #997404;\n    background-color: #e6dbb9;\n}\n\n.list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #997404;\n    border-color: #997404;\n}\n\n.list-group-item-danger {\n    color: #842029;\n    background-color: #f8d7da;\n}\n\n.list-group-item-danger.list-group-item-action:hover,\n.list-group-item-danger.list-group-item-action:focus {\n    color: #842029;\n    background-color: #dfc2c4;\n}\n\n.list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #842029;\n    border-color: #842029;\n}\n\n.list-group-item-light {\n    color: #959596;\n    background-color: #fefefe;\n}\n\n.list-group-item-light.list-group-item-action:hover,\n.list-group-item-light.list-group-item-action:focus {\n    color: #959596;\n    background-color: #e5e5e5;\n}\n\n.list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #959596;\n    border-color: #959596;\n}\n\n.list-group-item-dark {\n    color: #141619;\n    background-color: #d3d3d4;\n}\n\n.list-group-item-dark.list-group-item-action:hover,\n.list-group-item-dark.list-group-item-action:focus {\n    color: #141619;\n    background-color: #bebebf;\n}\n\n.list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #141619;\n    border-color: #141619;\n}\n\n.btn-close {\n    box-sizing: content-box;\n    width: 1em;\n    height: 1em;\n    padding: 0.25em 0.25em;\n    color: #000;\n    background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n    border: 0;\n    border-radius: 0.5rem;\n    opacity: 0.5;\n}\n\n.btn-close:hover {\n    color: #000;\n    text-decoration: none;\n    opacity: 0.75;\n}\n\n.btn-close:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(26, 188, 156, 0.25);\n    opacity: 1;\n}\n\n.btn-close:disabled,\n.btn-close.disabled {\n    pointer-events: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    opacity: 0.25;\n}\n\n.btn-close-white {\n    filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n    --bs-toast-zindex: 1090;\n    --bs-toast-padding-x: 0.75rem;\n    --bs-toast-padding-y: 0.5rem;\n    --bs-toast-spacing: 1.5rem;\n    --bs-toast-max-width: 350px;\n    --bs-toast-font-size: 0.875rem;\n    --bs-toast-color: ;\n    --bs-toast-bg: rgba(255, 255, 255, 0.85);\n    --bs-toast-border-width: 0.125rem;\n    --bs-toast-border-color: var(--bs-border-color-translucent);\n    --bs-toast-border-radius: 0.5rem;\n    --bs-toast-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-toast-header-color: #6c757d;\n    --bs-toast-header-bg: rgba(255, 255, 255, 0.85);\n    --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);\n    width: var(--bs-toast-max-width);\n    max-width: 100%;\n    font-size: var(--bs-toast-font-size);\n    color: var(--bs-toast-color);\n    pointer-events: auto;\n    background-color: var(--bs-toast-bg);\n    background-clip: padding-box;\n    border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n    box-shadow: var(--bs-toast-box-shadow);\n    border-radius: var(--bs-toast-border-radius);\n}\n\n.toast.showing {\n    opacity: 0;\n}\n\n.toast:not(.show) {\n    display: none;\n}\n\n.toast-container {\n    --bs-toast-zindex: 1090;\n    position: absolute;\n    z-index: var(--bs-toast-zindex);\n    width: -moz-max-content;\n    width: max-content;\n    max-width: 100%;\n    pointer-events: none;\n}\n\n.toast-container> :not(:last-child) {\n    margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n    display: flex;\n    align-items: center;\n    padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n    color: var(--bs-toast-header-color);\n    background-color: var(--bs-toast-header-bg);\n    background-clip: padding-box;\n    border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n    border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n    border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n\n.toast-header .btn-close {\n    margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n    margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n    padding: var(--bs-toast-padding-x);\n    word-wrap: break-word;\n}\n\n.modal {\n    --bs-modal-zindex: 1055;\n    --bs-modal-width: 500px;\n    --bs-modal-padding: 1rem;\n    --bs-modal-margin: 0.5rem;\n    --bs-modal-color: ;\n    --bs-modal-bg: #fff;\n    --bs-modal-border-color: var(--bs-border-color-translucent);\n    --bs-modal-border-width: 0.125rem;\n    --bs-modal-border-radius: 0.75rem;\n    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n    --bs-modal-inner-border-radius: 0.625rem;\n    --bs-modal-header-padding-x: 1rem;\n    --bs-modal-header-padding-y: 1rem;\n    --bs-modal-header-padding: 1rem 1rem;\n    --bs-modal-header-border-color: var(--bs-border-color);\n    --bs-modal-header-border-width: 0.125rem;\n    --bs-modal-title-line-height: 1.5;\n    --bs-modal-footer-gap: 0.5rem;\n    --bs-modal-footer-bg: ;\n    --bs-modal-footer-border-color: var(--bs-border-color);\n    --bs-modal-footer-border-width: 0.125rem;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: var(--bs-modal-zindex);\n    display: none;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    outline: 0;\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: var(--bs-modal-margin);\n    pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n    transform: translate(0, -50px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .modal.fade .modal-dialog {\n        transition: none;\n    }\n}\n\n.modal.show .modal-dialog {\n    transform: none;\n}\n\n.modal.modal-static .modal-dialog {\n    transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n    height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-dialog-scrollable .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-body {\n    overflow-y: auto;\n}\n\n.modal-dialog-centered {\n    display: flex;\n    align-items: center;\n    min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    color: var(--bs-modal-color);\n    pointer-events: auto;\n    background-color: var(--bs-modal-bg);\n    background-clip: padding-box;\n    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n    border-radius: var(--bs-modal-border-radius);\n    outline: 0;\n}\n\n.modal-backdrop {\n    --bs-backdrop-zindex: 1050;\n    --bs-backdrop-bg: #000;\n    --bs-backdrop-opacity: 0.5;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: var(--bs-backdrop-zindex);\n    width: 100vw;\n    height: 100vh;\n    background-color: var(--bs-backdrop-bg);\n}\n\n.modal-backdrop.fade {\n    opacity: 0;\n}\n\n.modal-backdrop.show {\n    opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-modal-header-padding);\n    border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n    border-top-left-radius: var(--bs-modal-inner-border-radius);\n    border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n\n.modal-header .btn-close {\n    padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n    margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n    margin-bottom: 0;\n    line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n    position: relative;\n    flex: 1 1 auto;\n    padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n    display: flex;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n    background-color: var(--bs-modal-footer-bg);\n    border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n    border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n    border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n\n.modal-footer>* {\n    margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n    .modal {\n        --bs-modal-margin: 1.75rem;\n        --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    }\n\n    .modal-dialog {\n        max-width: var(--bs-modal-width);\n        margin-right: auto;\n        margin-left: auto;\n    }\n\n    .modal-sm {\n        --bs-modal-width: 300px;\n    }\n}\n\n@media (min-width: 992px) {\n\n    .modal-lg,\n    .modal-xl {\n        --bs-modal-width: 800px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .modal-xl {\n        --bs-modal-width: 1140px;\n    }\n}\n\n.modal-fullscreen {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n}\n\n.modal-fullscreen .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n}\n\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n    border-radius: 0;\n}\n\n.modal-fullscreen .modal-body {\n    overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n    .modal-fullscreen-sm-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0;\n    }\n\n    .modal-fullscreen-sm-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-sm-down .modal-header,\n    .modal-fullscreen-sm-down .modal-footer {\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-sm-down .modal-body {\n        overflow-y: auto;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .modal-fullscreen-md-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0;\n    }\n\n    .modal-fullscreen-md-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-md-down .modal-header,\n    .modal-fullscreen-md-down .modal-footer {\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-md-down .modal-body {\n        overflow-y: auto;\n    }\n}\n\n@media (max-width: 991.98px) {\n    .modal-fullscreen-lg-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0;\n    }\n\n    .modal-fullscreen-lg-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-lg-down .modal-header,\n    .modal-fullscreen-lg-down .modal-footer {\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-lg-down .modal-body {\n        overflow-y: auto;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .modal-fullscreen-xl-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0;\n    }\n\n    .modal-fullscreen-xl-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-xl-down .modal-header,\n    .modal-fullscreen-xl-down .modal-footer {\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-xl-down .modal-body {\n        overflow-y: auto;\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .modal-fullscreen-xxl-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0;\n    }\n\n    .modal-fullscreen-xxl-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-xxl-down .modal-header,\n    .modal-fullscreen-xxl-down .modal-footer {\n        border-radius: 0;\n    }\n\n    .modal-fullscreen-xxl-down .modal-body {\n        overflow-y: auto;\n    }\n}\n\n.tooltip {\n    --bs-tooltip-zindex: 1080;\n    --bs-tooltip-max-width: 200px;\n    --bs-tooltip-padding-x: 0.5rem;\n    --bs-tooltip-padding-y: 0.25rem;\n    --bs-tooltip-margin: ;\n    --bs-tooltip-font-size: 0.875rem;\n    --bs-tooltip-color: #fff;\n    --bs-tooltip-bg: #000;\n    --bs-tooltip-border-radius: 0.5rem;\n    --bs-tooltip-opacity: 0.9;\n    --bs-tooltip-arrow-width: 0.8rem;\n    --bs-tooltip-arrow-height: 0.4rem;\n    z-index: var(--bs-tooltip-zindex);\n    display: block;\n    padding: var(--bs-tooltip-arrow-height);\n    margin: var(--bs-tooltip-margin);\n    font-family: var(--bs-font-sans-serif);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    white-space: normal;\n    word-spacing: normal;\n    line-break: auto;\n    font-size: var(--bs-tooltip-font-size);\n    word-wrap: break-word;\n    opacity: 0;\n}\n\n.tooltip.show {\n    opacity: var(--bs-tooltip-opacity);\n}\n\n.tooltip .tooltip-arrow {\n    display: block;\n    width: var(--bs-tooltip-arrow-width);\n    height: var(--bs-tooltip-arrow-height);\n}\n\n.tooltip .tooltip-arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n    bottom: 0;\n}\n\n.bs-tooltip-top .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n    top: -1px;\n    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n    border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n    left: 0;\n    width: var(--bs-tooltip-arrow-height);\n    height: var(--bs-tooltip-arrow-width);\n}\n\n.bs-tooltip-end .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n    right: -1px;\n    border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n    border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n    top: 0;\n}\n\n.bs-tooltip-bottom .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n    border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n    right: 0;\n    width: var(--bs-tooltip-arrow-height);\n    height: var(--bs-tooltip-arrow-width);\n}\n\n.bs-tooltip-start .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n    left: -1px;\n    border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n    border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n    max-width: var(--bs-tooltip-max-width);\n    padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n    color: var(--bs-tooltip-color);\n    text-align: center;\n    background-color: var(--bs-tooltip-bg);\n    border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n    --bs-popover-zindex: 1070;\n    --bs-popover-max-width: 276px;\n    --bs-popover-font-size: 0.875rem;\n    --bs-popover-bg: #fff;\n    --bs-popover-border-width: 0.125rem;\n    --bs-popover-border-color: var(--bs-border-color-translucent);\n    --bs-popover-border-radius: 0.75rem;\n    --bs-popover-inner-border-radius: 0.625rem;\n    --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    --bs-popover-header-padding-x: 1rem;\n    --bs-popover-header-padding-y: 0.5rem;\n    --bs-popover-header-font-size: 1rem;\n    --bs-popover-header-color: ;\n    --bs-popover-header-bg: #f0f0f0;\n    --bs-popover-body-padding-x: 1rem;\n    --bs-popover-body-padding-y: 1rem;\n    --bs-popover-body-color: #212529;\n    --bs-popover-arrow-width: 1rem;\n    --bs-popover-arrow-height: 0.5rem;\n    --bs-popover-arrow-border: var(--bs-popover-border-color);\n    z-index: var(--bs-popover-zindex);\n    display: block;\n    max-width: var(--bs-popover-max-width);\n    font-family: var(--bs-font-sans-serif);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    white-space: normal;\n    word-spacing: normal;\n    line-break: auto;\n    font-size: var(--bs-popover-font-size);\n    word-wrap: break-word;\n    background-color: var(--bs-popover-bg);\n    background-clip: padding-box;\n    border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n    border-radius: var(--bs-popover-border-radius);\n}\n\n.popover .popover-arrow {\n    display: block;\n    width: var(--bs-popover-arrow-width);\n    height: var(--bs-popover-arrow-height);\n}\n\n.popover .popover-arrow::before,\n.popover .popover-arrow::after {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n    border-width: 0;\n}\n\n.bs-popover-top>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {\n    bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {\n    bottom: 0;\n    border-top-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n    bottom: var(--bs-popover-border-width);\n    border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {\n    left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n    width: var(--bs-popover-arrow-height);\n    height: var(--bs-popover-arrow-width);\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n    border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {\n    left: 0;\n    border-right-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n    left: var(--bs-popover-border-width);\n    border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {\n    top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n    border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {\n    top: 0;\n    border-bottom-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n    top: var(--bs-popover-border-width);\n    border-bottom-color: var(--bs-popover-bg);\n}\n\n.bs-popover-bottom .popover-header::before,\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--bs-popover-arrow-width);\n    margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n    content: \"\";\n    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {\n    right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n    width: var(--bs-popover-arrow-height);\n    height: var(--bs-popover-arrow-width);\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n    border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {\n    right: 0;\n    border-left-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n    right: var(--bs-popover-border-width);\n    border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n    padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n    margin-bottom: 0;\n    font-size: var(--bs-popover-header-font-size);\n    color: var(--bs-popover-header-color);\n    background-color: var(--bs-popover-header-bg);\n    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n    border-top-left-radius: var(--bs-popover-inner-border-radius);\n    border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n\n.popover-header:empty {\n    display: none;\n}\n\n.popover-body {\n    padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n    color: var(--bs-popover-body-color);\n}\n\n.carousel {\n    position: relative;\n}\n\n.carousel.pointer-event {\n    touch-action: pan-y;\n}\n\n.carousel-inner {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n}\n\n.carousel-inner::after {\n    display: block;\n    clear: both;\n    content: \"\";\n}\n\n.carousel-item {\n    position: relative;\n    display: none;\n    float: left;\n    width: 100%;\n    margin-right: -100%;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    transition: transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .carousel-item {\n        transition: none;\n    }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n    display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n    transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n    transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    transition: opacity 0s 0.6s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .carousel-fade .active.carousel-item-start,\n    .carousel-fade .active.carousel-item-end {\n        transition: none;\n    }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 15%;\n    padding: 0;\n    color: #fff;\n    text-align: center;\n    background: none;\n    border: 0;\n    opacity: 0.5;\n    transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .carousel-control-prev,\n    .carousel-control-next {\n        transition: none;\n    }\n}\n\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: 0.9;\n}\n\n.carousel-control-prev {\n    left: 0;\n}\n\n.carousel-control-next {\n    right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    background-repeat: no-repeat;\n    background-position: 50%;\n    background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    margin-right: 15%;\n    margin-bottom: 1rem;\n    margin-left: 15%;\n    list-style: none;\n}\n\n.carousel-indicators [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    padding: 0;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    opacity: 0.5;\n    transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .carousel-indicators [data-bs-target] {\n        transition: none;\n    }\n}\n\n.carousel-indicators .active {\n    opacity: 1;\n}\n\n.carousel-caption {\n    position: absolute;\n    right: 15%;\n    bottom: 1.25rem;\n    left: 15%;\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    color: #fff;\n    text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n    filter: invert(1) grayscale(100);\n}\n\n.carousel-dark .carousel-indicators [data-bs-target] {\n    background-color: #000;\n}\n\n.carousel-dark .carousel-caption {\n    color: #000;\n}\n\n.spinner-grow,\n.spinner-border {\n    display: inline-block;\n    width: var(--bs-spinner-width);\n    height: var(--bs-spinner-height);\n    vertical-align: var(--bs-spinner-vertical-align);\n    border-radius: 50%;\n    animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n    to {\n        transform: rotate(360deg)\n            /* rtl:ignore */\n        ;\n    }\n}\n\n.spinner-border {\n    --bs-spinner-width: 2rem;\n    --bs-spinner-height: 2rem;\n    --bs-spinner-vertical-align: -0.125em;\n    --bs-spinner-border-width: 0.25em;\n    --bs-spinner-animation-speed: 0.75s;\n    --bs-spinner-animation-name: spinner-border;\n    border: var(--bs-spinner-border-width) solid currentcolor;\n    border-right-color: transparent;\n}\n\n.spinner-border-sm {\n    --bs-spinner-width: 1rem;\n    --bs-spinner-height: 1rem;\n    --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n    0% {\n        transform: scale(0);\n    }\n\n    50% {\n        opacity: 1;\n        transform: none;\n    }\n}\n\n.spinner-grow {\n    --bs-spinner-width: 2rem;\n    --bs-spinner-height: 2rem;\n    --bs-spinner-vertical-align: -0.125em;\n    --bs-spinner-animation-speed: 0.75s;\n    --bs-spinner-animation-name: spinner-grow;\n    background-color: currentcolor;\n    opacity: 0;\n}\n\n.spinner-grow-sm {\n    --bs-spinner-width: 1rem;\n    --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .spinner-border,\n    .spinner-grow {\n        --bs-spinner-animation-speed: 1.5s;\n    }\n}\n\n.offcanvas,\n.offcanvas-xxl,\n.offcanvas-xl,\n.offcanvas-lg,\n.offcanvas-md,\n.offcanvas-sm {\n    --bs-offcanvas-zindex: 1045;\n    --bs-offcanvas-width: 400px;\n    --bs-offcanvas-height: 30vh;\n    --bs-offcanvas-padding-x: 1rem;\n    --bs-offcanvas-padding-y: 1rem;\n    --bs-offcanvas-color: ;\n    --bs-offcanvas-bg: #fff;\n    --bs-offcanvas-border-width: 0.125rem;\n    --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n    --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n@media (max-width: 575.98px) {\n    .offcanvas-sm {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: transform 0.3s ease-in-out;\n    }\n}\n\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n    .offcanvas-sm {\n        transition: none;\n    }\n}\n\n@media (max-width: 575.98px) {\n    .offcanvas-sm.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%);\n    }\n}\n\n@media (max-width: 575.98px) {\n    .offcanvas-sm.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%);\n    }\n}\n\n@media (max-width: 575.98px) {\n    .offcanvas-sm.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%);\n    }\n}\n\n@media (max-width: 575.98px) {\n    .offcanvas-sm.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%);\n    }\n}\n\n@media (max-width: 575.98px) {\n\n    .offcanvas-sm.showing,\n    .offcanvas-sm.show:not(.hiding) {\n        transform: none;\n    }\n}\n\n@media (max-width: 575.98px) {\n\n    .offcanvas-sm.showing,\n    .offcanvas-sm.hiding,\n    .offcanvas-sm.show {\n        visibility: visible;\n    }\n}\n\n@media (min-width: 576px) {\n    .offcanvas-sm {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: transparent !important;\n    }\n\n    .offcanvas-sm .offcanvas-header {\n        display: none;\n    }\n\n    .offcanvas-sm .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: transparent !important;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .offcanvas-md {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: transform 0.3s ease-in-out;\n    }\n}\n\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n    .offcanvas-md {\n        transition: none;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .offcanvas-md.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%);\n    }\n}\n\n@media (max-width: 767.98px) {\n    .offcanvas-md.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%);\n    }\n}\n\n@media (max-width: 767.98px) {\n    .offcanvas-md.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%);\n    }\n}\n\n@media (max-width: 767.98px) {\n    .offcanvas-md.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%);\n    }\n}\n\n@media (max-width: 767.98px) {\n\n    .offcanvas-md.showing,\n    .offcanvas-md.show:not(.hiding) {\n        transform: none;\n    }\n}\n\n@media (max-width: 767.98px) {\n\n    .offcanvas-md.showing,\n    .offcanvas-md.hiding,\n    .offcanvas-md.show {\n        visibility: visible;\n    }\n}\n\n@media (min-width: 768px) {\n    .offcanvas-md {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: transparent !important;\n    }\n\n    .offcanvas-md .offcanvas-header {\n        display: none;\n    }\n\n    .offcanvas-md .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: transparent !important;\n    }\n}\n\n@media (max-width: 991.98px) {\n    .offcanvas-lg {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: transform 0.3s ease-in-out;\n    }\n}\n\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n    .offcanvas-lg {\n        transition: none;\n    }\n}\n\n@media (max-width: 991.98px) {\n    .offcanvas-lg.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%);\n    }\n}\n\n@media (max-width: 991.98px) {\n    .offcanvas-lg.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%);\n    }\n}\n\n@media (max-width: 991.98px) {\n    .offcanvas-lg.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%);\n    }\n}\n\n@media (max-width: 991.98px) {\n    .offcanvas-lg.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%);\n    }\n}\n\n@media (max-width: 991.98px) {\n\n    .offcanvas-lg.showing,\n    .offcanvas-lg.show:not(.hiding) {\n        transform: none;\n    }\n}\n\n@media (max-width: 991.98px) {\n\n    .offcanvas-lg.showing,\n    .offcanvas-lg.hiding,\n    .offcanvas-lg.show {\n        visibility: visible;\n    }\n}\n\n@media (min-width: 992px) {\n    .offcanvas-lg {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: transparent !important;\n    }\n\n    .offcanvas-lg .offcanvas-header {\n        display: none;\n    }\n\n    .offcanvas-lg .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: transparent !important;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .offcanvas-xl {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: transform 0.3s ease-in-out;\n    }\n}\n\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n    .offcanvas-xl {\n        transition: none;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .offcanvas-xl.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%);\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .offcanvas-xl.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%);\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .offcanvas-xl.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%);\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .offcanvas-xl.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%);\n    }\n}\n\n@media (max-width: 1199.98px) {\n\n    .offcanvas-xl.showing,\n    .offcanvas-xl.show:not(.hiding) {\n        transform: none;\n    }\n}\n\n@media (max-width: 1199.98px) {\n\n    .offcanvas-xl.showing,\n    .offcanvas-xl.hiding,\n    .offcanvas-xl.show {\n        visibility: visible;\n    }\n}\n\n@media (min-width: 1200px) {\n    .offcanvas-xl {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: transparent !important;\n    }\n\n    .offcanvas-xl .offcanvas-header {\n        display: none;\n    }\n\n    .offcanvas-xl .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: transparent !important;\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .offcanvas-xxl {\n        position: fixed;\n        bottom: 0;\n        z-index: var(--bs-offcanvas-zindex);\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n        color: var(--bs-offcanvas-color);\n        visibility: hidden;\n        background-color: var(--bs-offcanvas-bg);\n        background-clip: padding-box;\n        outline: 0;\n        transition: transform 0.3s ease-in-out;\n    }\n}\n\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n    .offcanvas-xxl {\n        transition: none;\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .offcanvas-xxl.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--bs-offcanvas-width);\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(-100%);\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .offcanvas-xxl.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--bs-offcanvas-width);\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateX(100%);\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .offcanvas-xxl.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(-100%);\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .offcanvas-xxl.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--bs-offcanvas-height);\n        max-height: 100%;\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n        transform: translateY(100%);\n    }\n}\n\n@media (max-width: 1399.98px) {\n\n    .offcanvas-xxl.showing,\n    .offcanvas-xxl.show:not(.hiding) {\n        transform: none;\n    }\n}\n\n@media (max-width: 1399.98px) {\n\n    .offcanvas-xxl.showing,\n    .offcanvas-xxl.hiding,\n    .offcanvas-xxl.show {\n        visibility: visible;\n    }\n}\n\n@media (min-width: 1400px) {\n    .offcanvas-xxl {\n        --bs-offcanvas-height: auto;\n        --bs-offcanvas-border-width: 0;\n        background-color: transparent !important;\n    }\n\n    .offcanvas-xxl .offcanvas-header {\n        display: none;\n    }\n\n    .offcanvas-xxl .offcanvas-body {\n        display: flex;\n        flex-grow: 0;\n        padding: 0;\n        overflow-y: visible;\n        background-color: transparent !important;\n    }\n}\n\n.offcanvas {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: transform 0.3s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .offcanvas {\n        transition: none;\n    }\n}\n\n.offcanvas.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n}\n\n.offcanvas.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n}\n\n.offcanvas.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n}\n\n.offcanvas.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n}\n\n.offcanvas.showing,\n.offcanvas.show:not(.hiding) {\n    transform: none;\n}\n\n.offcanvas.showing,\n.offcanvas.hiding,\n.offcanvas.show {\n    visibility: visible;\n}\n\n.offcanvas-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000;\n}\n\n.offcanvas-backdrop.fade {\n    opacity: 0;\n}\n\n.offcanvas-backdrop.show {\n    opacity: 0.5;\n}\n\n.offcanvas-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n\n.offcanvas-header .btn-close {\n    padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n    margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n    margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n    margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n    margin-bottom: 0;\n    line-height: 1.5;\n}\n\n.offcanvas-body {\n    flex-grow: 1;\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n    overflow-y: auto;\n}\n\n.placeholder {\n    display: inline-block;\n    min-height: 1em;\n    vertical-align: middle;\n    cursor: wait;\n    background-color: currentcolor;\n    opacity: 0.5;\n}\n\n.placeholder.btn::before {\n    display: inline-block;\n    content: \"\";\n}\n\n.placeholder-xs {\n    min-height: 0.6em;\n}\n\n.placeholder-sm {\n    min-height: 0.8em;\n}\n\n.placeholder-lg {\n    min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n    50% {\n        opacity: 0.2;\n    }\n}\n\n.placeholder-wave {\n    -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n    mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n    -webkit-mask-size: 200% 100%;\n    mask-size: 200% 100%;\n    animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n    100% {\n        -webkit-mask-position: -200% 0%;\n        mask-position: -200% 0%;\n    }\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\";\n}\n\n.text-bg-primary {\n    color: #fff !important;\n    background-color: RGBA(26, 188, 156, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n    color: #fff !important;\n    background-color: RGBA(44, 62, 80, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n    color: #fff !important;\n    background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n    color: #000 !important;\n    background-color: RGBA(13, 202, 240, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n    color: #000 !important;\n    background-color: RGBA(255, 193, 7, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n    color: #fff !important;\n    background-color: RGBA(220, 53, 69, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n    color: #000 !important;\n    background-color: RGBA(248, 249, 250, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n    color: #fff !important;\n    background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n    color: #0085CA !important;\n}\n\n.link-primary:hover,\n.link-primary:focus {\n    color: #15967d !important;\n}\n\n.link-secondary {\n    color: #2c3e50 !important;\n}\n\n.link-secondary:hover,\n.link-secondary:focus {\n    color: #233240 !important;\n}\n\n.link-success {\n    color: #198754 !important;\n}\n\n.link-success:hover,\n.link-success:focus {\n    color: #146c43 !important;\n}\n\n.link-info {\n    color: #0dcaf0 !important;\n}\n\n.link-info:hover,\n.link-info:focus {\n    color: #3dd5f3 !important;\n}\n\n.link-warning {\n    color: #ffc107 !important;\n}\n\n.link-warning:hover,\n.link-warning:focus {\n    color: #ffcd39 !important;\n}\n\n.link-danger {\n    color: #dc3545 !important;\n}\n\n.link-danger:hover,\n.link-danger:focus {\n    color: #b02a37 !important;\n}\n\n.link-light {\n    color: #f8f9fa !important;\n}\n\n.link-light:hover,\n.link-light:focus {\n    color: #f9fafb !important;\n}\n\n.link-dark {\n    color: #212529 !important;\n}\n\n.link-dark:hover,\n.link-dark:focus {\n    color: #1a1e21 !important;\n}\n\n.ratio {\n    position: relative;\n    width: 100%;\n}\n\n.ratio::before {\n    display: block;\n    padding-top: var(--bs-aspect-ratio);\n    content: \"\";\n}\n\n.ratio>* {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.ratio-1x1 {\n    --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n    --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n    --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n    --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030;\n}\n\n.fixed-bottom {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1030;\n}\n\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n}\n\n.sticky-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n}\n\n@media (min-width: 576px) {\n    .sticky-sm-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n\n    .sticky-sm-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020;\n    }\n}\n\n@media (min-width: 768px) {\n    .sticky-md-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n\n    .sticky-md-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020;\n    }\n}\n\n@media (min-width: 992px) {\n    .sticky-lg-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n\n    .sticky-lg-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020;\n    }\n}\n\n@media (min-width: 1200px) {\n    .sticky-xl-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n\n    .sticky-xl-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020;\n    }\n}\n\n@media (min-width: 1400px) {\n    .sticky-xxl-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n\n    .sticky-xxl-bottom {\n        position: sticky;\n        bottom: 0;\n        z-index: 1020;\n    }\n}\n\n.hstack {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    align-self: stretch;\n}\n\n.vstack {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n    position: absolute !important;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    margin: -1px !important;\n    overflow: hidden !important;\n    clip: rect(0, 0, 0, 0) !important;\n    white-space: nowrap !important;\n    border: 0 !important;\n}\n\n.stretched-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    content: \"\";\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.vr {\n    display: inline-block;\n    align-self: stretch;\n    width: 1px;\n    min-height: 1em;\n    background-color: currentcolor;\n    opacity: 0.25;\n}\n\n.align-baseline {\n    vertical-align: baseline !important;\n}\n\n.align-top {\n    vertical-align: top !important;\n}\n\n.align-middle {\n    vertical-align: middle !important;\n}\n\n.align-bottom {\n    vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n    vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n    vertical-align: text-top !important;\n}\n\n.float-start {\n    float: left !important;\n}\n\n.float-end {\n    float: right !important;\n}\n\n.float-none {\n    float: none !important;\n}\n\n.opacity-0 {\n    opacity: 0 !important;\n}\n\n.opacity-25 {\n    opacity: 0.25 !important;\n}\n\n.opacity-50 {\n    opacity: 0.5 !important;\n}\n\n.opacity-75 {\n    opacity: 0.75 !important;\n}\n\n.opacity-100 {\n    opacity: 1 !important;\n}\n\n.overflow-auto {\n    overflow: auto !important;\n}\n\n.overflow-hidden {\n    overflow: hidden !important;\n}\n\n.overflow-visible {\n    overflow: visible !important;\n}\n\n.overflow-scroll {\n    overflow: scroll !important;\n}\n\n.d-inline {\n    display: inline !important;\n}\n\n.d-inline-block {\n    display: inline-block !important;\n}\n\n.d-block {\n    display: block !important;\n}\n\n.d-grid {\n    display: grid !important;\n}\n\n.d-table {\n    display: table !important;\n}\n\n.d-table-row {\n    display: table-row !important;\n}\n\n.d-table-cell {\n    display: table-cell !important;\n}\n\n.d-flex {\n    display: flex !important;\n}\n\n.d-inline-flex {\n    display: inline-flex !important;\n}\n\n.d-none {\n    display: none !important;\n}\n\n.shadow {\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-sm {\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n    box-shadow: none !important;\n}\n\n.position-static {\n    position: static !important;\n}\n\n.position-relative {\n    position: relative !important;\n}\n\n.position-absolute {\n    position: absolute !important;\n}\n\n.position-fixed {\n    position: fixed !important;\n}\n\n.position-sticky {\n    position: sticky !important;\n}\n\n.top-0 {\n    top: 0 !important;\n}\n\n.top-50 {\n    top: 50% !important;\n}\n\n.top-100 {\n    top: 100% !important;\n}\n\n.bottom-0 {\n    bottom: 0 !important;\n}\n\n.bottom-50 {\n    bottom: 50% !important;\n}\n\n.bottom-100 {\n    bottom: 100% !important;\n}\n\n.start-0 {\n    left: 0 !important;\n}\n\n.start-50 {\n    left: 50% !important;\n}\n\n.start-100 {\n    left: 100% !important;\n}\n\n.end-0 {\n    right: 0 !important;\n}\n\n.end-50 {\n    right: 50% !important;\n}\n\n.end-100 {\n    right: 100% !important;\n}\n\n.translate-middle {\n    transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n    transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n    transform: translateY(-50%) !important;\n}\n\n.border {\n    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n    border: 0 !important;\n}\n\n.border-top {\n    border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n    border-top: 0 !important;\n}\n\n.border-end {\n    border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n    border-right: 0 !important;\n}\n\n.border-bottom {\n    border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n    border-bottom: 0 !important;\n}\n\n.border-start {\n    border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n    border-left: 0 !important;\n}\n\n.border-primary {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n    --bs-border-opacity: 1;\n    border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-1 {\n    --bs-border-width: 1px;\n}\n\n.border-2 {\n    --bs-border-width: 2px;\n}\n\n.border-3 {\n    --bs-border-width: 3px;\n}\n\n.border-4 {\n    --bs-border-width: 4px;\n}\n\n.border-5 {\n    --bs-border-width: 5px;\n}\n\n.border-opacity-10 {\n    --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n    --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n    --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n    --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n    --bs-border-opacity: 1;\n}\n\n.w-25 {\n    width: 25% !important;\n}\n\n.w-50 {\n    width: 50% !important;\n}\n\n.w-75 {\n    width: 75% !important;\n}\n\n.w-100 {\n    width: 100% !important;\n}\n\n.w-auto {\n    width: auto !important;\n}\n\n.mw-100 {\n    max-width: 100% !important;\n}\n\n.vw-100 {\n    width: 100vw !important;\n}\n\n.min-vw-100 {\n    min-width: 100vw !important;\n}\n\n.h-25 {\n    height: 25% !important;\n}\n\n.h-50 {\n    height: 50% !important;\n}\n\n.h-75 {\n    height: 75% !important;\n}\n\n.h-100 {\n    height: 100% !important;\n}\n\n.h-auto {\n    height: auto !important;\n}\n\n.mh-100 {\n    max-height: 100% !important;\n}\n\n.vh-100 {\n    height: 100vh !important;\n}\n\n.min-vh-100 {\n    min-height: 100vh !important;\n}\n\n.flex-fill {\n    flex: 1 1 auto !important;\n}\n\n.flex-row {\n    flex-direction: row !important;\n}\n\n.flex-column {\n    flex-direction: column !important;\n}\n\n.flex-row-reverse {\n    flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n    flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n    flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n    flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n    flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n    flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n    flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n    flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n    justify-content: flex-start !important;\n}\n\n.justify-content-end {\n    justify-content: flex-end !important;\n}\n\n.justify-content-center {\n    justify-content: center !important;\n}\n\n.justify-content-between {\n    justify-content: space-between !important;\n}\n\n.justify-content-around {\n    justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n    justify-content: space-evenly !important;\n}\n\n.align-items-start {\n    align-items: flex-start !important;\n}\n\n.align-items-end {\n    align-items: flex-end !important;\n}\n\n.align-items-center {\n    align-items: center !important;\n}\n\n.align-items-baseline {\n    align-items: baseline !important;\n}\n\n.align-items-stretch {\n    align-items: stretch !important;\n}\n\n.align-content-start {\n    align-content: flex-start !important;\n}\n\n.align-content-end {\n    align-content: flex-end !important;\n}\n\n.align-content-center {\n    align-content: center !important;\n}\n\n.align-content-between {\n    align-content: space-between !important;\n}\n\n.align-content-around {\n    align-content: space-around !important;\n}\n\n.align-content-stretch {\n    align-content: stretch !important;\n}\n\n.align-self-auto {\n    align-self: auto !important;\n}\n\n.align-self-start {\n    align-self: flex-start !important;\n}\n\n.align-self-end {\n    align-self: flex-end !important;\n}\n\n.align-self-center {\n    align-self: center !important;\n}\n\n.align-self-baseline {\n    align-self: baseline !important;\n}\n\n.align-self-stretch {\n    align-self: stretch !important;\n}\n\n.order-first {\n    order: -1 !important;\n}\n\n.order-0 {\n    order: 0 !important;\n}\n\n.order-1 {\n    order: 1 !important;\n}\n\n.order-2 {\n    order: 2 !important;\n}\n\n.order-3 {\n    order: 3 !important;\n}\n\n.order-4 {\n    order: 4 !important;\n}\n\n.order-5 {\n    order: 5 !important;\n}\n\n.order-last {\n    order: 6 !important;\n}\n\n.m-0 {\n    margin: 0 !important;\n}\n\n.m-1 {\n    margin: 0.25rem !important;\n}\n\n.m-2 {\n    margin: 0.5rem !important;\n}\n\n.m-3 {\n    margin: 1rem !important;\n}\n\n.m-4 {\n    margin: 1.5rem !important;\n}\n\n.m-5 {\n    margin: 3rem !important;\n}\n\n.m-auto {\n    margin: auto !important;\n}\n\n.mx-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n}\n\n.mx-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n}\n\n.mx-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n}\n\n.mx-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n\n.my-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n\n.my-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n}\n\n.my-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n}\n\n.my-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n}\n\n.mt-0 {\n    margin-top: 0 !important;\n}\n\n.mt-1 {\n    margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n    margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n    margin-top: 1rem !important;\n}\n\n.mt-4 {\n    margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n    margin-top: 3rem !important;\n}\n\n.mt-auto {\n    margin-top: auto !important;\n}\n\n.me-0 {\n    margin-right: 0 !important;\n}\n\n.me-1 {\n    margin-right: 0.25rem !important;\n}\n\n.me-2 {\n    margin-right: 0.5rem !important;\n}\n\n.me-3 {\n    margin-right: 1rem !important;\n}\n\n.me-4 {\n    margin-right: 1.5rem !important;\n}\n\n.me-5 {\n    margin-right: 3rem !important;\n}\n\n.me-auto {\n    margin-right: auto !important;\n}\n\n.mb-0 {\n    margin-bottom: 0 !important;\n}\n\n.mb-1 {\n    margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n    margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n    margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n    margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n    margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n    margin-bottom: auto !important;\n}\n\n.ms-0 {\n    margin-left: 0 !important;\n}\n\n.ms-1 {\n    margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n    margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n    margin-left: 1rem !important;\n}\n\n.ms-4 {\n    margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n    margin-left: 3rem !important;\n}\n\n.ms-auto {\n    margin-left: auto !important;\n}\n\n.p-0 {\n    padding: 0 !important;\n}\n\n.p-1 {\n    padding: 0.25rem !important;\n}\n\n.p-2 {\n    padding: 0.5rem !important;\n}\n\n.p-3 {\n    padding: 1rem !important;\n}\n\n.p-4 {\n    padding: 1.5rem !important;\n}\n\n.p-5 {\n    padding: 3rem !important;\n}\n\n.px-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n}\n\n.px-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n}\n\n.px-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n}\n\n.px-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n}\n\n.px-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n}\n\n.px-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n}\n\n.py-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n\n.py-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n\n.py-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n    padding-top: 0 !important;\n}\n\n.pt-1 {\n    padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n    padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n    padding-top: 1rem !important;\n}\n\n.pt-4 {\n    padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n    padding-top: 3rem !important;\n}\n\n.pe-0 {\n    padding-right: 0 !important;\n}\n\n.pe-1 {\n    padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n    padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n    padding-right: 1rem !important;\n}\n\n.pe-4 {\n    padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n    padding-right: 3rem !important;\n}\n\n.pb-0 {\n    padding-bottom: 0 !important;\n}\n\n.pb-1 {\n    padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n    padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n    padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n    padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n    padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n    padding-left: 0 !important;\n}\n\n.ps-1 {\n    padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n    padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n    padding-left: 1rem !important;\n}\n\n.ps-4 {\n    padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n    padding-left: 3rem !important;\n}\n\n.gap-0 {\n    gap: 0 !important;\n}\n\n.gap-1 {\n    gap: 0.25rem !important;\n}\n\n.gap-2 {\n    gap: 0.5rem !important;\n}\n\n.gap-3 {\n    gap: 1rem !important;\n}\n\n.gap-4 {\n    gap: 1.5rem !important;\n}\n\n.gap-5 {\n    gap: 3rem !important;\n}\n\n.font-monospace {\n    font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n    font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2 {\n    font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-3 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-4 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-5 {\n    font-size: 1.25rem !important;\n}\n\n.fs-6 {\n    font-size: 1rem !important;\n}\n\n.fst-italic {\n    font-style: italic !important;\n}\n\n.fst-normal {\n    font-style: normal !important;\n}\n\n.fw-light {\n    font-weight: 300 !important;\n}\n\n.fw-lighter {\n    font-weight: lighter !important;\n}\n\n.fw-normal {\n    font-weight: 400 !important;\n}\n\n.fw-bold {\n    font-weight: 700 !important;\n}\n\n.fw-semibold {\n    font-weight: 600 !important;\n}\n\n.fw-bolder {\n    font-weight: bolder !important;\n}\n\n.lh-1 {\n    line-height: 1 !important;\n}\n\n.lh-sm {\n    line-height: 1.25 !important;\n}\n\n.lh-base {\n    line-height: 1.5 !important;\n}\n\n.lh-lg {\n    line-height: 2 !important;\n}\n\n.text-start {\n    text-align: left !important;\n}\n\n.text-end {\n    text-align: right !important;\n}\n\n.text-center {\n    text-align: center !important;\n}\n\n.text-decoration-none {\n    text-decoration: none !important;\n}\n\n.text-decoration-underline {\n    text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n    text-decoration: line-through !important;\n}\n\n.text-lowercase {\n    text-transform: lowercase !important;\n}\n\n.text-uppercase {\n    text-transform: uppercase !important;\n}\n\n.text-capitalize {\n    text-transform: capitalize !important;\n}\n\n.text-wrap {\n    white-space: normal !important;\n}\n\n.text-nowrap {\n    white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n    --bs-text-opacity: 1;\n    color: #6c757d !important;\n}\n\n.text-black-50 {\n    --bs-text-opacity: 1;\n    color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n    --bs-text-opacity: 1;\n    color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n    --bs-text-opacity: 1;\n    color: inherit !important;\n}\n\n.text-opacity-25 {\n    --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n    --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n    --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n    --bs-text-opacity: 1;\n}\n\n.bg-primary {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n    --bs-bg-opacity: 1;\n    background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n    --bs-bg-opacity: 1;\n    background-color: transparent !important;\n}\n\n.bg-opacity-10 {\n    --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n    --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n    --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n    --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n    --bs-bg-opacity: 1;\n}\n\n.bg-gradient {\n    background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n    -webkit-user-select: all !important;\n    -moz-user-select: all !important;\n    user-select: all !important;\n}\n\n.user-select-auto {\n    -webkit-user-select: auto !important;\n    -moz-user-select: auto !important;\n    user-select: auto !important;\n}\n\n.user-select-none {\n    -webkit-user-select: none !important;\n    -moz-user-select: none !important;\n    user-select: none !important;\n}\n\n.pe-none {\n    pointer-events: none !important;\n}\n\n.pe-auto {\n    pointer-events: auto !important;\n}\n\n.rounded {\n    border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n    border-radius: 0 !important;\n}\n\n.rounded-1 {\n    border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n    border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n    border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n    border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n    border-radius: var(--bs-border-radius-2xl) !important;\n}\n\n.rounded-circle {\n    border-radius: 50% !important;\n}\n\n.rounded-pill {\n    border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n    border-top-left-radius: var(--bs-border-radius) !important;\n    border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end {\n    border-top-right-radius: var(--bs-border-radius) !important;\n    border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom {\n    border-bottom-right-radius: var(--bs-border-radius) !important;\n    border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start {\n    border-bottom-left-radius: var(--bs-border-radius) !important;\n    border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.visible {\n    visibility: visible !important;\n}\n\n.invisible {\n    visibility: hidden !important;\n}\n\n@media (min-width: 576px) {\n    .float-sm-start {\n        float: left !important;\n    }\n\n    .float-sm-end {\n        float: right !important;\n    }\n\n    .float-sm-none {\n        float: none !important;\n    }\n\n    .d-sm-inline {\n        display: inline !important;\n    }\n\n    .d-sm-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-sm-block {\n        display: block !important;\n    }\n\n    .d-sm-grid {\n        display: grid !important;\n    }\n\n    .d-sm-table {\n        display: table !important;\n    }\n\n    .d-sm-table-row {\n        display: table-row !important;\n    }\n\n    .d-sm-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-sm-flex {\n        display: flex !important;\n    }\n\n    .d-sm-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-sm-none {\n        display: none !important;\n    }\n\n    .flex-sm-fill {\n        flex: 1 1 auto !important;\n    }\n\n    .flex-sm-row {\n        flex-direction: row !important;\n    }\n\n    .flex-sm-column {\n        flex-direction: column !important;\n    }\n\n    .flex-sm-row-reverse {\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-sm-column-reverse {\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-sm-grow-0 {\n        flex-grow: 0 !important;\n    }\n\n    .flex-sm-grow-1 {\n        flex-grow: 1 !important;\n    }\n\n    .flex-sm-shrink-0 {\n        flex-shrink: 0 !important;\n    }\n\n    .flex-sm-shrink-1 {\n        flex-shrink: 1 !important;\n    }\n\n    .flex-sm-wrap {\n        flex-wrap: wrap !important;\n    }\n\n    .flex-sm-nowrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-sm-wrap-reverse {\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-sm-start {\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-sm-end {\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-sm-center {\n        justify-content: center !important;\n    }\n\n    .justify-content-sm-between {\n        justify-content: space-between !important;\n    }\n\n    .justify-content-sm-around {\n        justify-content: space-around !important;\n    }\n\n    .justify-content-sm-evenly {\n        justify-content: space-evenly !important;\n    }\n\n    .align-items-sm-start {\n        align-items: flex-start !important;\n    }\n\n    .align-items-sm-end {\n        align-items: flex-end !important;\n    }\n\n    .align-items-sm-center {\n        align-items: center !important;\n    }\n\n    .align-items-sm-baseline {\n        align-items: baseline !important;\n    }\n\n    .align-items-sm-stretch {\n        align-items: stretch !important;\n    }\n\n    .align-content-sm-start {\n        align-content: flex-start !important;\n    }\n\n    .align-content-sm-end {\n        align-content: flex-end !important;\n    }\n\n    .align-content-sm-center {\n        align-content: center !important;\n    }\n\n    .align-content-sm-between {\n        align-content: space-between !important;\n    }\n\n    .align-content-sm-around {\n        align-content: space-around !important;\n    }\n\n    .align-content-sm-stretch {\n        align-content: stretch !important;\n    }\n\n    .align-self-sm-auto {\n        align-self: auto !important;\n    }\n\n    .align-self-sm-start {\n        align-self: flex-start !important;\n    }\n\n    .align-self-sm-end {\n        align-self: flex-end !important;\n    }\n\n    .align-self-sm-center {\n        align-self: center !important;\n    }\n\n    .align-self-sm-baseline {\n        align-self: baseline !important;\n    }\n\n    .align-self-sm-stretch {\n        align-self: stretch !important;\n    }\n\n    .order-sm-first {\n        order: -1 !important;\n    }\n\n    .order-sm-0 {\n        order: 0 !important;\n    }\n\n    .order-sm-1 {\n        order: 1 !important;\n    }\n\n    .order-sm-2 {\n        order: 2 !important;\n    }\n\n    .order-sm-3 {\n        order: 3 !important;\n    }\n\n    .order-sm-4 {\n        order: 4 !important;\n    }\n\n    .order-sm-5 {\n        order: 5 !important;\n    }\n\n    .order-sm-last {\n        order: 6 !important;\n    }\n\n    .m-sm-0 {\n        margin: 0 !important;\n    }\n\n    .m-sm-1 {\n        margin: 0.25rem !important;\n    }\n\n    .m-sm-2 {\n        margin: 0.5rem !important;\n    }\n\n    .m-sm-3 {\n        margin: 1rem !important;\n    }\n\n    .m-sm-4 {\n        margin: 1.5rem !important;\n    }\n\n    .m-sm-5 {\n        margin: 3rem !important;\n    }\n\n    .m-sm-auto {\n        margin: auto !important;\n    }\n\n    .mx-sm-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n\n    .mx-sm-1 {\n        margin-right: 0.25rem !important;\n        margin-left: 0.25rem !important;\n    }\n\n    .mx-sm-2 {\n        margin-right: 0.5rem !important;\n        margin-left: 0.5rem !important;\n    }\n\n    .mx-sm-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important;\n    }\n\n    .mx-sm-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important;\n    }\n\n    .mx-sm-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important;\n    }\n\n    .mx-sm-auto {\n        margin-right: auto !important;\n        margin-left: auto !important;\n    }\n\n    .my-sm-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    .my-sm-1 {\n        margin-top: 0.25rem !important;\n        margin-bottom: 0.25rem !important;\n    }\n\n    .my-sm-2 {\n        margin-top: 0.5rem !important;\n        margin-bottom: 0.5rem !important;\n    }\n\n    .my-sm-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important;\n    }\n\n    .my-sm-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n\n    .my-sm-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .my-sm-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n\n    .mt-sm-0 {\n        margin-top: 0 !important;\n    }\n\n    .mt-sm-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mt-sm-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mt-sm-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mt-sm-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mt-sm-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mt-sm-auto {\n        margin-top: auto !important;\n    }\n\n    .me-sm-0 {\n        margin-right: 0 !important;\n    }\n\n    .me-sm-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .me-sm-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .me-sm-3 {\n        margin-right: 1rem !important;\n    }\n\n    .me-sm-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .me-sm-5 {\n        margin-right: 3rem !important;\n    }\n\n    .me-sm-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-sm-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .mb-sm-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .mb-sm-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .mb-sm-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .mb-sm-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .mb-sm-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .mb-sm-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ms-sm-0 {\n        margin-left: 0 !important;\n    }\n\n    .ms-sm-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .ms-sm-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .ms-sm-3 {\n        margin-left: 1rem !important;\n    }\n\n    .ms-sm-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .ms-sm-5 {\n        margin-left: 3rem !important;\n    }\n\n    .ms-sm-auto {\n        margin-left: auto !important;\n    }\n\n    .p-sm-0 {\n        padding: 0 !important;\n    }\n\n    .p-sm-1 {\n        padding: 0.25rem !important;\n    }\n\n    .p-sm-2 {\n        padding: 0.5rem !important;\n    }\n\n    .p-sm-3 {\n        padding: 1rem !important;\n    }\n\n    .p-sm-4 {\n        padding: 1.5rem !important;\n    }\n\n    .p-sm-5 {\n        padding: 3rem !important;\n    }\n\n    .px-sm-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n    .px-sm-1 {\n        padding-right: 0.25rem !important;\n        padding-left: 0.25rem !important;\n    }\n\n    .px-sm-2 {\n        padding-right: 0.5rem !important;\n        padding-left: 0.5rem !important;\n    }\n\n    .px-sm-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important;\n    }\n\n    .px-sm-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important;\n    }\n\n    .px-sm-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important;\n    }\n\n    .py-sm-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .py-sm-1 {\n        padding-top: 0.25rem !important;\n        padding-bottom: 0.25rem !important;\n    }\n\n    .py-sm-2 {\n        padding-top: 0.5rem !important;\n        padding-bottom: 0.5rem !important;\n    }\n\n    .py-sm-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important;\n    }\n\n    .py-sm-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n\n    .py-sm-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important;\n    }\n\n    .pt-sm-0 {\n        padding-top: 0 !important;\n    }\n\n    .pt-sm-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pt-sm-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pt-sm-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pt-sm-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pt-sm-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pe-sm-0 {\n        padding-right: 0 !important;\n    }\n\n    .pe-sm-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pe-sm-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pe-sm-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pe-sm-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pe-sm-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-sm-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pb-sm-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pb-sm-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pb-sm-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pb-sm-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pb-sm-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .ps-sm-0 {\n        padding-left: 0 !important;\n    }\n\n    .ps-sm-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .ps-sm-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .ps-sm-3 {\n        padding-left: 1rem !important;\n    }\n\n    .ps-sm-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .ps-sm-5 {\n        padding-left: 3rem !important;\n    }\n\n    .gap-sm-0 {\n        gap: 0 !important;\n    }\n\n    .gap-sm-1 {\n        gap: 0.25rem !important;\n    }\n\n    .gap-sm-2 {\n        gap: 0.5rem !important;\n    }\n\n    .gap-sm-3 {\n        gap: 1rem !important;\n    }\n\n    .gap-sm-4 {\n        gap: 1.5rem !important;\n    }\n\n    .gap-sm-5 {\n        gap: 3rem !important;\n    }\n\n    .text-sm-start {\n        text-align: left !important;\n    }\n\n    .text-sm-end {\n        text-align: right !important;\n    }\n\n    .text-sm-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .float-md-start {\n        float: left !important;\n    }\n\n    .float-md-end {\n        float: right !important;\n    }\n\n    .float-md-none {\n        float: none !important;\n    }\n\n    .d-md-inline {\n        display: inline !important;\n    }\n\n    .d-md-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-md-block {\n        display: block !important;\n    }\n\n    .d-md-grid {\n        display: grid !important;\n    }\n\n    .d-md-table {\n        display: table !important;\n    }\n\n    .d-md-table-row {\n        display: table-row !important;\n    }\n\n    .d-md-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-md-flex {\n        display: flex !important;\n    }\n\n    .d-md-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-md-none {\n        display: none !important;\n    }\n\n    .flex-md-fill {\n        flex: 1 1 auto !important;\n    }\n\n    .flex-md-row {\n        flex-direction: row !important;\n    }\n\n    .flex-md-column {\n        flex-direction: column !important;\n    }\n\n    .flex-md-row-reverse {\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-md-column-reverse {\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-md-grow-0 {\n        flex-grow: 0 !important;\n    }\n\n    .flex-md-grow-1 {\n        flex-grow: 1 !important;\n    }\n\n    .flex-md-shrink-0 {\n        flex-shrink: 0 !important;\n    }\n\n    .flex-md-shrink-1 {\n        flex-shrink: 1 !important;\n    }\n\n    .flex-md-wrap {\n        flex-wrap: wrap !important;\n    }\n\n    .flex-md-nowrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-md-wrap-reverse {\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-md-start {\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-md-end {\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-md-center {\n        justify-content: center !important;\n    }\n\n    .justify-content-md-between {\n        justify-content: space-between !important;\n    }\n\n    .justify-content-md-around {\n        justify-content: space-around !important;\n    }\n\n    .justify-content-md-evenly {\n        justify-content: space-evenly !important;\n    }\n\n    .align-items-md-start {\n        align-items: flex-start !important;\n    }\n\n    .align-items-md-end {\n        align-items: flex-end !important;\n    }\n\n    .align-items-md-center {\n        align-items: center !important;\n    }\n\n    .align-items-md-baseline {\n        align-items: baseline !important;\n    }\n\n    .align-items-md-stretch {\n        align-items: stretch !important;\n    }\n\n    .align-content-md-start {\n        align-content: flex-start !important;\n    }\n\n    .align-content-md-end {\n        align-content: flex-end !important;\n    }\n\n    .align-content-md-center {\n        align-content: center !important;\n    }\n\n    .align-content-md-between {\n        align-content: space-between !important;\n    }\n\n    .align-content-md-around {\n        align-content: space-around !important;\n    }\n\n    .align-content-md-stretch {\n        align-content: stretch !important;\n    }\n\n    .align-self-md-auto {\n        align-self: auto !important;\n    }\n\n    .align-self-md-start {\n        align-self: flex-start !important;\n    }\n\n    .align-self-md-end {\n        align-self: flex-end !important;\n    }\n\n    .align-self-md-center {\n        align-self: center !important;\n    }\n\n    .align-self-md-baseline {\n        align-self: baseline !important;\n    }\n\n    .align-self-md-stretch {\n        align-self: stretch !important;\n    }\n\n    .order-md-first {\n        order: -1 !important;\n    }\n\n    .order-md-0 {\n        order: 0 !important;\n    }\n\n    .order-md-1 {\n        order: 1 !important;\n    }\n\n    .order-md-2 {\n        order: 2 !important;\n    }\n\n    .order-md-3 {\n        order: 3 !important;\n    }\n\n    .order-md-4 {\n        order: 4 !important;\n    }\n\n    .order-md-5 {\n        order: 5 !important;\n    }\n\n    .order-md-last {\n        order: 6 !important;\n    }\n\n    .m-md-0 {\n        margin: 0 !important;\n    }\n\n    .m-md-1 {\n        margin: 0.25rem !important;\n    }\n\n    .m-md-2 {\n        margin: 0.5rem !important;\n    }\n\n    .m-md-3 {\n        margin: 1rem !important;\n    }\n\n    .m-md-4 {\n        margin: 1.5rem !important;\n    }\n\n    .m-md-5 {\n        margin: 3rem !important;\n    }\n\n    .m-md-auto {\n        margin: auto !important;\n    }\n\n    .mx-md-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n\n    .mx-md-1 {\n        margin-right: 0.25rem !important;\n        margin-left: 0.25rem !important;\n    }\n\n    .mx-md-2 {\n        margin-right: 0.5rem !important;\n        margin-left: 0.5rem !important;\n    }\n\n    .mx-md-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important;\n    }\n\n    .mx-md-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important;\n    }\n\n    .mx-md-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important;\n    }\n\n    .mx-md-auto {\n        margin-right: auto !important;\n        margin-left: auto !important;\n    }\n\n    .my-md-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    .my-md-1 {\n        margin-top: 0.25rem !important;\n        margin-bottom: 0.25rem !important;\n    }\n\n    .my-md-2 {\n        margin-top: 0.5rem !important;\n        margin-bottom: 0.5rem !important;\n    }\n\n    .my-md-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important;\n    }\n\n    .my-md-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n\n    .my-md-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .my-md-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n\n    .mt-md-0 {\n        margin-top: 0 !important;\n    }\n\n    .mt-md-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mt-md-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mt-md-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mt-md-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mt-md-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mt-md-auto {\n        margin-top: auto !important;\n    }\n\n    .me-md-0 {\n        margin-right: 0 !important;\n    }\n\n    .me-md-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .me-md-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .me-md-3 {\n        margin-right: 1rem !important;\n    }\n\n    .me-md-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .me-md-5 {\n        margin-right: 3rem !important;\n    }\n\n    .me-md-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-md-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .mb-md-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .mb-md-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .mb-md-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .mb-md-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .mb-md-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .mb-md-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ms-md-0 {\n        margin-left: 0 !important;\n    }\n\n    .ms-md-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .ms-md-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .ms-md-3 {\n        margin-left: 1rem !important;\n    }\n\n    .ms-md-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .ms-md-5 {\n        margin-left: 3rem !important;\n    }\n\n    .ms-md-auto {\n        margin-left: auto !important;\n    }\n\n    .p-md-0 {\n        padding: 0 !important;\n    }\n\n    .p-md-1 {\n        padding: 0.25rem !important;\n    }\n\n    .p-md-2 {\n        padding: 0.5rem !important;\n    }\n\n    .p-md-3 {\n        padding: 1rem !important;\n    }\n\n    .p-md-4 {\n        padding: 1.5rem !important;\n    }\n\n    .p-md-5 {\n        padding: 3rem !important;\n    }\n\n    .px-md-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n    .px-md-1 {\n        padding-right: 0.25rem !important;\n        padding-left: 0.25rem !important;\n    }\n\n    .px-md-2 {\n        padding-right: 0.5rem !important;\n        padding-left: 0.5rem !important;\n    }\n\n    .px-md-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important;\n    }\n\n    .px-md-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important;\n    }\n\n    .px-md-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important;\n    }\n\n    .py-md-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .py-md-1 {\n        padding-top: 0.25rem !important;\n        padding-bottom: 0.25rem !important;\n    }\n\n    .py-md-2 {\n        padding-top: 0.5rem !important;\n        padding-bottom: 0.5rem !important;\n    }\n\n    .py-md-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important;\n    }\n\n    .py-md-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n\n    .py-md-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important;\n    }\n\n    .pt-md-0 {\n        padding-top: 0 !important;\n    }\n\n    .pt-md-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pt-md-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pt-md-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pt-md-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pt-md-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pe-md-0 {\n        padding-right: 0 !important;\n    }\n\n    .pe-md-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pe-md-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pe-md-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pe-md-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pe-md-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-md-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pb-md-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pb-md-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pb-md-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pb-md-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pb-md-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .ps-md-0 {\n        padding-left: 0 !important;\n    }\n\n    .ps-md-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .ps-md-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .ps-md-3 {\n        padding-left: 1rem !important;\n    }\n\n    .ps-md-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .ps-md-5 {\n        padding-left: 3rem !important;\n    }\n\n    .gap-md-0 {\n        gap: 0 !important;\n    }\n\n    .gap-md-1 {\n        gap: 0.25rem !important;\n    }\n\n    .gap-md-2 {\n        gap: 0.5rem !important;\n    }\n\n    .gap-md-3 {\n        gap: 1rem !important;\n    }\n\n    .gap-md-4 {\n        gap: 1.5rem !important;\n    }\n\n    .gap-md-5 {\n        gap: 3rem !important;\n    }\n\n    .text-md-start {\n        text-align: left !important;\n    }\n\n    .text-md-end {\n        text-align: right !important;\n    }\n\n    .text-md-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .float-lg-start {\n        float: left !important;\n    }\n\n    .float-lg-end {\n        float: right !important;\n    }\n\n    .float-lg-none {\n        float: none !important;\n    }\n\n    .d-lg-inline {\n        display: inline !important;\n    }\n\n    .d-lg-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-lg-block {\n        display: block !important;\n    }\n\n    .d-lg-grid {\n        display: grid !important;\n    }\n\n    .d-lg-table {\n        display: table !important;\n    }\n\n    .d-lg-table-row {\n        display: table-row !important;\n    }\n\n    .d-lg-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-lg-flex {\n        display: flex !important;\n    }\n\n    .d-lg-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-lg-none {\n        display: none !important;\n    }\n\n    .flex-lg-fill {\n        flex: 1 1 auto !important;\n    }\n\n    .flex-lg-row {\n        flex-direction: row !important;\n    }\n\n    .flex-lg-column {\n        flex-direction: column !important;\n    }\n\n    .flex-lg-row-reverse {\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-lg-column-reverse {\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-lg-grow-0 {\n        flex-grow: 0 !important;\n    }\n\n    .flex-lg-grow-1 {\n        flex-grow: 1 !important;\n    }\n\n    .flex-lg-shrink-0 {\n        flex-shrink: 0 !important;\n    }\n\n    .flex-lg-shrink-1 {\n        flex-shrink: 1 !important;\n    }\n\n    .flex-lg-wrap {\n        flex-wrap: wrap !important;\n    }\n\n    .flex-lg-nowrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-lg-wrap-reverse {\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-lg-start {\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-lg-end {\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-lg-center {\n        justify-content: center !important;\n    }\n\n    .justify-content-lg-between {\n        justify-content: space-between !important;\n    }\n\n    .justify-content-lg-around {\n        justify-content: space-around !important;\n    }\n\n    .justify-content-lg-evenly {\n        justify-content: space-evenly !important;\n    }\n\n    .align-items-lg-start {\n        align-items: flex-start !important;\n    }\n\n    .align-items-lg-end {\n        align-items: flex-end !important;\n    }\n\n    .align-items-lg-center {\n        align-items: center !important;\n    }\n\n    .align-items-lg-baseline {\n        align-items: baseline !important;\n    }\n\n    .align-items-lg-stretch {\n        align-items: stretch !important;\n    }\n\n    .align-content-lg-start {\n        align-content: flex-start !important;\n    }\n\n    .align-content-lg-end {\n        align-content: flex-end !important;\n    }\n\n    .align-content-lg-center {\n        align-content: center !important;\n    }\n\n    .align-content-lg-between {\n        align-content: space-between !important;\n    }\n\n    .align-content-lg-around {\n        align-content: space-around !important;\n    }\n\n    .align-content-lg-stretch {\n        align-content: stretch !important;\n    }\n\n    .align-self-lg-auto {\n        align-self: auto !important;\n    }\n\n    .align-self-lg-start {\n        align-self: flex-start !important;\n    }\n\n    .align-self-lg-end {\n        align-self: flex-end !important;\n    }\n\n    .align-self-lg-center {\n        align-self: center !important;\n    }\n\n    .align-self-lg-baseline {\n        align-self: baseline !important;\n    }\n\n    .align-self-lg-stretch {\n        align-self: stretch !important;\n    }\n\n    .order-lg-first {\n        order: -1 !important;\n    }\n\n    .order-lg-0 {\n        order: 0 !important;\n    }\n\n    .order-lg-1 {\n        order: 1 !important;\n    }\n\n    .order-lg-2 {\n        order: 2 !important;\n    }\n\n    .order-lg-3 {\n        order: 3 !important;\n    }\n\n    .order-lg-4 {\n        order: 4 !important;\n    }\n\n    .order-lg-5 {\n        order: 5 !important;\n    }\n\n    .order-lg-last {\n        order: 6 !important;\n    }\n\n    .m-lg-0 {\n        margin: 0 !important;\n    }\n\n    .m-lg-1 {\n        margin: 0.25rem !important;\n    }\n\n    .m-lg-2 {\n        margin: 0.5rem !important;\n    }\n\n    .m-lg-3 {\n        margin: 1rem !important;\n    }\n\n    .m-lg-4 {\n        margin: 1.5rem !important;\n    }\n\n    .m-lg-5 {\n        margin: 3rem !important;\n    }\n\n    .m-lg-auto {\n        margin: auto !important;\n    }\n\n    .mx-lg-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n\n    .mx-lg-1 {\n        margin-right: 0.25rem !important;\n        margin-left: 0.25rem !important;\n    }\n\n    .mx-lg-2 {\n        margin-right: 0.5rem !important;\n        margin-left: 0.5rem !important;\n    }\n\n    .mx-lg-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important;\n    }\n\n    .mx-lg-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important;\n    }\n\n    .mx-lg-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important;\n    }\n\n    .mx-lg-auto {\n        margin-right: auto !important;\n        margin-left: auto !important;\n    }\n\n    .my-lg-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    .my-lg-1 {\n        margin-top: 0.25rem !important;\n        margin-bottom: 0.25rem !important;\n    }\n\n    .my-lg-2 {\n        margin-top: 0.5rem !important;\n        margin-bottom: 0.5rem !important;\n    }\n\n    .my-lg-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important;\n    }\n\n    .my-lg-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n\n    .my-lg-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .my-lg-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n\n    .mt-lg-0 {\n        margin-top: 0 !important;\n    }\n\n    .mt-lg-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mt-lg-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mt-lg-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mt-lg-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mt-lg-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mt-lg-auto {\n        margin-top: auto !important;\n    }\n\n    .me-lg-0 {\n        margin-right: 0 !important;\n    }\n\n    .me-lg-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .me-lg-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .me-lg-3 {\n        margin-right: 1rem !important;\n    }\n\n    .me-lg-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .me-lg-5 {\n        margin-right: 3rem !important;\n    }\n\n    .me-lg-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-lg-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .mb-lg-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .mb-lg-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .mb-lg-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .mb-lg-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .mb-lg-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .mb-lg-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ms-lg-0 {\n        margin-left: 0 !important;\n    }\n\n    .ms-lg-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .ms-lg-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .ms-lg-3 {\n        margin-left: 1rem !important;\n    }\n\n    .ms-lg-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .ms-lg-5 {\n        margin-left: 3rem !important;\n    }\n\n    .ms-lg-auto {\n        margin-left: auto !important;\n    }\n\n    .p-lg-0 {\n        padding: 0 !important;\n    }\n\n    .p-lg-1 {\n        padding: 0.25rem !important;\n    }\n\n    .p-lg-2 {\n        padding: 0.5rem !important;\n    }\n\n    .p-lg-3 {\n        padding: 1rem !important;\n    }\n\n    .p-lg-4 {\n        padding: 1.5rem !important;\n    }\n\n    .p-lg-5 {\n        padding: 3rem !important;\n    }\n\n    .px-lg-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n    .px-lg-1 {\n        padding-right: 0.25rem !important;\n        padding-left: 0.25rem !important;\n    }\n\n    .px-lg-2 {\n        padding-right: 0.5rem !important;\n        padding-left: 0.5rem !important;\n    }\n\n    .px-lg-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important;\n    }\n\n    .px-lg-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important;\n    }\n\n    .px-lg-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important;\n    }\n\n    .py-lg-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .py-lg-1 {\n        padding-top: 0.25rem !important;\n        padding-bottom: 0.25rem !important;\n    }\n\n    .py-lg-2 {\n        padding-top: 0.5rem !important;\n        padding-bottom: 0.5rem !important;\n    }\n\n    .py-lg-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important;\n    }\n\n    .py-lg-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n\n    .py-lg-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important;\n    }\n\n    .pt-lg-0 {\n        padding-top: 0 !important;\n    }\n\n    .pt-lg-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pt-lg-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pt-lg-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pt-lg-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pt-lg-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pe-lg-0 {\n        padding-right: 0 !important;\n    }\n\n    .pe-lg-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pe-lg-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pe-lg-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pe-lg-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pe-lg-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-lg-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pb-lg-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pb-lg-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pb-lg-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pb-lg-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pb-lg-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .ps-lg-0 {\n        padding-left: 0 !important;\n    }\n\n    .ps-lg-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .ps-lg-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .ps-lg-3 {\n        padding-left: 1rem !important;\n    }\n\n    .ps-lg-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .ps-lg-5 {\n        padding-left: 3rem !important;\n    }\n\n    .gap-lg-0 {\n        gap: 0 !important;\n    }\n\n    .gap-lg-1 {\n        gap: 0.25rem !important;\n    }\n\n    .gap-lg-2 {\n        gap: 0.5rem !important;\n    }\n\n    .gap-lg-3 {\n        gap: 1rem !important;\n    }\n\n    .gap-lg-4 {\n        gap: 1.5rem !important;\n    }\n\n    .gap-lg-5 {\n        gap: 3rem !important;\n    }\n\n    .text-lg-start {\n        text-align: left !important;\n    }\n\n    .text-lg-end {\n        text-align: right !important;\n    }\n\n    .text-lg-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .float-xl-start {\n        float: left !important;\n    }\n\n    .float-xl-end {\n        float: right !important;\n    }\n\n    .float-xl-none {\n        float: none !important;\n    }\n\n    .d-xl-inline {\n        display: inline !important;\n    }\n\n    .d-xl-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-xl-block {\n        display: block !important;\n    }\n\n    .d-xl-grid {\n        display: grid !important;\n    }\n\n    .d-xl-table {\n        display: table !important;\n    }\n\n    .d-xl-table-row {\n        display: table-row !important;\n    }\n\n    .d-xl-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-xl-flex {\n        display: flex !important;\n    }\n\n    .d-xl-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-xl-none {\n        display: none !important;\n    }\n\n    .flex-xl-fill {\n        flex: 1 1 auto !important;\n    }\n\n    .flex-xl-row {\n        flex-direction: row !important;\n    }\n\n    .flex-xl-column {\n        flex-direction: column !important;\n    }\n\n    .flex-xl-row-reverse {\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-xl-column-reverse {\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-xl-grow-0 {\n        flex-grow: 0 !important;\n    }\n\n    .flex-xl-grow-1 {\n        flex-grow: 1 !important;\n    }\n\n    .flex-xl-shrink-0 {\n        flex-shrink: 0 !important;\n    }\n\n    .flex-xl-shrink-1 {\n        flex-shrink: 1 !important;\n    }\n\n    .flex-xl-wrap {\n        flex-wrap: wrap !important;\n    }\n\n    .flex-xl-nowrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-xl-wrap-reverse {\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-xl-start {\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-xl-end {\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-xl-center {\n        justify-content: center !important;\n    }\n\n    .justify-content-xl-between {\n        justify-content: space-between !important;\n    }\n\n    .justify-content-xl-around {\n        justify-content: space-around !important;\n    }\n\n    .justify-content-xl-evenly {\n        justify-content: space-evenly !important;\n    }\n\n    .align-items-xl-start {\n        align-items: flex-start !important;\n    }\n\n    .align-items-xl-end {\n        align-items: flex-end !important;\n    }\n\n    .align-items-xl-center {\n        align-items: center !important;\n    }\n\n    .align-items-xl-baseline {\n        align-items: baseline !important;\n    }\n\n    .align-items-xl-stretch {\n        align-items: stretch !important;\n    }\n\n    .align-content-xl-start {\n        align-content: flex-start !important;\n    }\n\n    .align-content-xl-end {\n        align-content: flex-end !important;\n    }\n\n    .align-content-xl-center {\n        align-content: center !important;\n    }\n\n    .align-content-xl-between {\n        align-content: space-between !important;\n    }\n\n    .align-content-xl-around {\n        align-content: space-around !important;\n    }\n\n    .align-content-xl-stretch {\n        align-content: stretch !important;\n    }\n\n    .align-self-xl-auto {\n        align-self: auto !important;\n    }\n\n    .align-self-xl-start {\n        align-self: flex-start !important;\n    }\n\n    .align-self-xl-end {\n        align-self: flex-end !important;\n    }\n\n    .align-self-xl-center {\n        align-self: center !important;\n    }\n\n    .align-self-xl-baseline {\n        align-self: baseline !important;\n    }\n\n    .align-self-xl-stretch {\n        align-self: stretch !important;\n    }\n\n    .order-xl-first {\n        order: -1 !important;\n    }\n\n    .order-xl-0 {\n        order: 0 !important;\n    }\n\n    .order-xl-1 {\n        order: 1 !important;\n    }\n\n    .order-xl-2 {\n        order: 2 !important;\n    }\n\n    .order-xl-3 {\n        order: 3 !important;\n    }\n\n    .order-xl-4 {\n        order: 4 !important;\n    }\n\n    .order-xl-5 {\n        order: 5 !important;\n    }\n\n    .order-xl-last {\n        order: 6 !important;\n    }\n\n    .m-xl-0 {\n        margin: 0 !important;\n    }\n\n    .m-xl-1 {\n        margin: 0.25rem !important;\n    }\n\n    .m-xl-2 {\n        margin: 0.5rem !important;\n    }\n\n    .m-xl-3 {\n        margin: 1rem !important;\n    }\n\n    .m-xl-4 {\n        margin: 1.5rem !important;\n    }\n\n    .m-xl-5 {\n        margin: 3rem !important;\n    }\n\n    .m-xl-auto {\n        margin: auto !important;\n    }\n\n    .mx-xl-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n\n    .mx-xl-1 {\n        margin-right: 0.25rem !important;\n        margin-left: 0.25rem !important;\n    }\n\n    .mx-xl-2 {\n        margin-right: 0.5rem !important;\n        margin-left: 0.5rem !important;\n    }\n\n    .mx-xl-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important;\n    }\n\n    .mx-xl-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important;\n    }\n\n    .mx-xl-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important;\n    }\n\n    .mx-xl-auto {\n        margin-right: auto !important;\n        margin-left: auto !important;\n    }\n\n    .my-xl-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    .my-xl-1 {\n        margin-top: 0.25rem !important;\n        margin-bottom: 0.25rem !important;\n    }\n\n    .my-xl-2 {\n        margin-top: 0.5rem !important;\n        margin-bottom: 0.5rem !important;\n    }\n\n    .my-xl-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important;\n    }\n\n    .my-xl-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n\n    .my-xl-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .my-xl-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n\n    .mt-xl-0 {\n        margin-top: 0 !important;\n    }\n\n    .mt-xl-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mt-xl-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mt-xl-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mt-xl-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mt-xl-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mt-xl-auto {\n        margin-top: auto !important;\n    }\n\n    .me-xl-0 {\n        margin-right: 0 !important;\n    }\n\n    .me-xl-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .me-xl-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .me-xl-3 {\n        margin-right: 1rem !important;\n    }\n\n    .me-xl-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .me-xl-5 {\n        margin-right: 3rem !important;\n    }\n\n    .me-xl-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-xl-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .mb-xl-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .mb-xl-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .mb-xl-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .mb-xl-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .mb-xl-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .mb-xl-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ms-xl-0 {\n        margin-left: 0 !important;\n    }\n\n    .ms-xl-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .ms-xl-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .ms-xl-3 {\n        margin-left: 1rem !important;\n    }\n\n    .ms-xl-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .ms-xl-5 {\n        margin-left: 3rem !important;\n    }\n\n    .ms-xl-auto {\n        margin-left: auto !important;\n    }\n\n    .p-xl-0 {\n        padding: 0 !important;\n    }\n\n    .p-xl-1 {\n        padding: 0.25rem !important;\n    }\n\n    .p-xl-2 {\n        padding: 0.5rem !important;\n    }\n\n    .p-xl-3 {\n        padding: 1rem !important;\n    }\n\n    .p-xl-4 {\n        padding: 1.5rem !important;\n    }\n\n    .p-xl-5 {\n        padding: 3rem !important;\n    }\n\n    .px-xl-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n    .px-xl-1 {\n        padding-right: 0.25rem !important;\n        padding-left: 0.25rem !important;\n    }\n\n    .px-xl-2 {\n        padding-right: 0.5rem !important;\n        padding-left: 0.5rem !important;\n    }\n\n    .px-xl-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important;\n    }\n\n    .px-xl-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important;\n    }\n\n    .px-xl-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important;\n    }\n\n    .py-xl-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .py-xl-1 {\n        padding-top: 0.25rem !important;\n        padding-bottom: 0.25rem !important;\n    }\n\n    .py-xl-2 {\n        padding-top: 0.5rem !important;\n        padding-bottom: 0.5rem !important;\n    }\n\n    .py-xl-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important;\n    }\n\n    .py-xl-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n\n    .py-xl-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important;\n    }\n\n    .pt-xl-0 {\n        padding-top: 0 !important;\n    }\n\n    .pt-xl-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pt-xl-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pt-xl-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pt-xl-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pt-xl-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pe-xl-0 {\n        padding-right: 0 !important;\n    }\n\n    .pe-xl-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pe-xl-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pe-xl-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pe-xl-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pe-xl-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-xl-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pb-xl-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pb-xl-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pb-xl-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pb-xl-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pb-xl-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .ps-xl-0 {\n        padding-left: 0 !important;\n    }\n\n    .ps-xl-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .ps-xl-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .ps-xl-3 {\n        padding-left: 1rem !important;\n    }\n\n    .ps-xl-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .ps-xl-5 {\n        padding-left: 3rem !important;\n    }\n\n    .gap-xl-0 {\n        gap: 0 !important;\n    }\n\n    .gap-xl-1 {\n        gap: 0.25rem !important;\n    }\n\n    .gap-xl-2 {\n        gap: 0.5rem !important;\n    }\n\n    .gap-xl-3 {\n        gap: 1rem !important;\n    }\n\n    .gap-xl-4 {\n        gap: 1.5rem !important;\n    }\n\n    .gap-xl-5 {\n        gap: 3rem !important;\n    }\n\n    .text-xl-start {\n        text-align: left !important;\n    }\n\n    .text-xl-end {\n        text-align: right !important;\n    }\n\n    .text-xl-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 1400px) {\n    .float-xxl-start {\n        float: left !important;\n    }\n\n    .float-xxl-end {\n        float: right !important;\n    }\n\n    .float-xxl-none {\n        float: none !important;\n    }\n\n    .d-xxl-inline {\n        display: inline !important;\n    }\n\n    .d-xxl-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-xxl-block {\n        display: block !important;\n    }\n\n    .d-xxl-grid {\n        display: grid !important;\n    }\n\n    .d-xxl-table {\n        display: table !important;\n    }\n\n    .d-xxl-table-row {\n        display: table-row !important;\n    }\n\n    .d-xxl-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-xxl-flex {\n        display: flex !important;\n    }\n\n    .d-xxl-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-xxl-none {\n        display: none !important;\n    }\n\n    .flex-xxl-fill {\n        flex: 1 1 auto !important;\n    }\n\n    .flex-xxl-row {\n        flex-direction: row !important;\n    }\n\n    .flex-xxl-column {\n        flex-direction: column !important;\n    }\n\n    .flex-xxl-row-reverse {\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-xxl-column-reverse {\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-xxl-grow-0 {\n        flex-grow: 0 !important;\n    }\n\n    .flex-xxl-grow-1 {\n        flex-grow: 1 !important;\n    }\n\n    .flex-xxl-shrink-0 {\n        flex-shrink: 0 !important;\n    }\n\n    .flex-xxl-shrink-1 {\n        flex-shrink: 1 !important;\n    }\n\n    .flex-xxl-wrap {\n        flex-wrap: wrap !important;\n    }\n\n    .flex-xxl-nowrap {\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-xxl-wrap-reverse {\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-xxl-start {\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-xxl-end {\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-xxl-center {\n        justify-content: center !important;\n    }\n\n    .justify-content-xxl-between {\n        justify-content: space-between !important;\n    }\n\n    .justify-content-xxl-around {\n        justify-content: space-around !important;\n    }\n\n    .justify-content-xxl-evenly {\n        justify-content: space-evenly !important;\n    }\n\n    .align-items-xxl-start {\n        align-items: flex-start !important;\n    }\n\n    .align-items-xxl-end {\n        align-items: flex-end !important;\n    }\n\n    .align-items-xxl-center {\n        align-items: center !important;\n    }\n\n    .align-items-xxl-baseline {\n        align-items: baseline !important;\n    }\n\n    .align-items-xxl-stretch {\n        align-items: stretch !important;\n    }\n\n    .align-content-xxl-start {\n        align-content: flex-start !important;\n    }\n\n    .align-content-xxl-end {\n        align-content: flex-end !important;\n    }\n\n    .align-content-xxl-center {\n        align-content: center !important;\n    }\n\n    .align-content-xxl-between {\n        align-content: space-between !important;\n    }\n\n    .align-content-xxl-around {\n        align-content: space-around !important;\n    }\n\n    .align-content-xxl-stretch {\n        align-content: stretch !important;\n    }\n\n    .align-self-xxl-auto {\n        align-self: auto !important;\n    }\n\n    .align-self-xxl-start {\n        align-self: flex-start !important;\n    }\n\n    .align-self-xxl-end {\n        align-self: flex-end !important;\n    }\n\n    .align-self-xxl-center {\n        align-self: center !important;\n    }\n\n    .align-self-xxl-baseline {\n        align-self: baseline !important;\n    }\n\n    .align-self-xxl-stretch {\n        align-self: stretch !important;\n    }\n\n    .order-xxl-first {\n        order: -1 !important;\n    }\n\n    .order-xxl-0 {\n        order: 0 !important;\n    }\n\n    .order-xxl-1 {\n        order: 1 !important;\n    }\n\n    .order-xxl-2 {\n        order: 2 !important;\n    }\n\n    .order-xxl-3 {\n        order: 3 !important;\n    }\n\n    .order-xxl-4 {\n        order: 4 !important;\n    }\n\n    .order-xxl-5 {\n        order: 5 !important;\n    }\n\n    .order-xxl-last {\n        order: 6 !important;\n    }\n\n    .m-xxl-0 {\n        margin: 0 !important;\n    }\n\n    .m-xxl-1 {\n        margin: 0.25rem !important;\n    }\n\n    .m-xxl-2 {\n        margin: 0.5rem !important;\n    }\n\n    .m-xxl-3 {\n        margin: 1rem !important;\n    }\n\n    .m-xxl-4 {\n        margin: 1.5rem !important;\n    }\n\n    .m-xxl-5 {\n        margin: 3rem !important;\n    }\n\n    .m-xxl-auto {\n        margin: auto !important;\n    }\n\n    .mx-xxl-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important;\n    }\n\n    .mx-xxl-1 {\n        margin-right: 0.25rem !important;\n        margin-left: 0.25rem !important;\n    }\n\n    .mx-xxl-2 {\n        margin-right: 0.5rem !important;\n        margin-left: 0.5rem !important;\n    }\n\n    .mx-xxl-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important;\n    }\n\n    .mx-xxl-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important;\n    }\n\n    .mx-xxl-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important;\n    }\n\n    .mx-xxl-auto {\n        margin-right: auto !important;\n        margin-left: auto !important;\n    }\n\n    .my-xxl-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n\n    .my-xxl-1 {\n        margin-top: 0.25rem !important;\n        margin-bottom: 0.25rem !important;\n    }\n\n    .my-xxl-2 {\n        margin-top: 0.5rem !important;\n        margin-bottom: 0.5rem !important;\n    }\n\n    .my-xxl-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important;\n    }\n\n    .my-xxl-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important;\n    }\n\n    .my-xxl-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important;\n    }\n\n    .my-xxl-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important;\n    }\n\n    .mt-xxl-0 {\n        margin-top: 0 !important;\n    }\n\n    .mt-xxl-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mt-xxl-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mt-xxl-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mt-xxl-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mt-xxl-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mt-xxl-auto {\n        margin-top: auto !important;\n    }\n\n    .me-xxl-0 {\n        margin-right: 0 !important;\n    }\n\n    .me-xxl-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .me-xxl-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .me-xxl-3 {\n        margin-right: 1rem !important;\n    }\n\n    .me-xxl-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .me-xxl-5 {\n        margin-right: 3rem !important;\n    }\n\n    .me-xxl-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-xxl-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .mb-xxl-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .mb-xxl-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .mb-xxl-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .mb-xxl-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .mb-xxl-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .mb-xxl-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ms-xxl-0 {\n        margin-left: 0 !important;\n    }\n\n    .ms-xxl-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .ms-xxl-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .ms-xxl-3 {\n        margin-left: 1rem !important;\n    }\n\n    .ms-xxl-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .ms-xxl-5 {\n        margin-left: 3rem !important;\n    }\n\n    .ms-xxl-auto {\n        margin-left: auto !important;\n    }\n\n    .p-xxl-0 {\n        padding: 0 !important;\n    }\n\n    .p-xxl-1 {\n        padding: 0.25rem !important;\n    }\n\n    .p-xxl-2 {\n        padding: 0.5rem !important;\n    }\n\n    .p-xxl-3 {\n        padding: 1rem !important;\n    }\n\n    .p-xxl-4 {\n        padding: 1.5rem !important;\n    }\n\n    .p-xxl-5 {\n        padding: 3rem !important;\n    }\n\n    .px-xxl-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important;\n    }\n\n    .px-xxl-1 {\n        padding-right: 0.25rem !important;\n        padding-left: 0.25rem !important;\n    }\n\n    .px-xxl-2 {\n        padding-right: 0.5rem !important;\n        padding-left: 0.5rem !important;\n    }\n\n    .px-xxl-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important;\n    }\n\n    .px-xxl-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important;\n    }\n\n    .px-xxl-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important;\n    }\n\n    .py-xxl-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .py-xxl-1 {\n        padding-top: 0.25rem !important;\n        padding-bottom: 0.25rem !important;\n    }\n\n    .py-xxl-2 {\n        padding-top: 0.5rem !important;\n        padding-bottom: 0.5rem !important;\n    }\n\n    .py-xxl-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important;\n    }\n\n    .py-xxl-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important;\n    }\n\n    .py-xxl-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important;\n    }\n\n    .pt-xxl-0 {\n        padding-top: 0 !important;\n    }\n\n    .pt-xxl-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pt-xxl-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pt-xxl-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pt-xxl-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pt-xxl-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pe-xxl-0 {\n        padding-right: 0 !important;\n    }\n\n    .pe-xxl-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pe-xxl-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pe-xxl-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pe-xxl-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pe-xxl-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-xxl-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pb-xxl-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pb-xxl-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pb-xxl-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pb-xxl-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pb-xxl-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .ps-xxl-0 {\n        padding-left: 0 !important;\n    }\n\n    .ps-xxl-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .ps-xxl-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .ps-xxl-3 {\n        padding-left: 1rem !important;\n    }\n\n    .ps-xxl-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .ps-xxl-5 {\n        padding-left: 3rem !important;\n    }\n\n    .gap-xxl-0 {\n        gap: 0 !important;\n    }\n\n    .gap-xxl-1 {\n        gap: 0.25rem !important;\n    }\n\n    .gap-xxl-2 {\n        gap: 0.5rem !important;\n    }\n\n    .gap-xxl-3 {\n        gap: 1rem !important;\n    }\n\n    .gap-xxl-4 {\n        gap: 1.5rem !important;\n    }\n\n    .gap-xxl-5 {\n        gap: 3rem !important;\n    }\n\n    .text-xxl-start {\n        text-align: left !important;\n    }\n\n    .text-xxl-end {\n        text-align: right !important;\n    }\n\n    .text-xxl-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .fs-1 {\n        font-size: 2.5rem !important;\n    }\n\n    .fs-2 {\n        font-size: 2rem !important;\n    }\n\n    .fs-3 {\n        font-size: 1.75rem !important;\n    }\n\n    .fs-4 {\n        font-size: 1.5rem !important;\n    }\n}\n\n@media print {\n    .d-print-inline {\n        display: inline !important;\n    }\n\n    .d-print-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-print-block {\n        display: block !important;\n    }\n\n    .d-print-grid {\n        display: grid !important;\n    }\n\n    .d-print-table {\n        display: table !important;\n    }\n\n    .d-print-table-row {\n        display: table-row !important;\n    }\n\n    .d-print-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-print-flex {\n        display: flex !important;\n    }\n\n    .d-print-inline-flex {\n        display: inline-flex !important;\n    }\n\n    .d-print-none {\n        display: none !important;\n    }\n}\n\nhtml {\n    height: 100%;\n    scroll-padding-top: calc(4.5rem - 1px);\n}\n\n.page-section {\n    padding: 6rem 0;\n}\n\n.page-section .page-section-heading {\n    font-size: 2.25rem;\n    line-height: 2rem;\n}\n\n@media (min-width: 992px) {\n    .page-section .page-section-heading {\n        font-size: 3rem;\n        line-height: 2.5rem;\n    }\n}\n\n.divider-custom {\n    margin: 1.25rem 0 1.5rem;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.divider-custom .divider-custom-line {\n    width: 100%;\n    max-width: 7rem;\n    height: 0.25rem;\n    background-color: #2c3e50;\n    border-radius: 1rem;\n    border-color: #2c3e50;\n}\n\n.divider-custom .divider-custom-line:first-child {\n    margin-right: 1rem;\n}\n\n.divider-custom .divider-custom-line:last-child {\n    margin-left: 1rem;\n}\n\n.divider-custom .divider-custom-icon {\n    color: #2c3e50;\n    font-size: 2rem;\n}\n\n.divider-custom.divider-light .divider-custom-line {\n    background-color: #fff;\n}\n\n.divider-custom.divider-light .divider-custom-icon {\n    color: #fff;\n}\n\n.btn-xl {\n    padding: 1rem 1.75rem;\n    font-size: 1.25rem;\n}\n\n.btn-social {\n    border-radius: 100%;\n    display: inline-flex;\n    width: 3.25rem;\n    height: 3.25rem;\n    font-size: 1.25rem;\n    justify-content: center;\n    align-items: center;\n}\n\n#mainNav {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-weight: 700;\n}\n\n#mainNav .navbar-brand {\n    color: #fff;\n}\n\n#mainNav .navbar-nav {\n    margin-top: 1rem;\n}\n\n#mainNav .navbar-nav li.nav-item a.nav-link {\n    color: #fff;\n}\n\n#mainNav .navbar-nav li.nav-item a.nav-link:hover {\n    color: #0085CA;\n}\n\n#mainNav .navbar-nav li.nav-item a.nav-link:active,\n#mainNav .navbar-nav li.nav-item a.nav-link:focus {\n    color: #fff;\n}\n\n#mainNav .navbar-nav li.nav-item a.nav-link.active {\n    color: #0085CA;\n}\n\n#mainNav .navbar-toggler {\n    font-size: 80%;\n    padding: 0.8rem;\n}\n\n@media (min-width: 992px) {\n    #mainNav {\n        padding-top: 1.5rem;\n        padding-bottom: 1.5rem;\n        transition: padding-top 0.3s, padding-bottom 0.3s;\n    }\n\n    #mainNav .navbar-brand {\n        font-size: 1.75em;\n        transition: font-size 0.3s;\n    }\n\n    #mainNav .navbar-nav {\n        margin-top: 0;\n    }\n\n    #mainNav .navbar-nav>li.nav-item>a.nav-link.active {\n        color: #fff;\n        background: #0085CA;\n    }\n\n    #mainNav .navbar-nav>li.nav-item>a.nav-link.active:active,\n    #mainNav .navbar-nav>li.nav-item>a.nav-link.active:focus,\n    #mainNav .navbar-nav>li.nav-item>a.nav-link.active:hover {\n        color: #fff;\n        background: #0085CA;\n    }\n\n    #mainNav.navbar-shrink {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n    }\n\n    #mainNav.navbar-shrink .navbar-brand {\n        font-size: 1.5em;\n    }\n}\n\n.form-floating input.form-control,\n.form-floating textarea.form-control {\n    font-size: 1.5rem;\n    border-left: 0;\n    border-right: 0;\n    border-top: 0;\n    border-radius: 0;\n    border-width: 1px;\n}\n\n.form-floating input.form-control:focus,\n.form-floating textarea.form-control:focus {\n    box-shadow: none;\n}\n\n.form-floating label {\n    font-size: 1.5rem;\n    color: #6c757d;\n}\n\n.masthead {\n    padding-top: calc(6rem + 74px);\n    padding-bottom: 6rem;\n}\n\n.masthead .masthead-heading {\n    font-size: 2.75rem;\n    line-height: 2.75rem;\n}\n\n.masthead .masthead-subheading {\n    font-size: 1.25rem;\n}\n\n.masthead .masthead-avatar {\n    width: 15rem;\n}\n\n@media (min-width: 992px) {\n    .masthead {\n        padding-top: calc(6rem + 104px);\n        padding-bottom: 6rem;\n    }\n\n    .masthead .masthead-heading {\n        font-size: 4rem;\n        line-height: 3.5rem;\n    }\n\n    .masthead .masthead-subheading {\n        font-size: 1.5rem;\n    }\n}\n\n.portfolio .portfolio-item {\n    cursor: pointer;\n    position: relative;\n    display: block;\n    max-width: 25rem;\n    border-radius: 0.5rem;\n    overflow: hidden;\n}\n\n.portfolio .portfolio-item .portfolio-item-caption {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transition: all 0.2s ease-in-out;\n    opacity: 0;\n    background-color: rgba(26, 188, 156, 0.9);\n}\n\n.portfolio .portfolio-item .portfolio-item-caption:hover {\n    opacity: 1;\n}\n\n.portfolio .portfolio-item .portfolio-item-caption .portfolio-item-caption-content {\n    font-size: 1.5rem;\n}\n\n.portfolio-modal .btn-close {\n    color: #0085CA;\n    font-size: 2rem;\n    padding: 1rem;\n}\n\n.portfolio-modal .portfolio-modal-title {\n    font-size: 2.25rem;\n    line-height: 2rem;\n}\n\n@media (min-width: 992px) {\n    .portfolio-modal .portfolio-modal-title {\n        font-size: 3rem;\n        line-height: 2.5rem;\n    }\n}\n\n.footer {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n    background-image: url('../img/BANNER.jpg');\n    ;\n    color: #fff;\n}\n\n.copyright {\n    background-image: url('../img/BANNER.jpg');\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
